export enum AccountActivityTypeCode {
    Business = "Business",
    Main = "Main",
}

export enum AccountCategoryCode {
    BalanceSheet = "BS",
    IncomeStatement = "IS",
    FinancialStatement = "FS",
    Internal = "IN",
    Extension = "EX",
}

export enum AccountRoleCode {
    AccountsPayable = "AP",
    AccountsReceivable = "AR",
    Bank = "BANK",
    Cash = "CASH",
    ValueAddedTax = "VAT",
    ValueAddedTaxBalance = "VATBALANCE",
    Asset = "ASSET",
    Other = "OTHER",
    Payroll = "PAYROLL",
}

export enum AccountTypeCode {
    Assets = "A",
    Liabilities = "L",
    Income = "I",
    Expense = "E",
    None = "N",
    Opening = "O",
    Closing = "C",
    Balancing = "B",
}

export enum AccountingCode {
    AccountingForBusiness = "CzAccBiz",
    CashBasisAccounting = "CzCashBas",
    AccountingForNonprofitOrganizations = "CzNpoAcc",
}

export enum AccruedProcessingTypeCode {
    AccruedExpense = "AccruedExpense",
    AccruedRevenue = "AccruedRevenue",
    EstimatedAccruedExpense = "EstimatedAccruedExpense",
    EstimatedAccruedRevenue = "EstimatedAccruedRevenue",
}

export enum ActionTypeCode {
    ExcelExport = "XLS",
    CsvExport = "CSV",
    PDFExport = "PDF",
    XMLExport = "XML",
}

export enum AddressTypeCode {
    BusinessPartnerBilling = "BusinessPartnerBill",
    BusinessPartnerCorrespondence = "BusinessPartnerCorr",
    CompanyLegal = "CompanyLegal",
    CompanyCommunication = "CompanyCommunication",
    EmployeePermanent = "EmployeePermanent",
    EmployeeCzech = "EmployeeCzech",
    EmployeeTaxResidence = "EmployeeTaxResidence",
    EmployeeContact = "EmployeeContact",
    OtherProvider = "OtherProvider",
    OtherProviderEmployer = "OtherProviderEmplr",
    AbsenceDetailDoctor = "AbsenceDetailDoctor",
    AbsenceDetailResidence = "AbsenceDetailResid",
    EntityEmployeePermanent = "EntityEmployeePermanent",
    EntityEmployeeCzech = "EntityEmployeeCzech",
    EntityEmployeeTaxResidence = "EntityEmployeeTaxResidence",
    EntityEmployeeContact = "EntityEmployeeContact",
    EmploymentWorkplaceAddress = "EmploymentWorkplaceAddress",
    MortgageOtherPeople = "MortgageOtherPeople",
    MortgageLocation = "MortgageLocation",
    ForeignInsuranceCarrier = "ForeignInsuranceCarrier",
    RegZecForeignInsuranceCarrier = "RegZecForInsCar",
}

export enum ApprovalStatusTypeCode {
    Approved = "Approved",
    NotNeeded = "NotNeeded",
    Pending = "Pending",
    Rejected = "Rejected",
    Canceled = "Canceled",
}

export enum AssetDisposalTypeCode {
    Damaged = "DAMAGE",
    Disposed = "DISPOSAL",
    TransferredFreeOfCharge = "GIFT",
    Sold = "SALE",
    TransferredToPersonalUse = "TRANSFER",
}

export enum AssetItemTypeCode {
    Acquisition = "ACQ",
    Disposal = "DIS",
    PutInUse = "USE",
    TechnicalImprovement = "IMP",
    IncreaseOfPrice = "INC",
    ReductionOfPrice = "RED",
    AccountingDepreciation = "MAD",
    TaxDepreciation = "TAX",
    DepreciationOfTheResidualValue = "DRV",
    ImportOfOldAsset = "OLD",
    GrantAllocatedToAsset = "GAA",
    ReductionOfTaxPriceWithAccounting = "RET",
    ReductionOfTaxPrice = "RTP",
}

export enum AssetStatusCode {
    Created = "CRE",
    InUse = "USE",
    Disposed = "DIS",
}

export enum AssetTypeCode {
    Intangible = "Intan",
    Tangible = "Tan",
}

export enum AssetValueCode {
    MinimalFixedAssetValue = "CZ_AV0",
    MinimalFixedAssetValueFrom2021 = "CZ_AV21",
}

export enum BackgroundJobStatusCode {
    NotStarted = "NotStarted",
    Running = "Running",
    PendingUserInput = "PendingUserInput",
    Finished = "Finished",
    Error = "Error",
    Canceled = "Canceled",
    Cancelling = "Cancelling",
    Finishing = "Finishing",
    Expired = "Expired",
    FinishedWithErrors = "FinishedWithWarning",
}

export enum BackgroundJobTypeCode {
    BankStatementImport = "BankImport",
    PostingRulesApplication = "PostingRules",
    FileStorageCleanup = "AzureStorageCleanup",
    VerificationCleanup = "VerificationCleanup",
    SentDataBoxMessagesStatusUpdate = "UpdateSentDBM",
    ReceivingNewDataBoxMessages = "ReceiveDBM",
    UpdateDataBoxCredentials = "UpdateDBCredentials",
    CreateGoPayPaymentArchived = "GoPayPaymentCreate",
    GoPayPaymentStatusArchived = "GoPayPaymentStatus",
    DeferredDocumentPlanProcessing = "DeferredPlanProc",
    DepreciationPoliciesUpdate = "DepreciationUpdate",
    GetS5InvoicePDFArchived = "GetS5InvoicePdf",
    RecurringTaskExecution = "RecurringTaskProc",
    LoadExchangeRates = "LoadExchangeRates",
    UserSettingsSynchronization = "SyncUserSettings",
    BankTransactionsAPIImport = "BankApiImport",
    BusinessPartnerUpdate = "BusinessPartnerUpdt",
    SessionCleanup = "SessionCleanup",
    InboxNotification = "InboxNotification",
    NotificationCleanup = "NotificationCleanup",
    CompanyDelete = "CompanyDelete",
    RetryDeleteCompaniesAtNight = "RetryCompanyDelete",
    CleanupLoginLogs = "CleanupLoginLogs",
    TenantDelete = "TenantDelete",
    DataImportCleanupArchived = "DataImportCleanup",
    DocumentForApprovalNotificationArchived = "ApprovalNotification",
    ConfirmationOfBankTransactions = "BankTransactionsConfirmer",
    MultiplePostOfBankTransactions = "BankTransactionsPostMultiple",
    MultipleMatchOfBankTransactions = "BankTransactionsMatchMultiple",
    RossumDataMining = "RossumDataMining",
    RossumDataMiningSystem = "RossumDataMiningSystem",
    CleanupFailedLoginAttempts = "LoginFailedAttemptsCleanup",
    CleanupInactiveUsers = "CleanupInactiveUsers",
    CleanupTenantSelectionLogs = "CleanupTenantSelectionLogs",
    IsdocImport = "IsdocImport",
    MoneyS3Import = "MoneyS3Import",
    PohodaImport = "PohodaImport",
    CalculateTenantScore = "CalculateTenantScore",
    SynchronizeToDaktela = "SynchronizeToDaktela",
    SynchronizeToCrmScheduled = "SynchronizeToCrmScheduled",
    SynchronizeToCrm = "SynchronizeToCrm",
    SetFixedExchangeRates = "FixedExchangeRateSetting",
    TemporalSalesReport = "TemporalSalesReportJob",
    CreatingDemoCompany = "CreateDemoTenantJob",
    PostMultipleDrafts = "DraftsPostMultiple",
    BillingProcessing = "BillingProcessing",
    ImportsDocumentsFromInvoiceServices = "InvoiceServiceIntegrationJob",
    ImportsDocumentsFromInvoiceService = "InvoiceServiceIntegrationBkg",
    FetchAbsenceIllnessDetails = "PrDZDPNSubmission",
    ProcessCSSZTransaction = "PrCSSZTransactionProcessing",
    ScheduleCSSZTransactionsProcessing = "PrCSSZTransactionsScheduling",
    ClosePayrollPeriod = "PrPayrollPeriodClosing",
    TurnoverCheckForVAT = "VatPayerRegistrationCheckJob",
    ProcessSocialEvents = "PrSocialEventProcessing",
    BulkChangeOfDocuments = "DocumentsBulkChangeJob",
    BulkChangeOfDrafts = "DraftsBulkChangeJob",
    GrantSettlementDeadlineNotification = "GrantDeadlineNotificationJob",
    GeneratePayrollSheets = "GeneratePayrollSheetsJob",
    DeleteDocumentArchived = "DeleteDocumentJob",
    FixGrantsCalculationInDocumentsArchived = "Rel2026_05_FixGrantDivisionJob",
}

export enum BankAccountNumberFormatTypeCode {
    Inner = "I",
    Edit = "E",
}

export enum BankAccountRegistrationStatusCode {
    Registered = "Registered",
    Unregistered = "Unregistered",
}

export enum BankAccountTypeCode {
    BusinessPartner = "BusinessPartner",
    CompanyBankAccount = "Company",
    RetirementSavings = "RetirementSavings",
    LoanBankAccount = "Loan",
}

export enum BankApiStatementImportFrequencyCode {
    Daily = "D",
    LastDayOfTheMonth = "M",
    LastDayOfTheWeek = "W",
}

export enum BankApiStatementImportRangeCode {
    FiscalYear = "FiscalYear",
    Custom = "Custom",
}

export enum BankCode {
    KomerčníBanka_A_s_ = "0100",
    ČeskoslovenskáObchodníBanka_A_S_ = "0300",
    MONETAMoneyBank_A_s_ = "0600",
    ČESKÁNÁRODNÍBANKA = "0710",
    ČeskáSpořitelna_A_s_ = "0800",
    FioBanka_A_s_ = "2010",
    MUFGBankEuropeN_V_PragueBranch = "2020",
    Citfin_SpořitelníDružstvo = "2060",
    TRINITYBANKA_s_ = "2070",
    HypotečníBanka_A_s_ = "2100",
    PeněžníDům_SpořitelníDružstvo = "2200",
    Artesa_SpořitelníDružstvo = "2220",
    BankaCREDITASA_s_ = "2250",
    NEYSpořitelníDružstvo = "2260",
    PodnikatelskáDružstevníZáložna = "2275",
    CitibankEuropePlc_OrganizačníSložka = "2600",
    UniCreditBankCzechRepublicAndSlovakia_A_s_ = "2700",
    AirBankA_s_ = "3030",
    BNPParibasPersonalFinanceSA_OdštěpnýZávod = "3050",
    PKOBPS_A__CzechBranch = "3060",
    INGBankN_V_ = "3500",
    ExpobankCZA_s_ = "4000",
    NárodníRozvojováBanka_A_s_ = "4300",
    RaiffeisenbankA_s_ = "5500",
    J_AND_TBANKA_A_s_ = "5800",
    PPFBankaA_s_ = "6000",
    RaiffeisenbankA_s_Do31_12_2021EquaBankA_s_ = "6100",
    COMMERZBANKAktiengesellschaft_PobočkaPraha = "6200",
    MBankS_A__OrganizačníSložka = "6210",
    BNPParibasS_A__PobočkaČeskáRepublika = "6300",
    PartnersBanka_A_s_ = "6363",
    VšeobecnáÚverováBankaA_s__PobočkaPraha = "6700",
    SberbankCZ_A_s_ = "6800",
    DeutscheBankAktiengesellschaftFilialePrag_OrganizačníSložka = "7910",
    RaiffeisenStavebníSpořitelnaA_s_ = "7950",
    ČSOBStavebníSpořitelna_A_s_ = "7960",
    MONETAStavebníSpořitelna_A_s_ = "7970",
    ModráPyramidaStavebníSpořitelna_A_s_ = "7990",
    VolksbankRaiffeisenbankNordoberpfalzEGPobočkaCheb = "8030",
    OberbankAGPobočkaČeskáRepublika = "8040",
    StavebníSpořitelnaČeskéSpořitelny_A_s_ = "8060",
    ČeskáExportníBanka_A_s_ = "8090",
    HSBCContinentalEurope_CzechRepublic = "8150",
    SparkasseOberlausitzNiederschlesien = "8190",
    FASFinanceCompanyS_r_o_ = "8198",
    MoneyPoloEuropeS_r_o_ = "8199",
    PRIVATBANKDerRaiffeisenlandesbankOberösterreichAktiengesellschaft_PobočkaČeskáRepublika = "8200",
    PaymentExecutionS_r_o_ = "8220",
    ABAPAYS_r_o_ = "8230",
    DružstevníZáložnaKredit = "8240",
    BankOfChinaCEELtd_PragueBranch = "8250",
    BankOfCommunicationsCo__Ltd__PragueBranchOdštěpnýZávod = "8255",
    IndustrialAndCommercialBankOfChinaLimited_PragueBranch_OdštěpnýZávod = "8265",
    FairplayPayS_r_o_ = "8270",
    VIVAPAYMENTSERVICESS_A_OdštěpnýZávod = "8272",
    BEfektA_s_ = "8280",
    MercuriusPartnersS_r_o_ = "8293",
    BESTPAYS_r_o_ = "8299",
    FerratumBankPlc = "8500",
}

export enum BankExchangeRateFreshnessCode {
    Current = "Current",
    PreviousDay = "PrevDay",
}

export enum BankPaymentOrderStateCode {
    Exported = "Exported",
    Sent = "Sent",
    CustomerPortal = "CustomerPortal",
}

export enum BankStatementTypeCode {
    Bank = "Bank",
    Loan = "Loan",
}

export enum BankTransactionDocumentNumberLocationCode {
    RemittanceInformation = "RI",
    SpecificSymbol = "SS",
    VariableSymbol = "VS",
    PaymentInformation = "PI",
}

export enum BankTransactionTypeCode {
    IncomingPayment = "In",
    OutgoingPayment = "Out",
}

export enum BillingItemTypeCode {
    Company = "Company",
    Module = "Module",
    User = "User",
    AcceptableUserPolicy = "AUP",
    ArchivedCompany = "ArchivComp",
    Discount = "Discount",
}

export enum BillingModuleTypeCode {
    Archived = "Archived",
    CashBased = "CashBased",
    DoubleEntry = "DoubleEntry",
    NonprofitOrganization = "NonProfit",
    ExtraDocument = "ExtraDocument",
    IndividualCashBased = "IndividualCashBased",
    IndividualDoubleEntry = "IndividualDoubleEntry",
    IndividualNonprofit = "IndividualNonProfit",
    Rossum = "Rossum",
    Storage = "Storage",
    Payroll = "Payroll",
    PayrollOverLimit = "PayrollExtraPayslips",
    PayrollDiscount = "PayrollDiscount",
    TrialDiscount = "TrialDiscount",
    RossumFreeDocuments = "RossumDiscount",
    Discount = "Discount",
}

export enum BillingPricingCode {
    CZArchived = "CzArchived",
    CZCashBased = "CzCashBased",
    CZDoubleEntry = "CzDoubleEntry",
    CZNonprofit = "CzNonProfit",
    CZExtraDocument2024_5 = "CzExtraDocument2024A",
    CZExtraDocument2024_6 = "CzExtraDocument2024B",
    CZIndividualCashBased = "CzIndividualCashBased",
    CZIndividualDoubleEntry = "CzIndividualDoubleEntry",
    CZIndividualNonprofit = "CzIndividualNonProfit",
    CZRossum = "CzRossum",
    CZStorage = "CzStorage",
    CZPayroll = "CzPayroll",
    CZPayrollForIndividuals = "CzPayrollComp",
    CZPayrollPayslipsOverLimit = "CzPayrollExtraPayslips",
}

export enum BookkeepingCode {
    DoubleentryBookkeeping = "DE",
    SingleentryBookkeeping = "SE",
}

export enum BusinessPartnerDocumentDefaultTypeCode {
    Issued = "Issued",
    Received = "Received",
}

export enum CSSZBankTypeCode {
    AustrianBankleitzahl = "AT",
    AustralianBankStateBranchBSBCode = "AU",
    MezinárodníKód = "BIC",
    ProStátRusko = "BIK",
    GermanBankleitzahlBLZ = "BL",
    CanadianPaymentsAssociationPaymentRoutingNumber = "CC",
    SpanishDomesticInterbankingCode = "ES",
    FedwireOrABABankCodeRoutingNumber = "FW",
    HEBICHellenicBankIndentificationCode = "GR",
    IrishNationalClearingCodeNSC = "IE",
    ItalianDomesticIdentificationCode = "IT",
    PortugueseNationalClearingCode = "PT",
    UKSortingCode = "SC",
    SwissClearingCode = "SW",
    SouthAfricanNationalClearingCode = "ZA",
}

export enum CSSZSubmissionTypeCode {
    EmployeeDataOnTemporaryIncapacityForWork = "Dzdpn",
    PensionInsuranceRecord = "Eldp",
    EmployeeRegistration = "RegZec",
    MonthlyReport = "Jmhz",
}

export enum CSSZTransactionStatusCode {
    DisposeAcknowledged = "DisposeAcknowledged",
    DisposeFailed = "DisposeFailed",
    DisposeResponded = "DisposeResponded",
    PollAcknowledged = "PollAcknowledged",
    PollFailed = "PollFailed",
    PollResponded = "PollResponded",
    SubmitAcknowledged = "SubmitAcknowledged",
    SubmitFailed = "SubmitFailed",
}

export enum CbaAssetDisposalTypeCode {
    AssetDamageNaturalDisaster_UnknownPerpetrator = "Damage",
    GiftOrTransferToPersonalUse = "GiftTransfer",
    OtherDamage = "OtherDamage",
    PhysicalDisposal = "PhysicalDisposal",
    Sale = "Sale",
}

export enum CbaCategoryTaxImpactCode {
    Nontax = "NonTax",
    Partial = "Partial",
    Tax = "Tax",
    VATCorrection = "VatCorr",
}

export enum CbaEntryLedgerDocumentTypeCode {
    Bank = "Bank",
    CashBox = "CashBox",
    InternalDocument = "InternalDocument",
    ProformaInvoice = "ProformaDocument",
}

export enum CbaEntrySpecialVatCalculationCode {
    AssetInAutomatedVATInclusionMode = "AAvi",
    AssetInReverseCharge = "ARCh",
    ReverseCharge = "RCh",
}

export enum CbaEntryTypeCode {
    Expense = "Expense",
    Income = "Income",
}

export enum ChatParticipantTypeCode {
    ChatParticipantRecipient = "ChatParticipantRecipient",
    ChatParticipantSender = "ChatParticipantSender",
}

export enum ClearedStatusCode {
    Cleared = "C",
    PartiallyCleared = "P",
    NotCleared = "N",
    N_A = "_",
}

export enum ColourThemeCode {
    Light = "Light",
    Dark = "Dark",
}

export enum CommunicationEntryChannelCode {
    Email = "EMAIL",
    DataMessage = "DATABOX",
    BankAPI = "BANKAPI",
}

export enum CommunicationEntryStateCode {
    Sent = "SENT",
    Delivered = "DELIVERED",
    Received = "RECEIVED",
    Undeliverable = "UNDELIVERABLE",
    Deleted = "DELETED",
}

export enum CommunicationEntryTypeCode {
    Received = "IN",
    Sent = "OUT",
}

export enum CompanyBankAccountTypeCode {
    Bank = "BANK",
    PaymentService = "SERVICE",
}

export enum CompanyPermissionCode {
    Asset = "Asset",
    Audit = "Audit",
    Bank = "Bank",
    CanImport = "CanImport",
    CashBox = "CashBox",
    CustomerPortal = "CustomerPortal",
    DataBox = "DataBox",
    DocumentPosting = "DocumentPosting",
    FiscalYearClose = "FiscalYearClose",
    InBox = "InBox",
    InternalDocuments = "InternalDocuments",
    InvoicesIssued = "InvoicesIssued",
    InvoicesReceived = "InvoicesReceived",
    ChatTakeover = "ChatTakeover",
    MasterData = "MasterData",
    PrPayroll = "PrPayroll",
    PrPayrollSetting = "PrPayrollSetting",
    ReceivableAdjustments = "ReceivableAdjustments",
    RecurringTask = "RecurringTask",
    Reports = "Reports",
    VatStatement = "VatStatement",
    PrAttendance = "PrAttendance",
    AccountingReports = "AccountingReports",
    PrPayrollAgenda = "PrPayrollAgenda",
    DocumentApproval = "DocumentApproval",
    ChatInteractWithAccountant = "ChatInteractWithAccountant",
    PrPayrollInfo = "PrPayrollInfo",
    PrPayrollInfoConfidential = "PrPayrollInfoConfidential",
    Payments = "Payments",
    CompanyInfo = "CompanyInfo",
}

export enum CompanyRoleTypeCode {
    UserRole = "User",
    CustomerRole = "Customer",
}

export enum CompanyStateCode {
    New = "New",
    Initialized = "Initialized",
    Archived = "Archived",
    DeleteFailed = "DeleteFailed",
    DeleteRetryFailed = "DeleteRetryFailed",
    WaitingForDelete = "WaitingForDelete",
}

export enum ContactTypeCode {
    BusinessPartner = "BusinessPartner",
    CompanyCommunication = "CompanyCommunication",
    GovernmentInstitutionContact = "GovernmentInstitutionContact",
    OZUSPOJSubmissionContactWorker = "OzuspojContactWorker",
}

export enum CountryCode {
    Andorra = "AD",
    UnitedArabEmirates = "AE",
    Afghanistan = "AF",
    AntiguaAndBarbuda = "AG",
    Anguilla = "AI",
    Albania = "AL",
    Armenia = "AM",
    Angola = "AO",
    Antarctica = "AQ",
    Argentina = "AR",
    AmericanSamoa = "AS",
    Austria = "AT",
    Australia = "AU",
    Aruba = "AW",
    ÅlandIslands = "AX",
    Azerbaijan = "AZ",
    BosniaAndHerzegovina = "BA",
    Barbados = "BB",
    Bangladesh = "BD",
    Belgium = "BE",
    BurkinaFaso = "BF",
    Bulgaria = "BG",
    Bahrain = "BH",
    Burundi = "BI",
    Benin = "BJ",
    SaintBarthélemy = "BL",
    Bermuda = "BM",
    Brunei = "BN",
    Bolivia = "BO",
    Bonaire_SintEustasiusAndSaba = "BQ",
    Brazil = "BR",
    Bahamas = "BS",
    Bhutan = "BT",
    BouvetIsland = "BV",
    Botswana = "BW",
    Belarus = "BY",
    Belize = "BZ",
    Canada = "CA",
    CocosKeelingIslands = "CC",
    CongoDRC = "CD",
    CentralAfricanRepublic = "CF",
    Congo = "CG",
    CôteDIvoire = "CI",
    CookIslands = "CK",
    Chile = "CL",
    Cameroon = "CM",
    China = "CN",
    Colombia = "CO",
    CostaRica = "CR",
    Cuba = "CU",
    CaboVerde = "CV",
    Curaçao = "CW",
    ChristmasIsland = "CX",
    Cyprus = "CY",
    CzechRepublic = "CZ",
    Germany = "DE",
    Djibouti = "DJ",
    Denmark = "DK",
    Dominica = "DM",
    DominicanRepublic = "DO",
    Algeria = "DZ",
    Ecuador = "EC",
    Estonia = "EE",
    Egypt = "EG",
    WesternSahara = "EH",
    Eritrea = "ER",
    Spain = "ES",
    Ethiopia = "ET",
    Finland = "FI",
    Fiji = "FJ",
    FalklandIslands = "FK",
    Micronesia = "FM",
    FaroeIslands = "FO",
    France = "FR",
    Gabon = "GA",
    UnitedKingdom = "GB",
    Grenada = "GD",
    Georgia = "GE",
    FrenchGuiana = "GF",
    Guernsey = "GG",
    Ghana = "GH",
    Gibraltar = "GI",
    Greenland = "GL",
    Gambia = "GM",
    Guinea = "GN",
    Guadeloupe = "GP",
    EquatorialGuinea = "GQ",
    Greece = "GR",
    SouthGeorgiaAndTheSouthSandwichIslands = "GS",
    Guatemala = "GT",
    Guam = "GU",
    GuineaBissau = "GW",
    Guyana = "GY",
    HongKong = "HK",
    HeardIslandAndMcDonaldIslands = "HM",
    Honduras = "HN",
    Croatia = "HR",
    Haiti = "HT",
    Hungary = "HU",
    Switzerland = "CH",
    Indonesia = "ID",
    Ireland = "IE",
    Israel = "IL",
    IsleOfMan = "IM",
    India = "IN",
    BritishIndianOceanTerritory = "IO",
    Iraq = "IQ",
    Iran = "IR",
    Iceland = "IS",
    Italy = "IT",
    Jersey = "JE",
    Jamaica = "JM",
    Jordan = "JO",
    Japan = "JP",
    Kenya = "KE",
    Kyrgyzstan = "KG",
    Cambodia = "KH",
    Kiribati = "KI",
    Comoros = "KM",
    SaintKittsAndNevis = "KN",
    NorthKorea = "KP",
    SouthKorea = "KR",
    Kuwait = "KW",
    CaymanIslands = "KY",
    Kazakhstan = "KZ",
    Laos = "LA",
    Lebanon = "LB",
    SaintLucia = "LC",
    Liechtenstein = "LI",
    SriLanka = "LK",
    Liberia = "LR",
    Lesotho = "LS",
    Lithuania = "LT",
    Luxembourg = "LU",
    Latvia = "LV",
    Libya = "LY",
    Morocco = "MA",
    Monaco = "MC",
    Moldova = "MD",
    Montenegro = "ME",
    SaintMartin = "MF",
    Madagascar = "MG",
    MarshallIslands = "MH",
    NorthMacedonia = "MK",
    Mali = "ML",
    Myanmar = "MM",
    Mongolia = "MN",
    Macao = "MO",
    NorthernMarianaIslands = "MP",
    Martinique = "MQ",
    Mauritania = "MR",
    Montserrat = "MS",
    Malta = "MT",
    Mauritius = "MU",
    Maldives = "MV",
    Malawi = "MW",
    Mexico = "MX",
    Malaysia = "MY",
    Mozambique = "MZ",
    Namibia = "NA",
    NewCaledonia = "NC",
    Niger = "NE",
    NorfolkIsland = "NF",
    Nigeria = "NG",
    Nicaragua = "NI",
    Netherlands = "NL",
    Norway = "NO",
    Nepal = "NP",
    Nauru = "NR",
    Niue = "NU",
    NewZealand = "NZ",
    Oman = "OM",
    Panama = "PA",
    Peru = "PE",
    FrenchPolynesia = "PF",
    PapuaNewGuinea = "PG",
    Philippines = "PH",
    Pakistan = "PK",
    Poland = "PL",
    SaintPierreAndMiquelon = "PM",
    PitcairnIslands = "PN",
    PuertoRico = "PR",
    Palestine = "PS",
    Portugal = "PT",
    Palau = "PW",
    Paraguay = "PY",
    Qatar = "QA",
    Réunion = "RE",
    Romania = "RO",
    Serbia = "RS",
    Russia = "RU",
    Rwanda = "RW",
    SaudiArabia = "SA",
    SolomonIslands = "SB",
    Seychelles = "SC",
    Sudan = "SD",
    Sweden = "SE",
    Singapore = "SG",
    SaintHelena = "SH",
    Slovenia = "SI",
    Svalbard = "SJ",
    Slovakia = "SK",
    SierraLeone = "SL",
    SanMarino = "SM",
    Senegal = "SN",
    Somalia = "SO",
    Suriname = "SR",
    SouthSudan = "SS",
    SãoToméAndPríncipe = "ST",
    ElSalvador = "SV",
    SintMaarten = "SX",
    Syria = "SY",
    Eswatini = "SZ",
    TurksAndCaicosIslands = "TC",
    Chad = "TD",
    FrenchSouthernTerritories = "TF",
    Togo = "TG",
    Thailand = "TH",
    Tajikistan = "TJ",
    Tokelau = "TK",
    TimorLeste = "TL",
    Turkmenistan = "TM",
    Tunisia = "TN",
    Tonga = "TO",
    Turkey = "TR",
    TrinidadAndTobago = "TT",
    Tuvalu = "TV",
    Taiwan = "TW",
    Tanzania = "TZ",
    Ukraine = "UA",
    Uganda = "UG",
    U_S_MinorOutlyingIslands = "UM",
    UnitedStatesOfAmerica = "US",
    Uruguay = "UY",
    Uzbekistan = "UZ",
    VaticanCity = "VA",
    SaintVincentAndTheGrenadines = "VC",
    Venezuela = "VE",
    BritishVirginInslands = "VG",
    U_S_VirginIslands = "VI",
    Vietnam = "VN",
    Vanuatu = "VU",
    WallisAndFutuna = "WF",
    Samoa = "WS",
    Kosovo = "XK",
    Yemen = "YE",
    Mayotte = "YT",
    SouthAfrica = "ZA",
    Zambia = "ZM",
    Zimbabwe = "ZW",
    EuropeanUnion = "XX",
    InternationalMonetaryFund = "YY",
}

export enum CountryClassificationCode {
    Domestic = "Domestic",
    EuropeanUnion = "EEA",
    OutsideTheEuropeanUnion = "NonEEA",
}

export enum CountryOrUnionCode {
    Andorra = "AD",
    UnitedArabEmirates = "AE",
    Afghanistan = "AF",
    AntiguaAndBarbuda = "AG",
    Anguilla = "AI",
    Albania = "AL",
    Armenia = "AM",
    Angola = "AO",
    Antarctica = "AQ",
    Argentina = "AR",
    AmericanSamoa = "AS",
    Austria = "AT",
    Australia = "AU",
    Aruba = "AW",
    ÅlandIslands = "AX",
    Azerbaijan = "AZ",
    BosniaAndHerzegovina = "BA",
    Barbados = "BB",
    Bangladesh = "BD",
    Belgium = "BE",
    BurkinaFaso = "BF",
    Bulgaria = "BG",
    Bahrain = "BH",
    Burundi = "BI",
    Benin = "BJ",
    SaintBarthélemy = "BL",
    Bermuda = "BM",
    Brunei = "BN",
    Bolivia = "BO",
    Bonaire_SintEustasiusAndSaba = "BQ",
    Brazil = "BR",
    Bahamas = "BS",
    Bhutan = "BT",
    BouvetIsland = "BV",
    Botswana = "BW",
    Belarus = "BY",
    Belize = "BZ",
    Canada = "CA",
    CocosKeelingIslands = "CC",
    CongoDRC = "CD",
    CentralAfricanRepublic = "CF",
    Congo = "CG",
    CôteDIvoire = "CI",
    CookIslands = "CK",
    Chile = "CL",
    Cameroon = "CM",
    China = "CN",
    Colombia = "CO",
    CostaRica = "CR",
    Cuba = "CU",
    CaboVerde = "CV",
    Curaçao = "CW",
    ChristmasIsland = "CX",
    Cyprus = "CY",
    CzechRepublic = "CZ",
    Germany = "DE",
    Djibouti = "DJ",
    Denmark = "DK",
    Dominica = "DM",
    DominicanRepublic = "DO",
    Algeria = "DZ",
    Ecuador = "EC",
    Estonia = "EE",
    Egypt = "EG",
    WesternSahara = "EH",
    Eritrea = "ER",
    Spain = "ES",
    Ethiopia = "ET",
    Finland = "FI",
    Fiji = "FJ",
    FalklandIslands = "FK",
    Micronesia = "FM",
    FaroeIslands = "FO",
    France = "FR",
    Gabon = "GA",
    UnitedKingdom = "GB",
    Grenada = "GD",
    Georgia = "GE",
    FrenchGuiana = "GF",
    Guernsey = "GG",
    Ghana = "GH",
    Gibraltar = "GI",
    Greenland = "GL",
    Gambia = "GM",
    Guinea = "GN",
    Guadeloupe = "GP",
    EquatorialGuinea = "GQ",
    Greece = "GR",
    SouthGeorgiaAndTheSouthSandwichIslands = "GS",
    Guatemala = "GT",
    Guam = "GU",
    GuineaBissau = "GW",
    Guyana = "GY",
    HongKong = "HK",
    HeardIslandAndMcDonaldIslands = "HM",
    Honduras = "HN",
    Croatia = "HR",
    Haiti = "HT",
    Hungary = "HU",
    Switzerland = "CH",
    Indonesia = "ID",
    Ireland = "IE",
    Israel = "IL",
    IsleOfMan = "IM",
    India = "IN",
    BritishIndianOceanTerritory = "IO",
    Iraq = "IQ",
    Iran = "IR",
    Iceland = "IS",
    Italy = "IT",
    Jersey = "JE",
    Jamaica = "JM",
    Jordan = "JO",
    Japan = "JP",
    Kenya = "KE",
    Kyrgyzstan = "KG",
    Cambodia = "KH",
    Kiribati = "KI",
    Comoros = "KM",
    SaintKittsAndNevis = "KN",
    NorthKorea = "KP",
    SouthKorea = "KR",
    Kuwait = "KW",
    CaymanIslands = "KY",
    Kazakhstan = "KZ",
    Laos = "LA",
    Lebanon = "LB",
    SaintLucia = "LC",
    Liechtenstein = "LI",
    SriLanka = "LK",
    Liberia = "LR",
    Lesotho = "LS",
    Lithuania = "LT",
    Luxembourg = "LU",
    Latvia = "LV",
    Libya = "LY",
    Morocco = "MA",
    Monaco = "MC",
    Moldova = "MD",
    Montenegro = "ME",
    SaintMartin = "MF",
    Madagascar = "MG",
    MarshallIslands = "MH",
    NorthMacedonia = "MK",
    Mali = "ML",
    Myanmar = "MM",
    Mongolia = "MN",
    Macao = "MO",
    NorthernMarianaIslands = "MP",
    Martinique = "MQ",
    Mauritania = "MR",
    Montserrat = "MS",
    Malta = "MT",
    Mauritius = "MU",
    Maldives = "MV",
    Malawi = "MW",
    Mexico = "MX",
    Malaysia = "MY",
    Mozambique = "MZ",
    Namibia = "NA",
    NewCaledonia = "NC",
    Niger = "NE",
    NorfolkIsland = "NF",
    Nigeria = "NG",
    Nicaragua = "NI",
    Netherlands = "NL",
    Norway = "NO",
    Nepal = "NP",
    Nauru = "NR",
    Niue = "NU",
    NewZealand = "NZ",
    Oman = "OM",
    Panama = "PA",
    Peru = "PE",
    FrenchPolynesia = "PF",
    PapuaNewGuinea = "PG",
    Philippines = "PH",
    Pakistan = "PK",
    Poland = "PL",
    SaintPierreAndMiquelon = "PM",
    PitcairnIslands = "PN",
    PuertoRico = "PR",
    Palestine = "PS",
    Portugal = "PT",
    Palau = "PW",
    Paraguay = "PY",
    Qatar = "QA",
    Réunion = "RE",
    Romania = "RO",
    Serbia = "RS",
    Russia = "RU",
    Rwanda = "RW",
    SaudiArabia = "SA",
    SolomonIslands = "SB",
    Seychelles = "SC",
    Sudan = "SD",
    Sweden = "SE",
    Singapore = "SG",
    SaintHelena = "SH",
    Slovenia = "SI",
    Svalbard = "SJ",
    Slovakia = "SK",
    SierraLeone = "SL",
    SanMarino = "SM",
    Senegal = "SN",
    Somalia = "SO",
    Suriname = "SR",
    SouthSudan = "SS",
    SãoToméAndPríncipe = "ST",
    ElSalvador = "SV",
    SintMaarten = "SX",
    Syria = "SY",
    Eswatini = "SZ",
    TurksAndCaicosIslands = "TC",
    Chad = "TD",
    FrenchSouthernTerritories = "TF",
    Togo = "TG",
    Thailand = "TH",
    Tajikistan = "TJ",
    Tokelau = "TK",
    TimorLeste = "TL",
    Turkmenistan = "TM",
    Tunisia = "TN",
    Tonga = "TO",
    Turkey = "TR",
    TrinidadAndTobago = "TT",
    Tuvalu = "TV",
    Taiwan = "TW",
    Tanzania = "TZ",
    Ukraine = "UA",
    Uganda = "UG",
    U_S_MinorOutlyingIslands = "UM",
    UnitedStatesOfAmerica = "US",
    Uruguay = "UY",
    Uzbekistan = "UZ",
    VaticanCity = "VA",
    SaintVincentAndTheGrenadines = "VC",
    Venezuela = "VE",
    BritishVirginInslands = "VG",
    U_S_VirginIslands = "VI",
    Vietnam = "VN",
    Vanuatu = "VU",
    WallisAndFutuna = "WF",
    Samoa = "WS",
    Kosovo = "XK",
    Yemen = "YE",
    Mayotte = "YT",
    SouthAfrica = "ZA",
    Zambia = "ZM",
    Zimbabwe = "ZW",
    EuropeanUnion = "XX",
    InternationalMonetaryFund = "YY",
}

export enum CountryRegionCode {
    HradecKrálovéRegion = "CZ_HKK",
    SouthBohemianRegion = "CZ_JHC",
    SouthMoravianRegion = "CZ_JHM",
    KarlovyVaryRegion = "CZ_KVK",
    LiberecRegion = "CZ_LBK",
    MoravianSilesianRegion = "CZ_MSK",
    OlomoucRegion = "CZ_OLK",
    PardubiceRegion = "CZ_PAK",
    Prague = "CZ_PHA",
    PlzeňRegion = "CZ_PLK",
    CentralBohemianRegion = "CZ_STC",
    ÚstíNadLabemRegion = "CZ_ULK",
    VysočinaRegion = "CZ_VYS",
    ZlínRegion = "CZ_ZLK",
}

export enum CurrencyCode {
    UAEDirham = "AED",
    AfghanAfghani = "AFN",
    Lek = "ALL",
    ArmenianDram = "AMD",
    NetherlandsAntilleanGuilder = "ANG",
    Kwanza = "AOA",
    ArgentinePeso = "ARS",
    AustralianDollar = "AUD",
    ArubanFlorin = "AWG",
    AzerbaijanManat = "AZN",
    ConvertibleMark = "BAM",
    BarbadosDollar = "BBD",
    Taka = "BDT",
    BulgarianLev = "BGN",
    BahrainiDinar = "BHD",
    BurundiFranc = "BIF",
    BermudianDollar = "BMD",
    BruneiDollar = "BND",
    Boliviano = "BOB",
    Mvdol = "BOV",
    BrazilianReal = "BRL",
    BahamianDollar = "BSD",
    Ngultrum = "BTN",
    Pula = "BWP",
    BelarusianRuble = "BYN",
    BelizeDollar = "BZD",
    CanadianDollar = "CAD",
    CongoleseFranc = "CDF",
    UnidadDeFomento = "CLF",
    ChileanPeso = "CLP",
    YuanRenminbi = "CNY",
    ColombianPeso = "COP",
    UnidadDeValorReal = "COU",
    CostaRicanColon = "CRC",
    PesoConvertible = "CUC",
    CubanPeso = "CUP",
    CaboVerdeEscudo = "CVE",
    CzechKoruna = "CZK",
    DjiboutiFranc = "DJF",
    DanishKrone = "DKK",
    DominicanPeso = "DOP",
    AlgerianDinar = "DZD",
    EgyptianPound = "EGP",
    Nakfa = "ERN",
    EthiopianBirr = "ETB",
    Euro = "EUR",
    FijiDollar = "FJD",
    FalklandIslandsPound = "FKP",
    PoundSterling = "GBP",
    Lari = "GEL",
    GhanaCedi = "GHS",
    GibraltarPound = "GIP",
    Dalasi = "GMD",
    GuineanFranc = "GNF",
    Quetzal = "GTQ",
    GuyanaDollar = "GYD",
    HongKongDollar = "HKD",
    Lempira = "HNL",
    Kuna = "HRK",
    Gourde = "HTG",
    Forint = "HUF",
    WIREuro = "CHE",
    SwissFranc = "CHF",
    WIRFranc = "CHW",
    Rupiah = "IDR",
    NewIsraeliSheqel = "ILS",
    IndianRupee = "INR",
    IraqiDinar = "IQD",
    IranianRial = "IRR",
    IcelandKrona = "ISK",
    JamaicanDollar = "JMD",
    JordanianDinar = "JOD",
    Yen = "JPY",
    KenyanShilling = "KES",
    Som = "KGS",
    Riel = "KHR",
    ComorianFranc = "KMF",
    NorthKoreanWon = "KPW",
    Won = "KRW",
    KuwaitiDinar = "KWD",
    CaymanIslandsDollar = "KYD",
    Tenge = "KZT",
    LaoKip = "LAK",
    LebanesePound = "LBP",
    SriLankaRupee = "LKR",
    LiberianDollar = "LRD",
    Loti = "LSL",
    LibyanDinar = "LYD",
    MoroccanDirham = "MAD",
    MoldovanLeu = "MDL",
    MalagasyAriary = "MGA",
    Denar = "MKD",
    Kyat = "MMK",
    Tugrik = "MNT",
    Pataca = "MOP",
    Ouguiya = "MRU",
    MauritiusRupee = "MUR",
    Rufiyaa = "MVR",
    MalawiKwacha = "MWK",
    MexicanPeso = "MXN",
    MexicanUnidadDeInversionUDI = "MXV",
    MalaysianRinggit = "MYR",
    MozambiqueMetical = "MZN",
    NamibiaDollar = "NAD",
    Naira = "NGN",
    CordobaOro = "NIO",
    NorwegianKrone = "NOK",
    NepaleseRupee = "NPR",
    NewZealandDollar = "NZD",
    RialOmani = "OMR",
    Balboa = "PAB",
    Sol = "PEN",
    Kina = "PGK",
    PhilippinePeso = "PHP",
    PakistanRupee = "PKR",
    Zloty = "PLN",
    Guarani = "PYG",
    QatariRial = "QAR",
    RomanianLeu = "RON",
    SerbianDinar = "RSD",
    RussianRuble = "RUB",
    RwandaFranc = "RWF",
    SaudiRiyal = "SAR",
    SolomonIslandsDollar = "SBD",
    SeychellesRupee = "SCR",
    SudanesePound = "SDG",
    SwedishKrona = "SEK",
    SingaporeDollar = "SGD",
    SaintHelenaPound = "SHP",
    Leone694 = "SLL",
    Leone = "SLE",
    SomaliShilling = "SOS",
    SurinamDollar = "SRD",
    SouthSudanesePound = "SSP",
    Dobra = "STN",
    ElSalvadorColon = "SVC",
    SyrianPound = "SYP",
    Lilangeni = "SZL",
    Baht = "THB",
    Somoni = "TJS",
    TurkmenistanNewManat = "TMT",
    TunisianDinar = "TND",
    Paanga = "TOP",
    TurkishLira = "TRY",
    TrinidadAndTobagoDollar = "TTD",
    NewTaiwanDollar = "TWD",
    TanzanianShilling = "TZS",
    Hryvnia = "UAH",
    UgandaShilling = "UGX",
    USDollar = "USD",
    USDollarNextDay = "USN",
    UruguayPesoEnUnidadesIndexadasUI = "UYI",
    PesoUruguayo = "UYU",
    UnidadPrevisional = "UYW",
    UzbekistanSum = "UZS",
    BolívarSoberano = "VES",
    VenezuelanDigitalBolívar = "VED",
    VenezuelanBolívar = "VEF",
    Dong = "VND",
    Vatu = "VUV",
    Tala = "WST",
    CFAFrancBEAC = "XAF",
    EastCaribbeanDollar = "XCD",
    SDRSpecialDrawingRight = "XDR",
    CFAFrancBCEAO = "XOF",
    CFPFranc = "XPF",
    Sucre = "XSU",
    ADBUnitOfAccount = "XUA",
    YemeniRial = "YER",
    Rand = "ZAR",
    ZambianKwacha = "ZMW",
    ZimbabweanDollar = "ZWL",
}

export enum CzIsceCode {
    CZISCE1111 = "CZ_1111",
    CZISCE1112 = "CZ_1112",
    CZISCE1121 = "CZ_1121",
    CZISCE1122 = "CZ_1122",
    CZISCE1211 = "CZ_1211",
    CZISCE1212 = "CZ_1212",
    CZISCE1221 = "CZ_1221",
    CZISCE1222 = "CZ_1222",
    CZISCE1311 = "CZ_1311",
    CZISCE1312 = "CZ_1312",
    CZISCE1313 = "CZ_1313",
    CZISCE1320 = "CZ_1320",
    CZISCE1321 = "CZ_1321",
    CZISCE1322 = "CZ_1322",
    CZISCE1331 = "CZ_1331",
    CZISCE1332 = "CZ_1332",
    CZISCE1341 = "CZ_1341",
    CZISCE1342 = "CZ_1342",
    CZISCE1410 = "CZ_1410",
    CZISCE2111 = "CZ_2111",
    CZISCE2112 = "CZ_2112",
    CZISCE2113 = "CZ_2113",
    CZISCE2114 = "CZ_2114",
    CZISCE2119 = "CZ_2119",
    CZISCE2210 = "CZ_2210",
    CZISCE2219 = "CZ_2219",
    CZISCE3111 = "CZ_3111",
    CZISCE3112 = "CZ_3112",
    CZISCE3113 = "CZ_3113",
    CZISCE3114 = "CZ_3114",
    CZISCE3119 = "CZ_3119",
    CZISCE4111 = "CZ_4111",
    CZISCE4112 = "CZ_4112",
    CZISCE5111 = "CZ_5111",
    CZISCE5119 = "CZ_5119",
    CZISCE6110 = "CZ_6110",
}

export enum CzIscoCode {
    CZISCO01101 = "CZ_01101",
    CZISCO01102 = "CZ_01102",
    CZISCO01103 = "CZ_01103",
    CZISCO02100 = "CZ_02100",
    CZISCO03101 = "CZ_03101",
    CZISCO03102 = "CZ_03102",
    CZISCO03103 = "CZ_03103",
    CZISCO03109 = "CZ_03109",
    CZISCO11110 = "CZ_11110",
    CZISCO11121 = "CZ_11121",
    CZISCO11122 = "CZ_11122",
    CZISCO11123 = "CZ_11123",
    CZISCO11124 = "CZ_11124",
    CZISCO11125 = "CZ_11125",
    CZISCO11126 = "CZ_11126",
    CZISCO11127 = "CZ_11127",
    CZISCO11129 = "CZ_11129",
    CZISCO11130 = "CZ_11130",
    CZISCO11140 = "CZ_11140",
    CZISCO11201 = "CZ_11201",
    CZISCO11202 = "CZ_11202",
    CZISCO11203 = "CZ_11203",
    CZISCO11204 = "CZ_11204",
    CZISCO12111 = "CZ_12111",
    CZISCO12112 = "CZ_12112",
    CZISCO12113 = "CZ_12113",
    CZISCO12119 = "CZ_12119",
    CZISCO12121 = "CZ_12121",
    CZISCO12122 = "CZ_12122",
    CZISCO12123 = "CZ_12123",
    CZISCO12129 = "CZ_12129",
    CZISCO12130 = "CZ_12130",
    CZISCO12191 = "CZ_12191",
    CZISCO12192 = "CZ_12192",
    CZISCO12193 = "CZ_12193",
    CZISCO12194 = "CZ_12194",
    CZISCO12195 = "CZ_12195",
    CZISCO12196 = "CZ_12196",
    CZISCO12197 = "CZ_12197",
    CZISCO12199 = "CZ_12199",
    CZISCO12211 = "CZ_12211",
    CZISCO12212 = "CZ_12212",
    CZISCO12213 = "CZ_12213",
    CZISCO12214 = "CZ_12214",
    CZISCO12215 = "CZ_12215",
    CZISCO12219 = "CZ_12219",
    CZISCO12221 = "CZ_12221",
    CZISCO12222 = "CZ_12222",
    CZISCO12231 = "CZ_12231",
    CZISCO12232 = "CZ_12232",
    CZISCO12233 = "CZ_12233",
    CZISCO12239 = "CZ_12239",
    CZISCO13111 = "CZ_13111",
    CZISCO13112 = "CZ_13112",
    CZISCO13113 = "CZ_13113",
    CZISCO13114 = "CZ_13114",
    CZISCO13115 = "CZ_13115",
    CZISCO13121 = "CZ_13121",
    CZISCO13122 = "CZ_13122",
    CZISCO13211 = "CZ_13211",
    CZISCO13212 = "CZ_13212",
    CZISCO13213 = "CZ_13213",
    CZISCO13214 = "CZ_13214",
    CZISCO13215 = "CZ_13215",
    CZISCO13221 = "CZ_13221",
    CZISCO13222 = "CZ_13222",
    CZISCO13223 = "CZ_13223",
    CZISCO13231 = "CZ_13231",
    CZISCO13232 = "CZ_13232",
    CZISCO13233 = "CZ_13233",
    CZISCO13234 = "CZ_13234",
    CZISCO13235 = "CZ_13235",
    CZISCO13239 = "CZ_13239",
    CZISCO13241 = "CZ_13241",
    CZISCO13242 = "CZ_13242",
    CZISCO13243 = "CZ_13243",
    CZISCO13244 = "CZ_13244",
    CZISCO13245 = "CZ_13245",
    CZISCO13249 = "CZ_13249",
    CZISCO13301 = "CZ_13301",
    CZISCO13302 = "CZ_13302",
    CZISCO13303 = "CZ_13303",
    CZISCO13309 = "CZ_13309",
    CZISCO13411 = "CZ_13411",
    CZISCO13412 = "CZ_13412",
    CZISCO13413 = "CZ_13413",
    CZISCO13421 = "CZ_13421",
    CZISCO13422 = "CZ_13422",
    CZISCO13423 = "CZ_13423",
    CZISCO13424 = "CZ_13424",
    CZISCO13425 = "CZ_13425",
    CZISCO13429 = "CZ_13429",
    CZISCO13431 = "CZ_13431",
    CZISCO13432 = "CZ_13432",
    CZISCO13433 = "CZ_13433",
    CZISCO13434 = "CZ_13434",
    CZISCO13439 = "CZ_13439",
    CZISCO13441 = "CZ_13441",
    CZISCO13442 = "CZ_13442",
    CZISCO13443 = "CZ_13443",
    CZISCO13451 = "CZ_13451",
    CZISCO13452 = "CZ_13452",
    CZISCO13453 = "CZ_13453",
    CZISCO13454 = "CZ_13454",
    CZISCO13455 = "CZ_13455",
    CZISCO13456 = "CZ_13456",
    CZISCO13459 = "CZ_13459",
    CZISCO13461 = "CZ_13461",
    CZISCO13462 = "CZ_13462",
    CZISCO13491 = "CZ_13491",
    CZISCO13492 = "CZ_13492",
    CZISCO13493 = "CZ_13493",
    CZISCO13494 = "CZ_13494",
    CZISCO13495 = "CZ_13495",
    CZISCO13499 = "CZ_13499",
    CZISCO14111 = "CZ_14111",
    CZISCO14112 = "CZ_14112",
    CZISCO14113 = "CZ_14113",
    CZISCO14119 = "CZ_14119",
    CZISCO14121 = "CZ_14121",
    CZISCO14122 = "CZ_14122",
    CZISCO14123 = "CZ_14123",
    CZISCO14124 = "CZ_14124",
    CZISCO14125 = "CZ_14125",
    CZISCO14126 = "CZ_14126",
    CZISCO14129 = "CZ_14129",
    CZISCO14201 = "CZ_14201",
    CZISCO14202 = "CZ_14202",
    CZISCO14311 = "CZ_14311",
    CZISCO14312 = "CZ_14312",
    CZISCO14313 = "CZ_14313",
    CZISCO14314 = "CZ_14314",
    CZISCO14319 = "CZ_14319",
    CZISCO14391 = "CZ_14391",
    CZISCO14392 = "CZ_14392",
    CZISCO14393 = "CZ_14393",
    CZISCO14394 = "CZ_14394",
    CZISCO14395 = "CZ_14395",
    CZISCO14399 = "CZ_14399",
    CZISCO21111 = "CZ_21111",
    CZISCO21112 = "CZ_21112",
    CZISCO21113 = "CZ_21113",
    CZISCO21114 = "CZ_21114",
    CZISCO21119 = "CZ_21119",
    CZISCO21120 = "CZ_21120",
    CZISCO21131 = "CZ_21131",
    CZISCO21132 = "CZ_21132",
    CZISCO21133 = "CZ_21133",
    CZISCO21134 = "CZ_21134",
    CZISCO21135 = "CZ_21135",
    CZISCO21139 = "CZ_21139",
    CZISCO21141 = "CZ_21141",
    CZISCO21142 = "CZ_21142",
    CZISCO21143 = "CZ_21143",
    CZISCO21144 = "CZ_21144",
    CZISCO21149 = "CZ_21149",
    CZISCO21201 = "CZ_21201",
    CZISCO21202 = "CZ_21202",
    CZISCO21203 = "CZ_21203",
    CZISCO21311 = "CZ_21311",
    CZISCO21312 = "CZ_21312",
    CZISCO21313 = "CZ_21313",
    CZISCO21314 = "CZ_21314",
    CZISCO21315 = "CZ_21315",
    CZISCO21316 = "CZ_21316",
    CZISCO21317 = "CZ_21317",
    CZISCO21318 = "CZ_21318",
    CZISCO21319 = "CZ_21319",
    CZISCO21321 = "CZ_21321",
    CZISCO21322 = "CZ_21322",
    CZISCO21323 = "CZ_21323",
    CZISCO21324 = "CZ_21324",
    CZISCO21325 = "CZ_21325",
    CZISCO21326 = "CZ_21326",
    CZISCO21329 = "CZ_21329",
    CZISCO21330 = "CZ_21330",
    CZISCO21411 = "CZ_21411",
    CZISCO21412 = "CZ_21412",
    CZISCO21413 = "CZ_21413",
    CZISCO21414 = "CZ_21414",
    CZISCO21415 = "CZ_21415",
    CZISCO21416 = "CZ_21416",
    CZISCO21419 = "CZ_21419",
    CZISCO21421 = "CZ_21421",
    CZISCO21422 = "CZ_21422",
    CZISCO21423 = "CZ_21423",
    CZISCO21424 = "CZ_21424",
    CZISCO21425 = "CZ_21425",
    CZISCO21426 = "CZ_21426",
    CZISCO21427 = "CZ_21427",
    CZISCO21428 = "CZ_21428",
    CZISCO21429 = "CZ_21429",
    CZISCO21430 = "CZ_21430",
    CZISCO21441 = "CZ_21441",
    CZISCO21442 = "CZ_21442",
    CZISCO21443 = "CZ_21443",
    CZISCO21444 = "CZ_21444",
    CZISCO21445 = "CZ_21445",
    CZISCO21446 = "CZ_21446",
    CZISCO21449 = "CZ_21449",
    CZISCO21451 = "CZ_21451",
    CZISCO21452 = "CZ_21452",
    CZISCO21453 = "CZ_21453",
    CZISCO21454 = "CZ_21454",
    CZISCO21455 = "CZ_21455",
    CZISCO21456 = "CZ_21456",
    CZISCO21459 = "CZ_21459",
    CZISCO21461 = "CZ_21461",
    CZISCO21462 = "CZ_21462",
    CZISCO21463 = "CZ_21463",
    CZISCO21464 = "CZ_21464",
    CZISCO21465 = "CZ_21465",
    CZISCO21466 = "CZ_21466",
    CZISCO21469 = "CZ_21469",
    CZISCO21491 = "CZ_21491",
    CZISCO21492 = "CZ_21492",
    CZISCO21493 = "CZ_21493",
    CZISCO21494 = "CZ_21494",
    CZISCO21495 = "CZ_21495",
    CZISCO21496 = "CZ_21496",
    CZISCO21497 = "CZ_21497",
    CZISCO21498 = "CZ_21498",
    CZISCO21499 = "CZ_21499",
    CZISCO21511 = "CZ_21511",
    CZISCO21512 = "CZ_21512",
    CZISCO21513 = "CZ_21513",
    CZISCO21514 = "CZ_21514",
    CZISCO21515 = "CZ_21515",
    CZISCO21516 = "CZ_21516",
    CZISCO21517 = "CZ_21517",
    CZISCO21518 = "CZ_21518",
    CZISCO21519 = "CZ_21519",
    CZISCO21521 = "CZ_21521",
    CZISCO21522 = "CZ_21522",
    CZISCO21523 = "CZ_21523",
    CZISCO21524 = "CZ_21524",
    CZISCO21525 = "CZ_21525",
    CZISCO21526 = "CZ_21526",
    CZISCO21529 = "CZ_21529",
    CZISCO21531 = "CZ_21531",
    CZISCO21532 = "CZ_21532",
    CZISCO21533 = "CZ_21533",
    CZISCO21534 = "CZ_21534",
    CZISCO21535 = "CZ_21535",
    CZISCO21536 = "CZ_21536",
    CZISCO21539 = "CZ_21539",
    CZISCO21610 = "CZ_21610",
    CZISCO21620 = "CZ_21620",
    CZISCO21631 = "CZ_21631",
    CZISCO21632 = "CZ_21632",
    CZISCO21640 = "CZ_21640",
    CZISCO21650 = "CZ_21650",
    CZISCO21660 = "CZ_21660",
    CZISCO22111 = "CZ_22111",
    CZISCO22112 = "CZ_22112",
    CZISCO22113 = "CZ_22113",
    CZISCO22119 = "CZ_22119",
    CZISCO22121 = "CZ_22121",
    CZISCO22122 = "CZ_22122",
    CZISCO22123 = "CZ_22123",
    CZISCO22124 = "CZ_22124",
    CZISCO22125 = "CZ_22125",
    CZISCO22126 = "CZ_22126",
    CZISCO22127 = "CZ_22127",
    CZISCO22128 = "CZ_22128",
    CZISCO22129 = "CZ_22129",
    CZISCO22211 = "CZ_22211",
    CZISCO22212 = "CZ_22212",
    CZISCO22213 = "CZ_22213",
    CZISCO22214 = "CZ_22214",
    CZISCO22215 = "CZ_22215",
    CZISCO22216 = "CZ_22216",
    CZISCO22217 = "CZ_22217",
    CZISCO22218 = "CZ_22218",
    CZISCO22219 = "CZ_22219",
    CZISCO22221 = "CZ_22221",
    CZISCO22222 = "CZ_22222",
    CZISCO22223 = "CZ_22223",
    CZISCO22224 = "CZ_22224",
    CZISCO22229 = "CZ_22229",
    CZISCO22300 = "CZ_22300",
    CZISCO22400 = "CZ_22400",
    CZISCO22500 = "CZ_22500",
    CZISCO22611 = "CZ_22611",
    CZISCO22612 = "CZ_22612",
    CZISCO22613 = "CZ_22613",
    CZISCO22614 = "CZ_22614",
    CZISCO22619 = "CZ_22619",
    CZISCO22621 = "CZ_22621",
    CZISCO22622 = "CZ_22622",
    CZISCO22623 = "CZ_22623",
    CZISCO22629 = "CZ_22629",
    CZISCO22630 = "CZ_22630",
    CZISCO22641 = "CZ_22641",
    CZISCO22642 = "CZ_22642",
    CZISCO22643 = "CZ_22643",
    CZISCO22644 = "CZ_22644",
    CZISCO22649 = "CZ_22649",
    CZISCO22650 = "CZ_22650",
    CZISCO22661 = "CZ_22661",
    CZISCO22662 = "CZ_22662",
    CZISCO22663 = "CZ_22663",
    CZISCO22669 = "CZ_22669",
    CZISCO22671 = "CZ_22671",
    CZISCO22672 = "CZ_22672",
    CZISCO22673 = "CZ_22673",
    CZISCO22679 = "CZ_22679",
    CZISCO22691 = "CZ_22691",
    CZISCO22692 = "CZ_22692",
    CZISCO22693 = "CZ_22693",
    CZISCO22699 = "CZ_22699",
    CZISCO23101 = "CZ_23101",
    CZISCO23102 = "CZ_23102",
    CZISCO23103 = "CZ_23103",
    CZISCO23104 = "CZ_23104",
    CZISCO23105 = "CZ_23105",
    CZISCO23106 = "CZ_23106",
    CZISCO23107 = "CZ_23107",
    CZISCO23201 = "CZ_23201",
    CZISCO23202 = "CZ_23202",
    CZISCO23203 = "CZ_23203",
    CZISCO23204 = "CZ_23204",
    CZISCO23301 = "CZ_23301",
    CZISCO23302 = "CZ_23302",
    CZISCO23303 = "CZ_23303",
    CZISCO23411 = "CZ_23411",
    CZISCO23412 = "CZ_23412",
    CZISCO23420 = "CZ_23420",
    CZISCO23511 = "CZ_23511",
    CZISCO23512 = "CZ_23512",
    CZISCO23513 = "CZ_23513",
    CZISCO23514 = "CZ_23514",
    CZISCO23515 = "CZ_23515",
    CZISCO23519 = "CZ_23519",
    CZISCO23521 = "CZ_23521",
    CZISCO23522 = "CZ_23522",
    CZISCO23523 = "CZ_23523",
    CZISCO23524 = "CZ_23524",
    CZISCO23525 = "CZ_23525",
    CZISCO23526 = "CZ_23526",
    CZISCO23527 = "CZ_23527",
    CZISCO23529 = "CZ_23529",
    CZISCO23530 = "CZ_23530",
    CZISCO23540 = "CZ_23540",
    CZISCO23550 = "CZ_23550",
    CZISCO23560 = "CZ_23560",
    CZISCO23591 = "CZ_23591",
    CZISCO23592 = "CZ_23592",
    CZISCO23593 = "CZ_23593",
    CZISCO23594 = "CZ_23594",
    CZISCO23595 = "CZ_23595",
    CZISCO23596 = "CZ_23596",
    CZISCO23599 = "CZ_23599",
    CZISCO24111 = "CZ_24111",
    CZISCO24112 = "CZ_24112",
    CZISCO24113 = "CZ_24113",
    CZISCO24114 = "CZ_24114",
    CZISCO24115 = "CZ_24115",
    CZISCO24116 = "CZ_24116",
    CZISCO24119 = "CZ_24119",
    CZISCO24121 = "CZ_24121",
    CZISCO24122 = "CZ_24122",
    CZISCO24123 = "CZ_24123",
    CZISCO24124 = "CZ_24124",
    CZISCO24125 = "CZ_24125",
    CZISCO24129 = "CZ_24129",
    CZISCO24131 = "CZ_24131",
    CZISCO24132 = "CZ_24132",
    CZISCO24133 = "CZ_24133",
    CZISCO24134 = "CZ_24134",
    CZISCO24135 = "CZ_24135",
    CZISCO24136 = "CZ_24136",
    CZISCO24139 = "CZ_24139",
    CZISCO24210 = "CZ_24210",
    CZISCO24221 = "CZ_24221",
    CZISCO24222 = "CZ_24222",
    CZISCO24223 = "CZ_24223",
    CZISCO24224 = "CZ_24224",
    CZISCO24225 = "CZ_24225",
    CZISCO24226 = "CZ_24226",
    CZISCO24227 = "CZ_24227",
    CZISCO24228 = "CZ_24228",
    CZISCO24229 = "CZ_24229",
    CZISCO24230 = "CZ_24230",
    CZISCO24240 = "CZ_24240",
    CZISCO24311 = "CZ_24311",
    CZISCO24312 = "CZ_24312",
    CZISCO24313 = "CZ_24313",
    CZISCO24320 = "CZ_24320",
    CZISCO24331 = "CZ_24331",
    CZISCO24332 = "CZ_24332",
    CZISCO24333 = "CZ_24333",
    CZISCO24334 = "CZ_24334",
    CZISCO24335 = "CZ_24335",
    CZISCO24336 = "CZ_24336",
    CZISCO24337 = "CZ_24337",
    CZISCO24339 = "CZ_24339",
    CZISCO24340 = "CZ_24340",
    CZISCO25110 = "CZ_25110",
    CZISCO25120 = "CZ_25120",
    CZISCO25130 = "CZ_25130",
    CZISCO25140 = "CZ_25140",
    CZISCO25190 = "CZ_25190",
    CZISCO25210 = "CZ_25210",
    CZISCO25220 = "CZ_25220",
    CZISCO25230 = "CZ_25230",
    CZISCO25290 = "CZ_25290",
    CZISCO26111 = "CZ_26111",
    CZISCO26112 = "CZ_26112",
    CZISCO26113 = "CZ_26113",
    CZISCO26114 = "CZ_26114",
    CZISCO26119 = "CZ_26119",
    CZISCO26121 = "CZ_26121",
    CZISCO26122 = "CZ_26122",
    CZISCO26123 = "CZ_26123",
    CZISCO26124 = "CZ_26124",
    CZISCO26129 = "CZ_26129",
    CZISCO26191 = "CZ_26191",
    CZISCO26192 = "CZ_26192",
    CZISCO26193 = "CZ_26193",
    CZISCO26194 = "CZ_26194",
    CZISCO26195 = "CZ_26195",
    CZISCO26196 = "CZ_26196",
    CZISCO26199 = "CZ_26199",
    CZISCO26211 = "CZ_26211",
    CZISCO26212 = "CZ_26212",
    CZISCO26213 = "CZ_26213",
    CZISCO26220 = "CZ_26220",
    CZISCO26311 = "CZ_26311",
    CZISCO26312 = "CZ_26312",
    CZISCO26321 = "CZ_26321",
    CZISCO26322 = "CZ_26322",
    CZISCO26323 = "CZ_26323",
    CZISCO26324 = "CZ_26324",
    CZISCO26325 = "CZ_26325",
    CZISCO26326 = "CZ_26326",
    CZISCO26329 = "CZ_26329",
    CZISCO26330 = "CZ_26330",
    CZISCO26341 = "CZ_26341",
    CZISCO26342 = "CZ_26342",
    CZISCO26343 = "CZ_26343",
    CZISCO26344 = "CZ_26344",
    CZISCO26345 = "CZ_26345",
    CZISCO26349 = "CZ_26349",
    CZISCO26351 = "CZ_26351",
    CZISCO26352 = "CZ_26352",
    CZISCO26353 = "CZ_26353",
    CZISCO26354 = "CZ_26354",
    CZISCO26355 = "CZ_26355",
    CZISCO26356 = "CZ_26356",
    CZISCO26357 = "CZ_26357",
    CZISCO26359 = "CZ_26359",
    CZISCO26360 = "CZ_26360",
    CZISCO26410 = "CZ_26410",
    CZISCO26421 = "CZ_26421",
    CZISCO26422 = "CZ_26422",
    CZISCO26423 = "CZ_26423",
    CZISCO26424 = "CZ_26424",
    CZISCO26429 = "CZ_26429",
    CZISCO26431 = "CZ_26431",
    CZISCO26432 = "CZ_26432",
    CZISCO26511 = "CZ_26511",
    CZISCO26512 = "CZ_26512",
    CZISCO26513 = "CZ_26513",
    CZISCO26514 = "CZ_26514",
    CZISCO26519 = "CZ_26519",
    CZISCO26521 = "CZ_26521",
    CZISCO26522 = "CZ_26522",
    CZISCO26523 = "CZ_26523",
    CZISCO26524 = "CZ_26524",
    CZISCO26525 = "CZ_26525",
    CZISCO26529 = "CZ_26529",
    CZISCO26531 = "CZ_26531",
    CZISCO26532 = "CZ_26532",
    CZISCO26533 = "CZ_26533",
    CZISCO26534 = "CZ_26534",
    CZISCO26539 = "CZ_26539",
    CZISCO26541 = "CZ_26541",
    CZISCO26542 = "CZ_26542",
    CZISCO26543 = "CZ_26543",
    CZISCO26544 = "CZ_26544",
    CZISCO26549 = "CZ_26549",
    CZISCO26550 = "CZ_26550",
    CZISCO26561 = "CZ_26561",
    CZISCO26562 = "CZ_26562",
    CZISCO26569 = "CZ_26569",
    CZISCO26590 = "CZ_26590",
    CZISCO31111 = "CZ_31111",
    CZISCO31112 = "CZ_31112",
    CZISCO31113 = "CZ_31113",
    CZISCO31114 = "CZ_31114",
    CZISCO31115 = "CZ_31115",
    CZISCO31116 = "CZ_31116",
    CZISCO31117 = "CZ_31117",
    CZISCO31119 = "CZ_31119",
    CZISCO31121 = "CZ_31121",
    CZISCO31122 = "CZ_31122",
    CZISCO31123 = "CZ_31123",
    CZISCO31124 = "CZ_31124",
    CZISCO31125 = "CZ_31125",
    CZISCO31126 = "CZ_31126",
    CZISCO31127 = "CZ_31127",
    CZISCO31128 = "CZ_31128",
    CZISCO31129 = "CZ_31129",
    CZISCO31131 = "CZ_31131",
    CZISCO31132 = "CZ_31132",
    CZISCO31133 = "CZ_31133",
    CZISCO31134 = "CZ_31134",
    CZISCO31135 = "CZ_31135",
    CZISCO31136 = "CZ_31136",
    CZISCO31137 = "CZ_31137",
    CZISCO31138 = "CZ_31138",
    CZISCO31139 = "CZ_31139",
    CZISCO31141 = "CZ_31141",
    CZISCO31142 = "CZ_31142",
    CZISCO31143 = "CZ_31143",
    CZISCO31144 = "CZ_31144",
    CZISCO31145 = "CZ_31145",
    CZISCO31146 = "CZ_31146",
    CZISCO31147 = "CZ_31147",
    CZISCO31148 = "CZ_31148",
    CZISCO31149 = "CZ_31149",
    CZISCO31151 = "CZ_31151",
    CZISCO31152 = "CZ_31152",
    CZISCO31153 = "CZ_31153",
    CZISCO31154 = "CZ_31154",
    CZISCO31155 = "CZ_31155",
    CZISCO31156 = "CZ_31156",
    CZISCO31157 = "CZ_31157",
    CZISCO31158 = "CZ_31158",
    CZISCO31159 = "CZ_31159",
    CZISCO31161 = "CZ_31161",
    CZISCO31162 = "CZ_31162",
    CZISCO31163 = "CZ_31163",
    CZISCO31164 = "CZ_31164",
    CZISCO31165 = "CZ_31165",
    CZISCO31166 = "CZ_31166",
    CZISCO31167 = "CZ_31167",
    CZISCO31169 = "CZ_31169",
    CZISCO31171 = "CZ_31171",
    CZISCO31172 = "CZ_31172",
    CZISCO31173 = "CZ_31173",
    CZISCO31174 = "CZ_31174",
    CZISCO31175 = "CZ_31175",
    CZISCO31176 = "CZ_31176",
    CZISCO31177 = "CZ_31177",
    CZISCO31178 = "CZ_31178",
    CZISCO31179 = "CZ_31179",
    CZISCO31181 = "CZ_31181",
    CZISCO31182 = "CZ_31182",
    CZISCO31183 = "CZ_31183",
    CZISCO31189 = "CZ_31189",
    CZISCO31191 = "CZ_31191",
    CZISCO31192 = "CZ_31192",
    CZISCO31193 = "CZ_31193",
    CZISCO31194 = "CZ_31194",
    CZISCO31195 = "CZ_31195",
    CZISCO31196 = "CZ_31196",
    CZISCO31197 = "CZ_31197",
    CZISCO31198 = "CZ_31198",
    CZISCO31199 = "CZ_31199",
    CZISCO31211 = "CZ_31211",
    CZISCO31212 = "CZ_31212",
    CZISCO31213 = "CZ_31213",
    CZISCO31221 = "CZ_31221",
    CZISCO31222 = "CZ_31222",
    CZISCO31223 = "CZ_31223",
    CZISCO31224 = "CZ_31224",
    CZISCO31225 = "CZ_31225",
    CZISCO31226 = "CZ_31226",
    CZISCO31227 = "CZ_31227",
    CZISCO31228 = "CZ_31228",
    CZISCO31229 = "CZ_31229",
    CZISCO31230 = "CZ_31230",
    CZISCO31311 = "CZ_31311",
    CZISCO31312 = "CZ_31312",
    CZISCO31321 = "CZ_31321",
    CZISCO31322 = "CZ_31322",
    CZISCO31330 = "CZ_31330",
    CZISCO31340 = "CZ_31340",
    CZISCO31351 = "CZ_31351",
    CZISCO31352 = "CZ_31352",
    CZISCO31353 = "CZ_31353",
    CZISCO31354 = "CZ_31354",
    CZISCO31359 = "CZ_31359",
    CZISCO31391 = "CZ_31391",
    CZISCO31392 = "CZ_31392",
    CZISCO31399 = "CZ_31399",
    CZISCO31411 = "CZ_31411",
    CZISCO31412 = "CZ_31412",
    CZISCO31413 = "CZ_31413",
    CZISCO31414 = "CZ_31414",
    CZISCO31415 = "CZ_31415",
    CZISCO31419 = "CZ_31419",
    CZISCO31421 = "CZ_31421",
    CZISCO31422 = "CZ_31422",
    CZISCO31423 = "CZ_31423",
    CZISCO31424 = "CZ_31424",
    CZISCO31425 = "CZ_31425",
    CZISCO31429 = "CZ_31429",
    CZISCO31430 = "CZ_31430",
    CZISCO31510 = "CZ_31510",
    CZISCO31520 = "CZ_31520",
    CZISCO31531 = "CZ_31531",
    CZISCO31532 = "CZ_31532",
    CZISCO31533 = "CZ_31533",
    CZISCO31534 = "CZ_31534",
    CZISCO31535 = "CZ_31535",
    CZISCO31536 = "CZ_31536",
    CZISCO31540 = "CZ_31540",
    CZISCO31550 = "CZ_31550",
    CZISCO32111 = "CZ_32111",
    CZISCO32112 = "CZ_32112",
    CZISCO32113 = "CZ_32113",
    CZISCO32119 = "CZ_32119",
    CZISCO32121 = "CZ_32121",
    CZISCO32122 = "CZ_32122",
    CZISCO32129 = "CZ_32129",
    CZISCO32130 = "CZ_32130",
    CZISCO32141 = "CZ_32141",
    CZISCO32142 = "CZ_32142",
    CZISCO32143 = "CZ_32143",
    CZISCO32144 = "CZ_32144",
    CZISCO32149 = "CZ_32149",
    CZISCO32211 = "CZ_32211",
    CZISCO32213 = "CZ_32213",
    CZISCO32220 = "CZ_32220",
    CZISCO32300 = "CZ_32300",
    CZISCO32400 = "CZ_32400",
    CZISCO32510 = "CZ_32510",
    CZISCO32520 = "CZ_32520",
    CZISCO32530 = "CZ_32530",
    CZISCO32540 = "CZ_32540",
    CZISCO32551 = "CZ_32551",
    CZISCO32553 = "CZ_32553",
    CZISCO32559 = "CZ_32559",
    CZISCO32560 = "CZ_32560",
    CZISCO32570 = "CZ_32570",
    CZISCO32580 = "CZ_32580",
    CZISCO32591 = "CZ_32591",
    CZISCO32592 = "CZ_32592",
    CZISCO32593 = "CZ_32593",
    CZISCO32599 = "CZ_32599",
    CZISCO33110 = "CZ_33110",
    CZISCO33121 = "CZ_33121",
    CZISCO33122 = "CZ_33122",
    CZISCO33129 = "CZ_33129",
    CZISCO33131 = "CZ_33131",
    CZISCO33132 = "CZ_33132",
    CZISCO33133 = "CZ_33133",
    CZISCO33134 = "CZ_33134",
    CZISCO33135 = "CZ_33135",
    CZISCO33136 = "CZ_33136",
    CZISCO33137 = "CZ_33137",
    CZISCO33138 = "CZ_33138",
    CZISCO33139 = "CZ_33139",
    CZISCO33141 = "CZ_33141",
    CZISCO33142 = "CZ_33142",
    CZISCO33143 = "CZ_33143",
    CZISCO33151 = "CZ_33151",
    CZISCO33152 = "CZ_33152",
    CZISCO33211 = "CZ_33211",
    CZISCO33212 = "CZ_33212",
    CZISCO33219 = "CZ_33219",
    CZISCO33220 = "CZ_33220",
    CZISCO33230 = "CZ_33230",
    CZISCO33240 = "CZ_33240",
    CZISCO33311 = "CZ_33311",
    CZISCO33312 = "CZ_33312",
    CZISCO33313 = "CZ_33313",
    CZISCO33320 = "CZ_33320",
    CZISCO33331 = "CZ_33331",
    CZISCO33332 = "CZ_33332",
    CZISCO33333 = "CZ_33333",
    CZISCO33334 = "CZ_33334",
    CZISCO33335 = "CZ_33335",
    CZISCO33336 = "CZ_33336",
    CZISCO33337 = "CZ_33337",
    CZISCO33339 = "CZ_33339",
    CZISCO33340 = "CZ_33340",
    CZISCO33391 = "CZ_33391",
    CZISCO33392 = "CZ_33392",
    CZISCO33393 = "CZ_33393",
    CZISCO33394 = "CZ_33394",
    CZISCO33395 = "CZ_33395",
    CZISCO33396 = "CZ_33396",
    CZISCO33397 = "CZ_33397",
    CZISCO33399 = "CZ_33399",
    CZISCO33411 = "CZ_33411",
    CZISCO33412 = "CZ_33412",
    CZISCO33413 = "CZ_33413",
    CZISCO33414 = "CZ_33414",
    CZISCO33415 = "CZ_33415",
    CZISCO33416 = "CZ_33416",
    CZISCO33417 = "CZ_33417",
    CZISCO33419 = "CZ_33419",
    CZISCO33420 = "CZ_33420",
    CZISCO33431 = "CZ_33431",
    CZISCO33432 = "CZ_33432",
    CZISCO33433 = "CZ_33433",
    CZISCO33434 = "CZ_33434",
    CZISCO33435 = "CZ_33435",
    CZISCO33436 = "CZ_33436",
    CZISCO33437 = "CZ_33437",
    CZISCO33438 = "CZ_33438",
    CZISCO33439 = "CZ_33439",
    CZISCO33440 = "CZ_33440",
    CZISCO33511 = "CZ_33511",
    CZISCO33512 = "CZ_33512",
    CZISCO33513 = "CZ_33513",
    CZISCO33514 = "CZ_33514",
    CZISCO33515 = "CZ_33515",
    CZISCO33516 = "CZ_33516",
    CZISCO33517 = "CZ_33517",
    CZISCO33518 = "CZ_33518",
    CZISCO33519 = "CZ_33519",
    CZISCO33520 = "CZ_33520",
    CZISCO33530 = "CZ_33530",
    CZISCO33540 = "CZ_33540",
    CZISCO33551 = "CZ_33551",
    CZISCO33552 = "CZ_33552",
    CZISCO33553 = "CZ_33553",
    CZISCO33554 = "CZ_33554",
    CZISCO33555 = "CZ_33555",
    CZISCO33590 = "CZ_33590",
    CZISCO34111 = "CZ_34111",
    CZISCO34112 = "CZ_34112",
    CZISCO34113 = "CZ_34113",
    CZISCO34119 = "CZ_34119",
    CZISCO34121 = "CZ_34121",
    CZISCO34122 = "CZ_34122",
    CZISCO34123 = "CZ_34123",
    CZISCO34124 = "CZ_34124",
    CZISCO34125 = "CZ_34125",
    CZISCO34126 = "CZ_34126",
    CZISCO34127 = "CZ_34127",
    CZISCO34129 = "CZ_34129",
    CZISCO34130 = "CZ_34130",
    CZISCO34210 = "CZ_34210",
    CZISCO34221 = "CZ_34221",
    CZISCO34222 = "CZ_34222",
    CZISCO34223 = "CZ_34223",
    CZISCO34230 = "CZ_34230",
    CZISCO34311 = "CZ_34311",
    CZISCO34312 = "CZ_34312",
    CZISCO34313 = "CZ_34313",
    CZISCO34319 = "CZ_34319",
    CZISCO34321 = "CZ_34321",
    CZISCO34322 = "CZ_34322",
    CZISCO34323 = "CZ_34323",
    CZISCO34324 = "CZ_34324",
    CZISCO34325 = "CZ_34325",
    CZISCO34329 = "CZ_34329",
    CZISCO34331 = "CZ_34331",
    CZISCO34332 = "CZ_34332",
    CZISCO34333 = "CZ_34333",
    CZISCO34334 = "CZ_34334",
    CZISCO34339 = "CZ_34339",
    CZISCO34341 = "CZ_34341",
    CZISCO34342 = "CZ_34342",
    CZISCO34343 = "CZ_34343",
    CZISCO34344 = "CZ_34344",
    CZISCO34349 = "CZ_34349",
    CZISCO34351 = "CZ_34351",
    CZISCO34352 = "CZ_34352",
    CZISCO34353 = "CZ_34353",
    CZISCO34354 = "CZ_34354",
    CZISCO34355 = "CZ_34355",
    CZISCO34359 = "CZ_34359",
    CZISCO35110 = "CZ_35110",
    CZISCO35120 = "CZ_35120",
    CZISCO35130 = "CZ_35130",
    CZISCO35140 = "CZ_35140",
    CZISCO35211 = "CZ_35211",
    CZISCO35212 = "CZ_35212",
    CZISCO35213 = "CZ_35213",
    CZISCO35214 = "CZ_35214",
    CZISCO35219 = "CZ_35219",
    CZISCO35221 = "CZ_35221",
    CZISCO35222 = "CZ_35222",
    CZISCO35223 = "CZ_35223",
    CZISCO35224 = "CZ_35224",
    CZISCO35225 = "CZ_35225",
    CZISCO35226 = "CZ_35226",
    CZISCO35227 = "CZ_35227",
    CZISCO35228 = "CZ_35228",
    CZISCO35229 = "CZ_35229",
    CZISCO41100 = "CZ_41100",
    CZISCO41200 = "CZ_41200",
    CZISCO41311 = "CZ_41311",
    CZISCO41312 = "CZ_41312",
    CZISCO41321 = "CZ_41321",
    CZISCO41322 = "CZ_41322",
    CZISCO41323 = "CZ_41323",
    CZISCO42111 = "CZ_42111",
    CZISCO42112 = "CZ_42112",
    CZISCO42113 = "CZ_42113",
    CZISCO42114 = "CZ_42114",
    CZISCO42119 = "CZ_42119",
    CZISCO42121 = "CZ_42121",
    CZISCO42122 = "CZ_42122",
    CZISCO42123 = "CZ_42123",
    CZISCO42124 = "CZ_42124",
    CZISCO42130 = "CZ_42130",
    CZISCO42140 = "CZ_42140",
    CZISCO42211 = "CZ_42211",
    CZISCO42212 = "CZ_42212",
    CZISCO42219 = "CZ_42219",
    CZISCO42220 = "CZ_42220",
    CZISCO42230 = "CZ_42230",
    CZISCO42240 = "CZ_42240",
    CZISCO42250 = "CZ_42250",
    CZISCO42260 = "CZ_42260",
    CZISCO42270 = "CZ_42270",
    CZISCO42290 = "CZ_42290",
    CZISCO43111 = "CZ_43111",
    CZISCO43112 = "CZ_43112",
    CZISCO43113 = "CZ_43113",
    CZISCO43114 = "CZ_43114",
    CZISCO43115 = "CZ_43115",
    CZISCO43119 = "CZ_43119",
    CZISCO43121 = "CZ_43121",
    CZISCO43122 = "CZ_43122",
    CZISCO43123 = "CZ_43123",
    CZISCO43124 = "CZ_43124",
    CZISCO43125 = "CZ_43125",
    CZISCO43129 = "CZ_43129",
    CZISCO43130 = "CZ_43130",
    CZISCO43210 = "CZ_43210",
    CZISCO43220 = "CZ_43220",
    CZISCO43231 = "CZ_43231",
    CZISCO43232 = "CZ_43232",
    CZISCO43233 = "CZ_43233",
    CZISCO43234 = "CZ_43234",
    CZISCO43235 = "CZ_43235",
    CZISCO43236 = "CZ_43236",
    CZISCO43237 = "CZ_43237",
    CZISCO43238 = "CZ_43238",
    CZISCO43239 = "CZ_43239",
    CZISCO44110 = "CZ_44110",
    CZISCO44121 = "CZ_44121",
    CZISCO44122 = "CZ_44122",
    CZISCO44123 = "CZ_44123",
    CZISCO44124 = "CZ_44124",
    CZISCO44125 = "CZ_44125",
    CZISCO44126 = "CZ_44126",
    CZISCO44129 = "CZ_44129",
    CZISCO44130 = "CZ_44130",
    CZISCO44150 = "CZ_44150",
    CZISCO44160 = "CZ_44160",
    CZISCO44191 = "CZ_44191",
    CZISCO44192 = "CZ_44192",
    CZISCO44193 = "CZ_44193",
    CZISCO44194 = "CZ_44194",
    CZISCO44199 = "CZ_44199",
    CZISCO51111 = "CZ_51111",
    CZISCO51112 = "CZ_51112",
    CZISCO51121 = "CZ_51121",
    CZISCO51122 = "CZ_51122",
    CZISCO51123 = "CZ_51123",
    CZISCO51129 = "CZ_51129",
    CZISCO51131 = "CZ_51131",
    CZISCO51132 = "CZ_51132",
    CZISCO51133 = "CZ_51133",
    CZISCO51139 = "CZ_51139",
    CZISCO51201 = "CZ_51201",
    CZISCO51202 = "CZ_51202",
    CZISCO51203 = "CZ_51203",
    CZISCO51310 = "CZ_51310",
    CZISCO51321 = "CZ_51321",
    CZISCO51322 = "CZ_51322",
    CZISCO51329 = "CZ_51329",
    CZISCO51410 = "CZ_51410",
    CZISCO51421 = "CZ_51421",
    CZISCO51422 = "CZ_51422",
    CZISCO51423 = "CZ_51423",
    CZISCO51429 = "CZ_51429",
    CZISCO51511 = "CZ_51511",
    CZISCO51512 = "CZ_51512",
    CZISCO51513 = "CZ_51513",
    CZISCO51519 = "CZ_51519",
    CZISCO51521 = "CZ_51521",
    CZISCO51522 = "CZ_51522",
    CZISCO51530 = "CZ_51530",
    CZISCO51610 = "CZ_51610",
    CZISCO51620 = "CZ_51620",
    CZISCO51630 = "CZ_51630",
    CZISCO51641 = "CZ_51641",
    CZISCO51642 = "CZ_51642",
    CZISCO51643 = "CZ_51643",
    CZISCO51644 = "CZ_51644",
    CZISCO51645 = "CZ_51645",
    CZISCO51649 = "CZ_51649",
    CZISCO51650 = "CZ_51650",
    CZISCO51690 = "CZ_51690",
    CZISCO52110 = "CZ_52110",
    CZISCO52120 = "CZ_52120",
    CZISCO52210 = "CZ_52210",
    CZISCO52220 = "CZ_52220",
    CZISCO52231 = "CZ_52231",
    CZISCO52232 = "CZ_52232",
    CZISCO52233 = "CZ_52233",
    CZISCO52234 = "CZ_52234",
    CZISCO52235 = "CZ_52235",
    CZISCO52236 = "CZ_52236",
    CZISCO52237 = "CZ_52237",
    CZISCO52238 = "CZ_52238",
    CZISCO52239 = "CZ_52239",
    CZISCO52301 = "CZ_52301",
    CZISCO52302 = "CZ_52302",
    CZISCO52303 = "CZ_52303",
    CZISCO52304 = "CZ_52304",
    CZISCO52305 = "CZ_52305",
    CZISCO52309 = "CZ_52309",
    CZISCO52410 = "CZ_52410",
    CZISCO52420 = "CZ_52420",
    CZISCO52430 = "CZ_52430",
    CZISCO52440 = "CZ_52440",
    CZISCO52450 = "CZ_52450",
    CZISCO52460 = "CZ_52460",
    CZISCO52491 = "CZ_52491",
    CZISCO52499 = "CZ_52499",
    CZISCO53111 = "CZ_53111",
    CZISCO53112 = "CZ_53112",
    CZISCO53113 = "CZ_53113",
    CZISCO53119 = "CZ_53119",
    CZISCO53121 = "CZ_53121",
    CZISCO53122 = "CZ_53122",
    CZISCO53123 = "CZ_53123",
    CZISCO53211 = "CZ_53211",
    CZISCO53212 = "CZ_53212",
    CZISCO53213 = "CZ_53213",
    CZISCO53219 = "CZ_53219",
    CZISCO53221 = "CZ_53221",
    CZISCO53222 = "CZ_53222",
    CZISCO53223 = "CZ_53223",
    CZISCO53229 = "CZ_53229",
    CZISCO53293 = "CZ_53293",
    CZISCO53294 = "CZ_53294",
    CZISCO53295 = "CZ_53295",
    CZISCO53296 = "CZ_53296",
    CZISCO53299 = "CZ_53299",
    CZISCO54111 = "CZ_54111",
    CZISCO54112 = "CZ_54112",
    CZISCO54113 = "CZ_54113",
    CZISCO54114 = "CZ_54114",
    CZISCO54115 = "CZ_54115",
    CZISCO54116 = "CZ_54116",
    CZISCO54119 = "CZ_54119",
    CZISCO54121 = "CZ_54121",
    CZISCO54122 = "CZ_54122",
    CZISCO54123 = "CZ_54123",
    CZISCO54124 = "CZ_54124",
    CZISCO54125 = "CZ_54125",
    CZISCO54131 = "CZ_54131",
    CZISCO54132 = "CZ_54132",
    CZISCO54133 = "CZ_54133",
    CZISCO54134 = "CZ_54134",
    CZISCO54135 = "CZ_54135",
    CZISCO54136 = "CZ_54136",
    CZISCO54137 = "CZ_54137",
    CZISCO54138 = "CZ_54138",
    CZISCO54139 = "CZ_54139",
    CZISCO54141 = "CZ_54141",
    CZISCO54142 = "CZ_54142",
    CZISCO54143 = "CZ_54143",
    CZISCO54144 = "CZ_54144",
    CZISCO54149 = "CZ_54149",
    CZISCO54191 = "CZ_54191",
    CZISCO54192 = "CZ_54192",
    CZISCO54193 = "CZ_54193",
    CZISCO54194 = "CZ_54194",
    CZISCO54199 = "CZ_54199",
    CZISCO61110 = "CZ_61110",
    CZISCO61120 = "CZ_61120",
    CZISCO61131 = "CZ_61131",
    CZISCO61132 = "CZ_61132",
    CZISCO61133 = "CZ_61133",
    CZISCO61134 = "CZ_61134",
    CZISCO61135 = "CZ_61135",
    CZISCO61136 = "CZ_61136",
    CZISCO61139 = "CZ_61139",
    CZISCO61140 = "CZ_61140",
    CZISCO61211 = "CZ_61211",
    CZISCO61212 = "CZ_61212",
    CZISCO61213 = "CZ_61213",
    CZISCO61214 = "CZ_61214",
    CZISCO61219 = "CZ_61219",
    CZISCO61220 = "CZ_61220",
    CZISCO61230 = "CZ_61230",
    CZISCO61290 = "CZ_61290",
    CZISCO61300 = "CZ_61300",
    CZISCO62101 = "CZ_62101",
    CZISCO62102 = "CZ_62102",
    CZISCO62109 = "CZ_62109",
    CZISCO62210 = "CZ_62210",
    CZISCO62220 = "CZ_62220",
    CZISCO62230 = "CZ_62230",
    CZISCO62240 = "CZ_62240",
    CZISCO63100 = "CZ_63100",
    CZISCO63200 = "CZ_63200",
    CZISCO63300 = "CZ_63300",
    CZISCO63400 = "CZ_63400",
    CZISCO71110 = "CZ_71110",
    CZISCO71121 = "CZ_71121",
    CZISCO71122 = "CZ_71122",
    CZISCO71123 = "CZ_71123",
    CZISCO71124 = "CZ_71124",
    CZISCO71130 = "CZ_71130",
    CZISCO71140 = "CZ_71140",
    CZISCO71151 = "CZ_71151",
    CZISCO71152 = "CZ_71152",
    CZISCO71191 = "CZ_71191",
    CZISCO71192 = "CZ_71192",
    CZISCO71193 = "CZ_71193",
    CZISCO71194 = "CZ_71194",
    CZISCO71195 = "CZ_71195",
    CZISCO71199 = "CZ_71199",
    CZISCO71210 = "CZ_71210",
    CZISCO71221 = "CZ_71221",
    CZISCO71222 = "CZ_71222",
    CZISCO71223 = "CZ_71223",
    CZISCO71231 = "CZ_71231",
    CZISCO71232 = "CZ_71232",
    CZISCO71240 = "CZ_71240",
    CZISCO71250 = "CZ_71250",
    CZISCO71261 = "CZ_71261",
    CZISCO71262 = "CZ_71262",
    CZISCO71263 = "CZ_71263",
    CZISCO71264 = "CZ_71264",
    CZISCO71265 = "CZ_71265",
    CZISCO71266 = "CZ_71266",
    CZISCO71267 = "CZ_71267",
    CZISCO71270 = "CZ_71270",
    CZISCO71311 = "CZ_71311",
    CZISCO71312 = "CZ_71312",
    CZISCO71313 = "CZ_71313",
    CZISCO71321 = "CZ_71321",
    CZISCO71322 = "CZ_71322",
    CZISCO71323 = "CZ_71323",
    CZISCO71324 = "CZ_71324",
    CZISCO71329 = "CZ_71329",
    CZISCO71331 = "CZ_71331",
    CZISCO71332 = "CZ_71332",
    CZISCO71339 = "CZ_71339",
    CZISCO72111 = "CZ_72111",
    CZISCO72112 = "CZ_72112",
    CZISCO72113 = "CZ_72113",
    CZISCO72121 = "CZ_72121",
    CZISCO72122 = "CZ_72122",
    CZISCO72123 = "CZ_72123",
    CZISCO72131 = "CZ_72131",
    CZISCO72132 = "CZ_72132",
    CZISCO72133 = "CZ_72133",
    CZISCO72139 = "CZ_72139",
    CZISCO72140 = "CZ_72140",
    CZISCO72150 = "CZ_72150",
    CZISCO72210 = "CZ_72210",
    CZISCO72221 = "CZ_72221",
    CZISCO72222 = "CZ_72222",
    CZISCO72223 = "CZ_72223",
    CZISCO72224 = "CZ_72224",
    CZISCO72225 = "CZ_72225",
    CZISCO72226 = "CZ_72226",
    CZISCO72229 = "CZ_72229",
    CZISCO72231 = "CZ_72231",
    CZISCO72232 = "CZ_72232",
    CZISCO72233 = "CZ_72233",
    CZISCO72234 = "CZ_72234",
    CZISCO72235 = "CZ_72235",
    CZISCO72236 = "CZ_72236",
    CZISCO72237 = "CZ_72237",
    CZISCO72239 = "CZ_72239",
    CZISCO72241 = "CZ_72241",
    CZISCO72242 = "CZ_72242",
    CZISCO72243 = "CZ_72243",
    CZISCO72311 = "CZ_72311",
    CZISCO72312 = "CZ_72312",
    CZISCO72313 = "CZ_72313",
    CZISCO72314 = "CZ_72314",
    CZISCO72319 = "CZ_72319",
    CZISCO72320 = "CZ_72320",
    CZISCO72331 = "CZ_72331",
    CZISCO72332 = "CZ_72332",
    CZISCO72333 = "CZ_72333",
    CZISCO72334 = "CZ_72334",
    CZISCO72335 = "CZ_72335",
    CZISCO72336 = "CZ_72336",
    CZISCO72337 = "CZ_72337",
    CZISCO72339 = "CZ_72339",
    CZISCO72340 = "CZ_72340",
    CZISCO73111 = "CZ_73111",
    CZISCO73112 = "CZ_73112",
    CZISCO73113 = "CZ_73113",
    CZISCO73119 = "CZ_73119",
    CZISCO73121 = "CZ_73121",
    CZISCO73122 = "CZ_73122",
    CZISCO73130 = "CZ_73130",
    CZISCO73141 = "CZ_73141",
    CZISCO73142 = "CZ_73142",
    CZISCO73149 = "CZ_73149",
    CZISCO73151 = "CZ_73151",
    CZISCO73152 = "CZ_73152",
    CZISCO73153 = "CZ_73153",
    CZISCO73154 = "CZ_73154",
    CZISCO73155 = "CZ_73155",
    CZISCO73161 = "CZ_73161",
    CZISCO73162 = "CZ_73162",
    CZISCO73163 = "CZ_73163",
    CZISCO73169 = "CZ_73169",
    CZISCO73171 = "CZ_73171",
    CZISCO73172 = "CZ_73172",
    CZISCO73173 = "CZ_73173",
    CZISCO73179 = "CZ_73179",
    CZISCO73180 = "CZ_73180",
    CZISCO73191 = "CZ_73191",
    CZISCO73192 = "CZ_73192",
    CZISCO73193 = "CZ_73193",
    CZISCO73199 = "CZ_73199",
    CZISCO73210 = "CZ_73210",
    CZISCO73220 = "CZ_73220",
    CZISCO73230 = "CZ_73230",
    CZISCO74110 = "CZ_74110",
    CZISCO74121 = "CZ_74121",
    CZISCO74122 = "CZ_74122",
    CZISCO74123 = "CZ_74123",
    CZISCO74131 = "CZ_74131",
    CZISCO74132 = "CZ_74132",
    CZISCO74210 = "CZ_74210",
    CZISCO74220 = "CZ_74220",
    CZISCO75111 = "CZ_75111",
    CZISCO75112 = "CZ_75112",
    CZISCO75119 = "CZ_75119",
    CZISCO75121 = "CZ_75121",
    CZISCO75122 = "CZ_75122",
    CZISCO75123 = "CZ_75123",
    CZISCO75131 = "CZ_75131",
    CZISCO75132 = "CZ_75132",
    CZISCO75139 = "CZ_75139",
    CZISCO75140 = "CZ_75140",
    CZISCO75151 = "CZ_75151",
    CZISCO75152 = "CZ_75152",
    CZISCO75153 = "CZ_75153",
    CZISCO75154 = "CZ_75154",
    CZISCO75160 = "CZ_75160",
    CZISCO75210 = "CZ_75210",
    CZISCO75220 = "CZ_75220",
    CZISCO75231 = "CZ_75231",
    CZISCO75232 = "CZ_75232",
    CZISCO75311 = "CZ_75311",
    CZISCO75312 = "CZ_75312",
    CZISCO75313 = "CZ_75313",
    CZISCO75321 = "CZ_75321",
    CZISCO75322 = "CZ_75322",
    CZISCO75323 = "CZ_75323",
    CZISCO75329 = "CZ_75329",
    CZISCO75330 = "CZ_75330",
    CZISCO75341 = "CZ_75341",
    CZISCO75342 = "CZ_75342",
    CZISCO75343 = "CZ_75343",
    CZISCO75349 = "CZ_75349",
    CZISCO75350 = "CZ_75350",
    CZISCO75361 = "CZ_75361",
    CZISCO75362 = "CZ_75362",
    CZISCO75363 = "CZ_75363",
    CZISCO75369 = "CZ_75369",
    CZISCO75410 = "CZ_75410",
    CZISCO75420 = "CZ_75420",
    CZISCO75430 = "CZ_75430",
    CZISCO75440 = "CZ_75440",
    CZISCO75491 = "CZ_75491",
    CZISCO75492 = "CZ_75492",
    CZISCO75499 = "CZ_75499",
    CZISCO81111 = "CZ_81111",
    CZISCO81112 = "CZ_81112",
    CZISCO81113 = "CZ_81113",
    CZISCO81114 = "CZ_81114",
    CZISCO81115 = "CZ_81115",
    CZISCO81116 = "CZ_81116",
    CZISCO81117 = "CZ_81117",
    CZISCO81118 = "CZ_81118",
    CZISCO81119 = "CZ_81119",
    CZISCO81121 = "CZ_81121",
    CZISCO81122 = "CZ_81122",
    CZISCO81131 = "CZ_81131",
    CZISCO81132 = "CZ_81132",
    CZISCO81133 = "CZ_81133",
    CZISCO81139 = "CZ_81139",
    CZISCO81141 = "CZ_81141",
    CZISCO81142 = "CZ_81142",
    CZISCO81149 = "CZ_81149",
    CZISCO81211 = "CZ_81211",
    CZISCO81212 = "CZ_81212",
    CZISCO81213 = "CZ_81213",
    CZISCO81214 = "CZ_81214",
    CZISCO81215 = "CZ_81215",
    CZISCO81216 = "CZ_81216",
    CZISCO81219 = "CZ_81219",
    CZISCO81221 = "CZ_81221",
    CZISCO81222 = "CZ_81222",
    CZISCO81311 = "CZ_81311",
    CZISCO81312 = "CZ_81312",
    CZISCO81313 = "CZ_81313",
    CZISCO81314 = "CZ_81314",
    CZISCO81315 = "CZ_81315",
    CZISCO81316 = "CZ_81316",
    CZISCO81317 = "CZ_81317",
    CZISCO81319 = "CZ_81319",
    CZISCO81321 = "CZ_81321",
    CZISCO81322 = "CZ_81322",
    CZISCO81410 = "CZ_81410",
    CZISCO81420 = "CZ_81420",
    CZISCO81430 = "CZ_81430",
    CZISCO81510 = "CZ_81510",
    CZISCO81521 = "CZ_81521",
    CZISCO81522 = "CZ_81522",
    CZISCO81530 = "CZ_81530",
    CZISCO81540 = "CZ_81540",
    CZISCO81550 = "CZ_81550",
    CZISCO81561 = "CZ_81561",
    CZISCO81562 = "CZ_81562",
    CZISCO81569 = "CZ_81569",
    CZISCO81570 = "CZ_81570",
    CZISCO81591 = "CZ_81591",
    CZISCO81592 = "CZ_81592",
    CZISCO81599 = "CZ_81599",
    CZISCO81601 = "CZ_81601",
    CZISCO81602 = "CZ_81602",
    CZISCO81603 = "CZ_81603",
    CZISCO81604 = "CZ_81604",
    CZISCO81605 = "CZ_81605",
    CZISCO81606 = "CZ_81606",
    CZISCO81607 = "CZ_81607",
    CZISCO81608 = "CZ_81608",
    CZISCO81609 = "CZ_81609",
    CZISCO81710 = "CZ_81710",
    CZISCO81720 = "CZ_81720",
    CZISCO81811 = "CZ_81811",
    CZISCO81812 = "CZ_81812",
    CZISCO81813 = "CZ_81813",
    CZISCO81814 = "CZ_81814",
    CZISCO81821 = "CZ_81821",
    CZISCO81822 = "CZ_81822",
    CZISCO81823 = "CZ_81823",
    CZISCO81824 = "CZ_81824",
    CZISCO81825 = "CZ_81825",
    CZISCO81829 = "CZ_81829",
    CZISCO81830 = "CZ_81830",
    CZISCO81891 = "CZ_81891",
    CZISCO81892 = "CZ_81892",
    CZISCO81893 = "CZ_81893",
    CZISCO81894 = "CZ_81894",
    CZISCO81895 = "CZ_81895",
    CZISCO81896 = "CZ_81896",
    CZISCO81897 = "CZ_81897",
    CZISCO81899 = "CZ_81899",
    CZISCO82110 = "CZ_82110",
    CZISCO82121 = "CZ_82121",
    CZISCO82122 = "CZ_82122",
    CZISCO82191 = "CZ_82191",
    CZISCO82192 = "CZ_82192",
    CZISCO82193 = "CZ_82193",
    CZISCO82194 = "CZ_82194",
    CZISCO82195 = "CZ_82195",
    CZISCO82196 = "CZ_82196",
    CZISCO82197 = "CZ_82197",
    CZISCO82199 = "CZ_82199",
    CZISCO83111 = "CZ_83111",
    CZISCO83112 = "CZ_83112",
    CZISCO83113 = "CZ_83113",
    CZISCO83114 = "CZ_83114",
    CZISCO83119 = "CZ_83119",
    CZISCO83121 = "CZ_83121",
    CZISCO83122 = "CZ_83122",
    CZISCO83123 = "CZ_83123",
    CZISCO83124 = "CZ_83124",
    CZISCO83125 = "CZ_83125",
    CZISCO83126 = "CZ_83126",
    CZISCO83127 = "CZ_83127",
    CZISCO83128 = "CZ_83128",
    CZISCO83129 = "CZ_83129",
    CZISCO83210 = "CZ_83210",
    CZISCO83221 = "CZ_83221",
    CZISCO83222 = "CZ_83222",
    CZISCO83223 = "CZ_83223",
    CZISCO83311 = "CZ_83311",
    CZISCO83312 = "CZ_83312",
    CZISCO83313 = "CZ_83313",
    CZISCO83314 = "CZ_83314",
    CZISCO83321 = "CZ_83321",
    CZISCO83322 = "CZ_83322",
    CZISCO83323 = "CZ_83323",
    CZISCO83324 = "CZ_83324",
    CZISCO83325 = "CZ_83325",
    CZISCO83326 = "CZ_83326",
    CZISCO83329 = "CZ_83329",
    CZISCO83411 = "CZ_83411",
    CZISCO83412 = "CZ_83412",
    CZISCO83421 = "CZ_83421",
    CZISCO83422 = "CZ_83422",
    CZISCO83431 = "CZ_83431",
    CZISCO83432 = "CZ_83432",
    CZISCO83433 = "CZ_83433",
    CZISCO83434 = "CZ_83434",
    CZISCO83439 = "CZ_83439",
    CZISCO83441 = "CZ_83441",
    CZISCO83442 = "CZ_83442",
    CZISCO83443 = "CZ_83443",
    CZISCO83449 = "CZ_83449",
    CZISCO83501 = "CZ_83501",
    CZISCO83502 = "CZ_83502",
    CZISCO83509 = "CZ_83509",
    CZISCO91110 = "CZ_91110",
    CZISCO91121 = "CZ_91121",
    CZISCO91122 = "CZ_91122",
    CZISCO91123 = "CZ_91123",
    CZISCO91124 = "CZ_91124",
    CZISCO91125 = "CZ_91125",
    CZISCO91126 = "CZ_91126",
    CZISCO91127 = "CZ_91127",
    CZISCO91128 = "CZ_91128",
    CZISCO91129 = "CZ_91129",
    CZISCO91210 = "CZ_91210",
    CZISCO91220 = "CZ_91220",
    CZISCO91230 = "CZ_91230",
    CZISCO91290 = "CZ_91290",
    CZISCO92110 = "CZ_92110",
    CZISCO92120 = "CZ_92120",
    CZISCO92130 = "CZ_92130",
    CZISCO92140 = "CZ_92140",
    CZISCO92150 = "CZ_92150",
    CZISCO92160 = "CZ_92160",
    CZISCO93111 = "CZ_93111",
    CZISCO93112 = "CZ_93112",
    CZISCO93113 = "CZ_93113",
    CZISCO93114 = "CZ_93114",
    CZISCO93115 = "CZ_93115",
    CZISCO93119 = "CZ_93119",
    CZISCO93121 = "CZ_93121",
    CZISCO93122 = "CZ_93122",
    CZISCO93123 = "CZ_93123",
    CZISCO93130 = "CZ_93130",
    CZISCO93210 = "CZ_93210",
    CZISCO93291 = "CZ_93291",
    CZISCO93292 = "CZ_93292",
    CZISCO93293 = "CZ_93293",
    CZISCO93294 = "CZ_93294",
    CZISCO93299 = "CZ_93299",
    CZISCO93310 = "CZ_93310",
    CZISCO93320 = "CZ_93320",
    CZISCO93331 = "CZ_93331",
    CZISCO93332 = "CZ_93332",
    CZISCO93333 = "CZ_93333",
    CZISCO93334 = "CZ_93334",
    CZISCO93339 = "CZ_93339",
    CZISCO93340 = "CZ_93340",
    CZISCO94111 = "CZ_94111",
    CZISCO94112 = "CZ_94112",
    CZISCO94119 = "CZ_94119",
    CZISCO94120 = "CZ_94120",
    CZISCO95100 = "CZ_95100",
    CZISCO95200 = "CZ_95200",
    CZISCO96110 = "CZ_96110",
    CZISCO96120 = "CZ_96120",
    CZISCO96131 = "CZ_96131",
    CZISCO96132 = "CZ_96132",
    CZISCO96139 = "CZ_96139",
    CZISCO96210 = "CZ_96210",
    CZISCO96220 = "CZ_96220",
    CZISCO96230 = "CZ_96230",
    CZISCO96291 = "CZ_96291",
    CZISCO96292 = "CZ_96292",
    CZISCO96293 = "CZ_96293",
    CZISCO96294 = "CZ_96294",
    CZISCO96299 = "CZ_96299",
}

export enum DateFormatCode {
    DaysMonthsYearsDots = "DaysMonthsYearsDots",
    DaysMonthsYearsSlashes = "DaysMonthsYearsSlashes",
    DaysMonthsYearsHyphens = "DaysMonthsYearsHyphens",
    MonthsDaysYearsDots = "MonthsDaysYearsDots",
    MonthsDaysYearsSlashes = "MonthsDaysYearsSlashes",
    MonthsDaysYearsHyphens = "MonthsDaysYearsHyphens",
    YearsMonthsDaysDots = "YearsMonthsDaysDots",
    YearsMonthsDaysSlashes = "YearsMonthsDaysSlashes",
    YearsMonthsDaysHyphens = "YearsMonthsDaysHyphens",
}

export enum DayOfWeekCode {
    Friday = "FRI",
    Monday = "MON",
    Saturday = "SAT",
    Sunday = "SUN",
    Thursday = "THU",
    Tuesday = "TUE",
    Wednesday = "WED",
}

export enum DeferredPlanPostingTypeCode {
    Monthly = "Monthly",
    Yearly = "Yearly",
}

export enum DepreciationPolicyTypeCode {
    TaxDepreciation = "TAX",
    AccountingDepreciation = "ACCOUNTING",
}

export enum DepreciationSettingTypeCode {
    Interrupted = "INTERRUPTED",
    Partial = "PARTIAL",
}

export enum DepreciationTypeCode {
    Linear = "LINEAR",
    Accelerated = "ACCELERATED",
    TimeDependent = "TIMED",
}

export enum DocumentBusinessPartnerTypeCode {
    BusinessPartner = "BusinessPartner",
    Employee = "Employee",
}

export enum DocumentImportTypeCode {
    Isdoc = "Isdoc",
    MoneyS3 = "MoneyS3",
    Pohoda = "Pohoda",
}

export enum DocumentItemTypeCode {
    PaymentPostingItem = "PaymentDocumentItem",
    RegularDocumentItem = "RegularDocumentItem",
    InternalDocumentItem = "InternalDocumentItem",
}

export enum DocumentLinkClearingTypeCode {
    Both = "All",
    None = "None",
    SourceDocument = "SourceDocument",
    TargetDocument = "TargetDocument",
}

export enum DocumentLinkTypeCode {
    DF = "DF",
    CRC = "CRC",
    CRN = "CRN",
    PM = "PM",
    IDCL = "IDCL",
    EXRG = "EXRG",
    EXRL = "EXRL",
    RA = "RA",
    RAS = "RAS",
    RAC = "RAC",
    RACC = "RACC",
    RAEX = "RAEX",
    WOT = "WOT",
    WON = "WON",
    DE = "DE",
    AE = "AE",
    AES = "AES",
    DR = "DR",
    AR = "AR",
    ARS = "ARS",
    EDR = "EDR",
    EDRS = "EDRS",
    EAE = "EAE",
    EAES = "EAES",
    AVII = "AVII",
    AVIO = "AVIO",
    ATE = "ATE",
    PII = "PII",
    APIU = "APIU",
    PRCL = "PRCL",
}

export enum DocumentSourceTypeCode {
    Fakturoid = "Fakturoid",
    ISDOC = "ISDOC",
    Manual = "Manual",
    Money = "Money",
    Pohoda = "Pohoda",
    Rossum = "Rossum",
    IDoklad = "iDoklad",
}

export enum DocumentStatusCode {
    Posted = "P:_",
    NotCleared = "P:N",
    PartiallyCleared = "P:P",
    Cleared = "P:C",
    NotPosted = "N:_",
    NotPaid = "_:N",
    PartiallyPaid = "_:P",
    Paid = "_:C",
    Created = "_:_",
    NotPostedNotPaid = "N:N",
    NotPostedPartiallyPaid = "N:P",
    NotPostedPaid = "N:C",
}

export enum DocumentTypeCode {
    BankTransaction = "BankTransaction",
    CorrectiveInvoiceIssued = "CorrectiveInvoiceIssued",
    CorrectiveInvoiceReceived = "CorrectiveInvoiceReceived",
    InternalDocument = "InternalDocument",
    InvoiceIssued = "InvoiceIssued",
    InvoiceReceived = "InvoiceReceived",
    OtherLiability = "OtherLiability",
    OtherReceivable = "OtherReceivable",
    ProformaInvoiceIssued = "ProformaInvoiceIssued",
    ProformaInvoiceReceived = "ProformaInvoiceReceived",
    CashReceiptIssued = "CashReceiptIssued",
    CashReceiptReceived = "CashReceiptReceived",
    LoanTransaction = "LoanTransaction",
}

export enum ElectronicSubmissionSubmissionTypeCode {
    Amended = "Amended",
    Regular = "Regular",
}

export enum ElectronicSubmissionTypeCode {
    VatControlStatement = "VatControlSt",
    VatStatement = "VatSt",
    VatVIESStatement = "VatViesSt",
    VatOSSStatement = "VatOssSt",
}

export enum EntityPermissionLevelCode {
    Read = "R",
    Write_Create = "W",
    Delete = "D",
}

export enum EvalaZoomCode {
    S = "S",
    M = "M",
    L = "L",
}

export enum ExchangeRateTypeCode {
    DailyRate = "ByBank",
    FixedRate = "Fixed",
}

export enum ExpenseTaxRateCode {
    ZemědělskáALesníVýroba = "CzeAgriculture2010",
    ŘemeslnéŽivnosti = "CzeCrafts2010",
    Živnosti = "CzeTrade2010",
    JináPodnikáníPráva_Autoři____ = "CzeOtherProfessions2010",
    Pronájem = "CzeRent2010",
}

export enum ExportRangeCode {
    All = "All",
    CurrentFiscalYear = "CurrentFiscalYear",
    LastClosedFiscalYear = "LastClosedFiscalYear",
}

export enum ExportResultTypeCode {
    SeparatelyForEachRecord = "MultipleFiles",
    SingleFile = "SingleFile",
}

export enum ExportTypeCode {
    All = "All",
    Documents = "Documents",
    BankTransactions = "BankTransactions",
    CashReceipts = "CashReceipts",
}

export enum ExternalCorrectedDocumentTypeCode {
    Clear = "Clear",
    DontClear = "DontClear",
}

export enum FeatureCode {
    Payroll = "Payroll",
}

export enum FinancialReportLayoutCode {
    RozvahaPlatnáOd1_1_2018 = "CZ_BS2018",
    VýsledovkaDruhovéČleněníPlatnáOd1_1_2019 = "CZ_IS_N_2019",
    VýsledovkaÚčelovéČleněníPlatnáOd1_1_2019 = "CZ_IS_F_2019",
    RozvahaProSpolkyPlatnáOd1_1_2003 = "CZ_BS_NPO_2003",
    VýsledovkaProSpolkyPlatnáOd1_1_2003 = "CZ_IS_N_NPO_2003",
}

export enum FiscalYearCloseSectionTypeCode {
    Accrued = "Accrued",
    Asset = "Asset",
    Bank = "Bank",
    CashBox = "CashBox",
    DeferredPlan = "DeferredPlan",
    ExchangeRates = "ExchangeRates",
    FinalClosure = "FinalClosure",
    ForeignCurrencies = "ForeignCurrencies",
    Inventory = "Inventory",
    PayableReceivable = "PayableReceivable",
    ReceivableAdjustments = "ReceivableAdjustments",
    TaxStatement = "TaxStatement",
}

export enum FiscalYearStatusCode {
    Closed = "CD",
    Active = "AC",
    NotUsed = "NU",
}

export enum FulfilmentTypeCode {
    ReceivedTaxableFulfilments = "R",
    ExecutedTaxableFulfilments = "X",
}

export enum GeneralPermissionCode {
    CanExport = "CanExport",
    OrganizationManagement = "OrganizationManagement",
    CompanyManagement = "CompanyManagement",
    TemplateManagement = "TemplateManagement",
    Unlocking = "Unlocking",
    AuditTrail = "AuditTrail",
}

export enum GovernmentInstitutionCode {
    CZ_CSSA_110 = "CZ_CSSA_110",
    CZ_CSSA_111 = "CZ_CSSA_111",
    CZ_CSSA_112 = "CZ_CSSA_112",
    CZ_CSSA_113 = "CZ_CSSA_113",
    CZ_CSSA_114 = "CZ_CSSA_114",
    CZ_CSSA_115 = "CZ_CSSA_115",
    CZ_CSSA_116 = "CZ_CSSA_116",
    CZ_CSSA_117 = "CZ_CSSA_117",
    CZ_CSSA_118 = "CZ_CSSA_118",
    CZ_CSSA_119 = "CZ_CSSA_119",
    CZ_CSSA_121 = "CZ_CSSA_121",
    CZ_CSSA_122 = "CZ_CSSA_122",
    CZ_CSSA_123 = "CZ_CSSA_123",
    CZ_CSSA_220 = "CZ_CSSA_220",
    CZ_CSSA_221 = "CZ_CSSA_221",
    CZ_CSSA_222 = "CZ_CSSA_222",
    CZ_CSSA_223 = "CZ_CSSA_223",
    CZ_CSSA_224 = "CZ_CSSA_224",
    CZ_CSSA_225 = "CZ_CSSA_225",
    CZ_CSSA_226 = "CZ_CSSA_226",
    CZ_CSSA_227 = "CZ_CSSA_227",
    CZ_CSSA_228 = "CZ_CSSA_228",
    CZ_CSSA_229 = "CZ_CSSA_229",
    CZ_CSSA_230 = "CZ_CSSA_230",
    CZ_CSSA_231 = "CZ_CSSA_231",
    CZ_CSSA_332 = "CZ_CSSA_332",
    CZ_CSSA_333 = "CZ_CSSA_333",
    CZ_CSSA_334 = "CZ_CSSA_334",
    CZ_CSSA_335 = "CZ_CSSA_335",
    CZ_CSSA_336 = "CZ_CSSA_336",
    CZ_CSSA_337 = "CZ_CSSA_337",
    CZ_CSSA_338 = "CZ_CSSA_338",
    CZ_CSSA_339 = "CZ_CSSA_339",
    CZ_CSSA_440 = "CZ_CSSA_440",
    CZ_CSSA_441 = "CZ_CSSA_441",
    CZ_CSSA_442 = "CZ_CSSA_442",
    CZ_CSSA_443 = "CZ_CSSA_443",
    CZ_CSSA_444 = "CZ_CSSA_444",
    CZ_CSSA_445 = "CZ_CSSA_445",
    CZ_CSSA_446 = "CZ_CSSA_446",
    CZ_CSSA_447 = "CZ_CSSA_447",
    CZ_CSSA_448 = "CZ_CSSA_448",
    CZ_CSSA_449 = "CZ_CSSA_449",
    CZ_CSSA_550 = "CZ_CSSA_550",
    CZ_CSSA_551 = "CZ_CSSA_551",
    CZ_CSSA_552 = "CZ_CSSA_552",
    CZ_CSSA_553 = "CZ_CSSA_553",
    CZ_CSSA_554 = "CZ_CSSA_554",
    CZ_CSSA_555 = "CZ_CSSA_555",
    CZ_CSSA_556 = "CZ_CSSA_556",
    CZ_CSSA_557 = "CZ_CSSA_557",
    CZ_CSSA_558 = "CZ_CSSA_558",
    CZ_CSSA_559 = "CZ_CSSA_559",
    CZ_CSSA_660 = "CZ_CSSA_660",
    CZ_CSSA_661 = "CZ_CSSA_661",
    CZ_CSSA_662 = "CZ_CSSA_662",
    CZ_CSSA_663 = "CZ_CSSA_663",
    CZ_CSSA_664 = "CZ_CSSA_664",
    CZ_CSSA_665 = "CZ_CSSA_665",
    CZ_CSSA_666 = "CZ_CSSA_666",
    CZ_CSSA_667 = "CZ_CSSA_667",
    CZ_CSSA_668 = "CZ_CSSA_668",
    CZ_CSSA_669 = "CZ_CSSA_669",
    CZ_CSSA_670 = "CZ_CSSA_670",
    CZ_CSSA_771 = "CZ_CSSA_771",
    CZ_CSSA_772 = "CZ_CSSA_772",
    CZ_CSSA_773 = "CZ_CSSA_773",
    CZ_CSSA_774 = "CZ_CSSA_774",
    CZ_CSSA_775 = "CZ_CSSA_775",
    CZ_CSSA_776 = "CZ_CSSA_776",
    CZ_CSSA_777 = "CZ_CSSA_777",
    CZ_CSSA_778 = "CZ_CSSA_778",
    CZ_CSSA_779 = "CZ_CSSA_779",
    CZ_CSSA_780 = "CZ_CSSA_780",
    CZ_CSSA_781 = "CZ_CSSA_781",
    CZ_CSSA_782 = "CZ_CSSA_782",
    CZ_CSSA_783 = "CZ_CSSA_783",
    CZ_CSSA_784 = "CZ_CSSA_784",
    CZ_CSSA_884 = "CZ_CSSA_884",
    CZ_CSSA_885 = "CZ_CSSA_885",
    CZ_CSSA_886 = "CZ_CSSA_886",
    CZ_CSSA_887 = "CZ_CSSA_887",
    CZ_CSSA_888 = "CZ_CSSA_888",
    CZ_CSSA_889 = "CZ_CSSA_889",
    CZ_CSSA_890 = "CZ_CSSA_890",
    CZ_CSSA_891 = "CZ_CSSA_891",
    CZ_CSSA_892 = "CZ_CSSA_892",
    CZ_CSSA_893 = "CZ_CSSA_893",
    CZ_CSSA_894 = "CZ_CSSA_894",
    CZ_LO_krp_2 = "CZ_LO_krp_2",
    CZ_LO_ABC = "CZ_LO_ABC",
    CZ_LO_ABE = "CZ_LO_ABE",
    CZ_LO_ABF = "CZ_LO_ABF",
    CZ_LO_ABG = "CZ_LO_ABG",
    CZ_LO_ABI = "CZ_LO_ABI",
    CZ_LO_ABJ = "CZ_LO_ABJ",
    CZ_LO_krp_3 = "CZ_LO_krp_3",
    CZ_LO_BNA = "CZ_LO_BNA",
    CZ_LO_BEA = "CZ_LO_BEA",
    CZ_LO_KHD = "CZ_LO_KHD",
    CZ_LO_KOB = "CZ_LO_KOB",
    CZ_LO_PBC = "CZ_LO_PBC",
    CZ_LO_BEB = "CZ_LO_BEB",
    CZ_LO_KLA = "CZ_LO_KLA",
    CZ_LO_KOA = "CZ_LO_KOA",
    CZ_LO_MEB = "CZ_LO_MEB",
    CZ_LO_KHA = "CZ_LO_KHA",
    CZ_LO_MEA = "CZ_LO_MEA",
    CZ_LO_NBB = "CZ_LO_NBB",
    CZ_LO_MBA = "CZ_LO_MBA",
    CZ_LO_MBB = "CZ_LO_MBB",
    CZ_LO_MEC = "CZ_LO_MEC",
    CZ_LO_NBA = "CZ_LO_NBA",
    CZ_LO_PYA = "CZ_LO_PYA",
    CZ_LO_PBA = "CZ_LO_PBA",
    CZ_LO_RAA = "CZ_LO_RAA",
    CZ_LO_PBB = "CZ_LO_PBB",
    CZ_LO_KLB = "CZ_LO_KLB",
    CZ_LO_BNB = "CZ_LO_BNB",
    CZ_LO_krp_4 = "CZ_LO_krp_4",
    CZ_LO_STB = "CZ_LO_STB",
    CZ_LO_CBA = "CZ_LO_CBA",
    CZ_LO_CKA = "CZ_LO_CKA",
    CZ_LO_JHB = "CZ_LO_JHB",
    CZ_LO_JHA = "CZ_LO_JHA",
    CZ_LO_CKB = "CZ_LO_CKB",
    CZ_LO_PIC = "CZ_LO_PIC",
    CZ_LO_PIA = "CZ_LO_PIA",
    CZ_LO_PTA = "CZ_LO_PTA",
    CZ_LO_TAB = "CZ_LO_TAB",
    CZ_LO_STA = "CZ_LO_STA",
    CZ_LO_TAA = "CZ_LO_TAA",
    CZ_LO_CBC = "CZ_LO_CBC",
    CZ_LO_JHC = "CZ_LO_JHC",
    CZ_LO_CBD = "CZ_LO_CBD",
    CZ_LO_PTB = "CZ_LO_PTB",
    CZ_LO_krp_12 = "CZ_LO_krp_12",
    CZ_LO_BKA = "CZ_LO_BKA",
    CZ_LO_BKB = "CZ_LO_BKB",
    CZ_LO_BMA = "CZ_LO_BMA",
    CZ_LO_BVA = "CZ_LO_BVA",
    CZ_LO_VYB = "CZ_LO_VYB",
    CZ_LO_HOA = "CZ_LO_HOA",
    CZ_LO_ZNC = "CZ_LO_ZNC",
    CZ_LO_BVB = "CZ_LO_BVB",
    CZ_LO_BOB = "CZ_LO_BOB",
    CZ_LO_BOA = "CZ_LO_BOA",
    CZ_LO_HOB = "CZ_LO_HOB",
    CZ_LO_BVC = "CZ_LO_BVC",
    CZ_LO_ZNB = "CZ_LO_ZNB",
    CZ_LO_BOG = "CZ_LO_BOG",
    CZ_LO_BOD = "CZ_LO_BOD",
    CZ_LO_VYC = "CZ_LO_VYC",
    CZ_LO_BOE = "CZ_LO_BOE",
    CZ_LO_HOC = "CZ_LO_HOC",
    CZ_LO_VYA = "CZ_LO_VYA",
    CZ_LO_ZNA = "CZ_LO_ZNA",
    CZ_LO_BOF = "CZ_LO_BOF",
    CZ_LO_krp_6 = "CZ_LO_krp_6",
    CZ_LO_CHB = "CZ_LO_CHB",
    CZ_LO_CHA = "CZ_LO_CHA",
    CZ_LO_SOD = "CZ_LO_SOD",
    CZ_LO_KVA = "CZ_LO_KVA",
    CZ_LO_CHC = "CZ_LO_CHC",
    CZ_LO_KVE = "CZ_LO_KVE",
    CZ_LO_SOA = "CZ_LO_SOA",
    CZ_LO_KVB = "CZ_LO_KVB",
    CZ_LO_krp_11 = "CZ_LO_krp_11",
    CZ_LO_ZRB = "CZ_LO_ZRB",
    CZ_LO_HBA = "CZ_LO_HBA",
    CZ_LO_PEB = "CZ_LO_PEB",
    CZ_LO_HBB = "CZ_LO_HBB",
    CZ_LO_JIA = "CZ_LO_JIA",
    CZ_LO_TRC = "CZ_LO_TRC",
    CZ_LO_ZRC = "CZ_LO_ZRC",
    CZ_LO_PEA = "CZ_LO_PEA",
    CZ_LO_HBF = "CZ_LO_HBF",
    CZ_LO_JIC = "CZ_LO_JIC",
    CZ_LO_TRA = "CZ_LO_TRA",
    CZ_LO_ZRD = "CZ_LO_ZRD",
    CZ_LO_ZRA = "CZ_LO_ZRA",
    CZ_LO_krp_9 = "CZ_LO_krp_9",
    CZ_LO_NAB = "CZ_LO_NAB",
    CZ_LO_RKB = "CZ_LO_RKB",
    CZ_LO_TUC = "CZ_LO_TUC",
    CZ_LO_HKA = "CZ_LO_HKA",
    CZ_LO_NAC = "CZ_LO_NAC",
    CZ_LO_JCA = "CZ_LO_JCA",
    CZ_LO_NAA = "CZ_LO_NAA",
    CZ_LO_HKC = "CZ_LO_HKC",
    CZ_LO_RKA = "CZ_LO_RKA",
    CZ_LO_TUA = "CZ_LO_TUA",
    CZ_LO_TUB = "CZ_LO_TUB",
    CZ_LO_krp_8 = "CZ_LO_krp_8",
    CZ_LO_CLA = "CZ_LO_CLA",
    CZ_LO_LBB = "CZ_LO_LBB",
    CZ_LO_JNA = "CZ_LO_JNA",
    CZ_LO_SMB = "CZ_LO_SMB",
    CZ_LO_LBA = "CZ_LO_LBA",
    CZ_LO_CLD = "CZ_LO_CLD",
    CZ_LO_CLB = "CZ_LO_CLB",
    CZ_LO_SMA = "CZ_LO_SMA",
    CZ_LO_JNB = "CZ_LO_JNB",
    CZ_LO_SMC = "CZ_LO_SMC",
    CZ_LO_JNC = "CZ_LO_JNC",
    CZ_LO_krp_14 = "CZ_LO_krp_14",
    CZ_LO_NJD = "CZ_LO_NJD",
    CZ_LO_KAB = "CZ_LO_KAB",
    CZ_LO_BRA = "CZ_LO_BRA",
    CZ_LO_KAE = "CZ_LO_KAE",
    CZ_LO_NJE = "CZ_LO_NJE",
    CZ_LO_FMA = "CZ_LO_FMA",
    CZ_LO_FMC = "CZ_LO_FMC",
    CZ_LO_KAC = "CZ_LO_KAC",
    CZ_LO_OPB = "CZ_LO_OPB",
    CZ_LO_FMD = "CZ_LO_FMD",
    CZ_LO_KAA = "CZ_LO_KAA",
    CZ_LO_NJB = "CZ_LO_NJB",
    CZ_LO_OPD = "CZ_LO_OPD",
    CZ_LO_BRB = "CZ_LO_BRB",
    CZ_LO_BRF = "CZ_LO_BRF",
    CZ_LO_NJA = "CZ_LO_NJA",
    CZ_LO_NJC = "CZ_LO_NJC",
    CZ_LO_OPA = "CZ_LO_OPA",
    CZ_LO_KAD = "CZ_LO_KAD",
    CZ_LO_BRC = "CZ_LO_BRC",
    CZ_LO_OTC = "CZ_LO_OTC",
    CZ_LO_OTB = "CZ_LO_OTB",
    CZ_LO_OTE = "CZ_LO_OTE",
    CZ_LO_BRD = "CZ_LO_BRD",
    CZ_LO_FMB = "CZ_LO_FMB",
    CZ_LO_OPC = "CZ_LO_OPC",
    CZ_LO_krp_13 = "CZ_LO_krp_13",
    CZ_LO_SUD = "CZ_LO_SUD",
    CZ_LO_PRB = "CZ_LO_PRB",
    CZ_LO_JEB = "CZ_LO_JEB",
    CZ_LO_JEA = "CZ_LO_JEA",
    CZ_LO_PRD = "CZ_LO_PRD",
    CZ_LO_PVB = "CZ_LO_PVB",
    CZ_LO_SUC = "CZ_LO_SUC",
    CZ_LO_OLA = "CZ_LO_OLA",
    CZ_LO_PVA = "CZ_LO_PVA",
    CZ_LO_PRA = "CZ_LO_PRA",
    CZ_LO_OLC = "CZ_LO_OLC",
    CZ_LO_SUA = "CZ_LO_SUA",
    CZ_LO_OLD = "CZ_LO_OLD",
    CZ_LO_SUB = "CZ_LO_SUB",
    CZ_LO_JED = "CZ_LO_JED",
    CZ_LO_krp_10 = "CZ_LO_krp_10",
    CZ_LO_UOE = "CZ_LO_UOE",
    CZ_LO_CRB = "CZ_LO_CRB",
    CZ_LO_PAB = "CZ_LO_PAB",
    CZ_LO_CRA = "CZ_LO_CRA",
    CZ_LO_UOC = "CZ_LO_UOC",
    CZ_LO_UOB = "CZ_LO_UOB",
    CZ_LO_SYB = "CZ_LO_SYB",
    CZ_LO_SYC = "CZ_LO_SYC",
    CZ_LO_PAA = "CZ_LO_PAA",
    CZ_LO_SYD = "CZ_LO_SYD",
    CZ_LO_PAC = "CZ_LO_PAC",
    CZ_LO_CRD = "CZ_LO_CRD",
    CZ_LO_SYA = "CZ_LO_SYA",
    CZ_LO_CRC = "CZ_LO_CRC",
    CZ_LO_UOA = "CZ_LO_UOA",
    CZ_LO_UOD = "CZ_LO_UOD",
    CZ_LO_UOF = "CZ_LO_UOF",
    CZ_LO_krp_5 = "CZ_LO_krp_5",
    CZ_LO_PJA = "CZ_LO_PJA",
    CZ_LO_DOA = "CZ_LO_DOA",
    CZ_LO_KTC = "CZ_LO_KTC",
    CZ_LO_KTA = "CZ_LO_KTA",
    CZ_LO_PSC = "CZ_LO_PSC",
    CZ_LO_PSE = "CZ_LO_PSE",
    CZ_LO_PJB = "CZ_LO_PJB",
    CZ_LO_PMA = "CZ_LO_PMA",
    CZ_LO_ROA = "CZ_LO_ROA",
    CZ_LO_TCB = "CZ_LO_TCB",
    CZ_LO_KTB = "CZ_LO_KTB",
    CZ_LO_TCA = "CZ_LO_TCA",
    CZ_LO_krp_15 = "CZ_LO_krp_15",
    CZ_LO_KMB = "CZ_LO_KMB",
    CZ_LO_KMA = "CZ_LO_KMA",
    CZ_LO_ZLD = "CZ_LO_ZLD",
    CZ_LO_UHA = "CZ_LO_UHA",
    CZ_LO_UHB = "CZ_LO_UHB",
    CZ_LO_ZLC = "CZ_LO_ZLC",
    CZ_LO_VSC = "CZ_LO_VSC",
    CZ_LO_VSA = "CZ_LO_VSA",
    CZ_LO_ZLA = "CZ_LO_ZLA",
    CZ_LO_krp_7 = "CZ_LO_krp_7",
    CZ_LO_TPA = "CZ_LO_TPA",
    CZ_LO_DCA = "CZ_LO_DCA",
    CZ_LO_CVA = "CZ_LO_CVA",
    CZ_LO_CVC = "CZ_LO_CVC",
    CZ_LO_LTA = "CZ_LO_LTA",
    CZ_LO_MOB = "CZ_LO_MOB",
    CZ_LO_LTE = "CZ_LO_LTE",
    CZ_LO_LNB = "CZ_LO_LNB",
    CZ_LO_LTB = "CZ_LO_LTB",
    CZ_LO_DCB = "CZ_LO_DCB",
    CZ_LO_LTF = "CZ_LO_LTF",
    CZ_LO_DCC = "CZ_LO_DCC",
    CZ_LO_LNC = "CZ_LO_LNC",
    CZ_SIC_KOOP = "CZ_SIC_KOOP",
    CZ_SIC_CP = "CZ_SIC_CP",
    CZ_FA_2103 = "CZ_FA_2103",
    CZ_FA_3004 = "CZ_FA_3004",
    CZ_FA_2503 = "CZ_FA_2503",
    CZ_FA_3102 = "CZ_FA_3102",
    CZ_FA_2901 = "CZ_FA_2901",
    CZ_FA_3213 = "CZ_FA_3213",
    CZ_FA_2509 = "CZ_FA_2509",
    CZ_FA_3216 = "CZ_FA_3216",
    CZ_FA_2301 = "CZ_FA_2301",
    CZ_FA_2003 = "CZ_FA_2003",
    CZ_FA_2012 = "CZ_FA_2012",
    CZ_FA_2512 = "CZ_FA_2512",
    CZ_FA_2211 = "CZ_FA_2211",
    CZ_FA_2912 = "CZ_FA_2912",
    CZ_FA_2913 = "CZ_FA_2913",
    CZ_FA_3020 = "CZ_FA_3020",
    CZ_FA_2104 = "CZ_FA_2104",
    CZ_FA_3005 = "CZ_FA_3005",
    CZ_FA_2305 = "CZ_FA_2305",
    CZ_FA_3011 = "CZ_FA_3011",
    CZ_FA_2205 = "CZ_FA_2205",
    CZ_FA_2112 = "CZ_FA_2112",
    CZ_FA_2114 = "CZ_FA_2114",
    CZ_FA_3202 = "CZ_FA_3202",
    CZ_FA_2303 = "CZ_FA_2303",
    CZ_FA_2004 = "CZ_FA_2004",
    CZ_FA_2101 = "CZ_FA_2101",
    CZ_FA_3307 = "CZ_FA_3307",
    CZ_FA_2808 = "CZ_FA_2808",
    CZ_FA_3218 = "CZ_FA_3218",
    CZ_FA_3018 = "CZ_FA_3018",
    CZ_FA_2811 = "CZ_FA_2811",
    CZ_FA_3006 = "CZ_FA_3006",
    CZ_FA_3205 = "CZ_FA_3205",
    CZ_FA_3207 = "CZ_FA_3207",
    CZ_FA_2403 = "CZ_FA_2403",
    CZ_FA_2505 = "CZ_FA_2505",
    CZ_FA_3214 = "CZ_FA_3214",
    CZ_FA_2115 = "CZ_FA_2115",
    CZ_FA_3203 = "CZ_FA_3203",
    CZ_FA_2302 = "CZ_FA_2302",
    CZ_FA_2005 = "CZ_FA_2005",
    CZ_FA_2209 = "CZ_FA_2209",
    CZ_FA_2513 = "CZ_FA_2513",
    CZ_FA_3108 = "CZ_FA_3108",
    CZ_FA_2609 = "CZ_FA_2609",
    CZ_FA_2125 = "CZ_FA_2125",
    CZ_FA_2515 = "CZ_FA_2515",
    CZ_FA_3007 = "CZ_FA_3007",
    CZ_FA_3008 = "CZ_FA_3008",
    CZ_FA_3210 = "CZ_FA_3210",
    CZ_FA_2504 = "CZ_FA_2504",
    CZ_FA_2401 = "CZ_FA_2401",
    CZ_FA_3304 = "CZ_FA_3304",
    CZ_FA_2510 = "CZ_FA_2510",
    CZ_FA_3201 = "CZ_FA_3201",
    CZ_FA_2119 = "CZ_FA_2119",
    CZ_FA_2006 = "CZ_FA_2006",
    CZ_FA_3106 = "CZ_FA_3106",
    CZ_FA_2712 = "CZ_FA_2712",
    CZ_FA_3109 = "CZ_FA_3109",
    CZ_FA_3309 = "CZ_FA_3309",
    CZ_FA_3312 = "CZ_FA_3312",
    CZ_FA_2914 = "CZ_FA_2914",
    CZ_FA_2105 = "CZ_FA_2105",
    CZ_FA_2106 = "CZ_FA_2106",
    CZ_FA_2903 = "CZ_FA_2903",
    CZ_FA_2804 = "CZ_FA_2804",
    CZ_FA_3212 = "CZ_FA_3212",
    CZ_FA_2113 = "CZ_FA_2113",
    CZ_FA_2709 = "CZ_FA_2709",
    CZ_FA_3306 = "CZ_FA_3306",
    CZ_FA_2102 = "CZ_FA_2102",
    CZ_FA_2007 = "CZ_FA_2007",
    CZ_FA_3107 = "CZ_FA_3107",
    CZ_FA_2122 = "CZ_FA_2122",
    CZ_FA_2212 = "CZ_FA_2212",
    CZ_FA_3308 = "CZ_FA_3308",
    CZ_FA_2810 = "CZ_FA_2810",
    CZ_FA_3001 = "CZ_FA_3001",
    CZ_FA_2602 = "CZ_FA_2602",
    CZ_FA_3010 = "CZ_FA_3010",
    CZ_FA_2604 = "CZ_FA_2604",
    CZ_FA_2110 = "CZ_FA_2110",
    CZ_FA_3013 = "CZ_FA_3013",
    CZ_FA_3215 = "CZ_FA_3215",
    CZ_FA_2801 = "CZ_FA_2801",
    CZ_FA_2001 = "CZ_FA_2001",
    CZ_FA_2008 = "CZ_FA_2008",
    CZ_FA_2120 = "CZ_FA_2120",
    CZ_FA_2607 = "CZ_FA_2607",
    CZ_FA_2313 = "CZ_FA_2313",
    CZ_FA_2501 = "CZ_FA_2501",
    CZ_FA_3019 = "CZ_FA_3019",
    CZ_FA_3002 = "CZ_FA_3002",
    CZ_FA_2201 = "CZ_FA_2201",
    CZ_FA_2109 = "CZ_FA_2109",
    CZ_FA_3103 = "CZ_FA_3103",
    CZ_FA_2308 = "CZ_FA_2308",
    CZ_FA_2601 = "CZ_FA_2601",
    CZ_FA_2118 = "CZ_FA_2118",
    CZ_FA_2910 = "CZ_FA_2910",
    CZ_FA_2010 = "CZ_FA_2010",
    CZ_FA_2009 = "CZ_FA_2009",
    CZ_FA_2121 = "CZ_FA_2121",
    CZ_FA_2124 = "CZ_FA_2124",
    CZ_FA_2514 = "CZ_FA_2514",
    CZ_FA_2809 = "CZ_FA_2809",
    CZ_FA_3110 = "CZ_FA_3110",
    CZ_FA_3003 = "CZ_FA_3003",
    CZ_FA_2203 = "CZ_FA_2203",
    CZ_FA_2701 = "CZ_FA_2701",
    CZ_FA_2707 = "CZ_FA_2707",
    CZ_FA_2111 = "CZ_FA_2111",
    CZ_FA_2507 = "CZ_FA_2507",
    CZ_FA_3101 = "CZ_FA_3101",
    CZ_FA_2208 = "CZ_FA_2208",
    CZ_FA_2002 = "CZ_FA_2002",
    CZ_FA_2011 = "CZ_FA_2011",
    CZ_FA_2312 = "CZ_FA_2312",
    CZ_FA_2407 = "CZ_FA_2407",
    CZ_FA_2713 = "CZ_FA_2713",
    CZ_FA_3310 = "CZ_FA_3310",
    CZ_FA_3301 = "CZ_FA_3301",
    CZ_LO_OTA = "CZ_LO_OTA",
    CZ_LO_ULA = "CZ_LO_ULA",
    CZ_LO_LNA = "CZ_LO_LNA",
    CZ_LO_MOA = "CZ_LO_MOA",
}

export enum GovernmentInstitutionTypeCode {
    CzechSocialSecurityAdministration = "CSSA",
    FinancialAdministration = "FA",
    LaborOffice = "LO",
    StatutoryInsuranceCompany = "SIC",
}

export enum GrantAssignmentTypeCode {
    None = "None",
    UseDefault = "UseDefault",
    SingleGrant = "SingleGrant",
    Division = "Division",
}

export enum GrantClaimTypeCode {
    Entitlement = "Entitlement",
    Refund = "Refund",
}

export enum GrantStatusCode {
    Applied = "Applied",
    Closed = "Closed",
    InProgress = "InProgress",
}

export enum InboxEntityTypeCode {
    CashReceiptsIssued = "CashReceiptIssued",
    CashReceiptsReceived = "CashReceiptReceived",
    InvoicesIssued = "InvoiceIssued",
    InvoicesReceived = "InvoiceReceived",
    Other = "Other",
    OtherLiabilities = "OtherLiability",
    OtherReceivables = "OtherReceivable",
    ProformaInvoicesIssued = "ProformaInvoiceIssued",
    ProformaInvoicesReceived = "ProformaInvoiceReceived",
    TaxDocumentsIssued = "TaxDocumentIssued",
    TaxDocumentsReceived = "TaxDocumentReceived",
}

export enum InboxFileSourceCode {
    Email = "Email",
    CustomerPortal = "CustomerPortal",
    UploadedByAccountant = "UploadedByAccountant",
}

export enum InboxFileStatusCode {
    Processing = "Processing",
    Completed = "Completed",
    Deleted = "Deleted",
}

export enum InboxItemLogStateCode {
    Accepted = "Accepted",
    ApprovedByUser = "ApprovedByUser",
    IncludedByUser = "IncludedByUser",
    IncludedIn = "IncludedIn",
    ApprovedTrustedSender = "ApprovedTrustedSender",
    ApprovedCustomerPortal = "ApprovedCustomerPortal",
    ApprovedAutomatically = "ApprovedAutomatically",
    CanceledByUser = "CanceledByUser",
    ResumedByUser = "ResumedByUser",
    RejectedByUser = "RejectedByUser",
    DeletedByUser = "DeletedByUser",
}

export enum IntegrationApiImportFrequencyCode {
    Daily = "Daily",
    LastDayOfTheMonth = "LastDayOfMonth",
    DoNotImportAutomatically = "Never",
    LastDayOfTheWeek = "LastDayOfWeek",
}

export enum IntegrationApiImportFromWhenCode {
    FromDate = "CustomDate",
    ForThisFiscalYear = "FiscalYear",
}

export enum IntegrationApiImportRangeCode {
    FromDate = "Custom",
    InTheCurrentFiscalYear = "FiscalYear",
    DoNotImport = "None",
}

export enum IntegrationApiImportedDocumentsCode {
    NewOnly = "New",
    NewAndChanged = "NewAndChanged",
}

export enum InteractionTypeCode {
    DeletedBankAccount = "DeletedBankAccount",
    DeletedAdvanceTaxPayment = "DeletedAdvanceTaxPayment",
    DeletedSalaryAdvance = "DeletedSalaryAdvance",
    DeletedBalanceSheetClose = "DeletedBalanceSheetClose",
    DeletedDeferredPlan = "DeletedDeferredPlan",
    ClosedDeferredPlan = "ClosedDeferredPlan",
    DeletedExchangeRates = "DeletedExchangeRates",
    DeletedIncomeExpenseTransfer = "DeletedIncomeExpenseTransfer",
    DeletedIncomeTaxDocument = "DeletedIncomeTax",
    DeletedInitialAccountBalances = "DeletedInitialAccountBalances",
    DeletedInventoryCheckDocument = "DeletedInventoryCheck",
    DeletedInventoryClearingDocument = "DeletedInventoryClearing",
    DeletedLinksAndSettlement = "DeletedLinksAndSettlement",
    DeletedNextYearBalanceSheetOpen = "DeletedNextYearBalance",
    DeletedNextYearProfitOrLossTransfer = "DeletedNextYearProfitOrLoss",
    DeletedProfitOrLoss = "DeletedProfitOrLoss",
    DisposedAsset = "DisposedAsset",
    ReceivableAdjustments = "ReceivableAdjustments",
    UserInteraction = "UserInteraction",
    VATElectronicSubmissionUnlocked = "ElectronicSubmissionUnlocked",
    PayrollPeriodReopened = "ReopenPrPayrollPeriod",
    PayrollPeriodDeleted = "DeletedPrPayrollPeriod",
    DistrainmentDepositReopened = "ReopenDistrainmentDeposit",
    InsolvencyDepositReopened = "ReopenInsolvencyDeposit",
}

export enum InventoryTypeCode {
    MethodA = "CzInvA",
    MethodB = "CzInvB",
}

export enum InvoiceServiceIntegrationTypeCode {
    Fakturoid = "Fakturoid",
    IDoklad = "IDoklad",
}

export enum JournalEntryTypeCode {
    Debit = "Dr",
    Credit = "Cr",
}

export enum LORegionalOfficeCode {
    RegionalOfficeHradecKrálové = "HKK",
    RegionalOfficeČeskéBudějovice = "JCK",
    RegionalOfficeBrno = "JMK",
    RegionalOfficeKarlovyVary = "KVK",
    RegionalOfficeLiberec = "LBK",
    RegionalOfficePrague = "MHMP",
    RegionalOfficeOstrava = "MSK",
    RegionalOfficeOlomouc = "OLK",
    RegionalOfficePardubice = "PAK",
    RegionalOfficePlzeň = "PMK",
    RegionalOfficePříbram = "SCK",
    RegionalOfficeÚstíNadLabem = "ULK",
    RegionalOfficeJihlava = "VYK",
    RegionalOfficeZlín = "ZLK",
}

export enum LanguageCode {
    English = "en",
    Czech = "cs-CZ",
}

export enum LegalEntityCategoryCode {
    Large = "Large",
    Medium = "Medium",
    Micro = "Micro",
    Small = "Small",
}

export enum LegislativeFixedExchangeRateCode {
    CZ2020_CZK_AUD = "CZ2020_CZK_AUD",
    CZ2020_CZK_BRL = "CZ2020_CZK_BRL",
    CZ2020_CZK_BGN = "CZ2020_CZK_BGN",
    CZ2020_CZK_CNY = "CZ2020_CZK_CNY",
    CZ2020_CZK_DKK = "CZ2020_CZK_DKK",
    CZ2020_CZK_EUR = "CZ2020_CZK_EUR",
    CZ2020_CZK_PHP = "CZ2020_CZK_PHP",
    CZ2020_CZK_HKD = "CZ2020_CZK_HKD",
    CZ2020_CZK_HRK = "CZ2020_CZK_HRK",
    CZ2020_CZK_INR = "CZ2020_CZK_INR",
    CZ2020_CZK_IDR = "CZ2020_CZK_IDR",
    CZ2020_CZK_ISK = "CZ2020_CZK_ISK",
    CZ2020_CZK_ILS = "CZ2020_CZK_ILS",
    CZ2020_CZK_JPY = "CZ2020_CZK_JPY",
    CZ2020_CZK_ZAR = "CZ2020_CZK_ZAR",
    CZ2020_CZK_CAD = "CZ2020_CZK_CAD",
    CZ2020_CZK_KRW = "CZ2020_CZK_KRW",
    CZ2020_CZK_HUF = "CZ2020_CZK_HUF",
    CZ2020_CZK_MYR = "CZ2020_CZK_MYR",
    CZ2020_CZK_MXN = "CZ2020_CZK_MXN",
    CZ2020_CZK_XDR = "CZ2020_CZK_XDR",
    CZ2020_CZK_NOK = "CZ2020_CZK_NOK",
    CZ2020_CZK_NZD = "CZ2020_CZK_NZD",
    CZ2020_CZK_PLN = "CZ2020_CZK_PLN",
    CZ2020_CZK_RON = "CZ2020_CZK_RON",
    CZ2020_CZK_RUB = "CZ2020_CZK_RUB",
    CZ2020_CZK_SGD = "CZ2020_CZK_SGD",
    CZ2020_CZK_SEK = "CZ2020_CZK_SEK",
    CZ2020_CZK_CHF = "CZ2020_CZK_CHF",
    CZ2020_CZK_THB = "CZ2020_CZK_THB",
    CZ2020_CZK_TRY = "CZ2020_CZK_TRY",
    CZ2020_CZK_USD = "CZ2020_CZK_USD",
    CZ2020_CZK_GBP = "CZ2020_CZK_GBP",
    CZ2021_CZK_AUD = "CZ2021_CZK_AUD",
    CZ2021_CZK_BRL = "CZ2021_CZK_BRL",
    CZ2021_CZK_BGN = "CZ2021_CZK_BGN",
    CZ2021_CZK_CNY = "CZ2021_CZK_CNY",
    CZ2021_CZK_DKK = "CZ2021_CZK_DKK",
    CZ2021_CZK_EUR = "CZ2021_CZK_EUR",
    CZ2021_CZK_PHP = "CZ2021_CZK_PHP",
    CZ2021_CZK_HKD = "CZ2021_CZK_HKD",
    CZ2021_CZK_HRK = "CZ2021_CZK_HRK",
    CZ2021_CZK_INR = "CZ2021_CZK_INR",
    CZ2021_CZK_IDR = "CZ2021_CZK_IDR",
    CZ2021_CZK_ISK = "CZ2021_CZK_ISK",
    CZ2021_CZK_ILS = "CZ2021_CZK_ILS",
    CZ2021_CZK_JPY = "CZ2021_CZK_JPY",
    CZ2021_CZK_ZAR = "CZ2021_CZK_ZAR",
    CZ2021_CZK_CAD = "CZ2021_CZK_CAD",
    CZ2021_CZK_KRW = "CZ2021_CZK_KRW",
    CZ2021_CZK_HUF = "CZ2021_CZK_HUF",
    CZ2021_CZK_MYR = "CZ2021_CZK_MYR",
    CZ2021_CZK_MXN = "CZ2021_CZK_MXN",
    CZ2021_CZK_XDR = "CZ2021_CZK_XDR",
    CZ2021_CZK_NOK = "CZ2021_CZK_NOK",
    CZ2021_CZK_NZD = "CZ2021_CZK_NZD",
    CZ2021_CZK_PLN = "CZ2021_CZK_PLN",
    CZ2021_CZK_RON = "CZ2021_CZK_RON",
    CZ2021_CZK_RUB = "CZ2021_CZK_RUB",
    CZ2021_CZK_SGD = "CZ2021_CZK_SGD",
    CZ2021_CZK_SEK = "CZ2021_CZK_SEK",
    CZ2021_CZK_CHF = "CZ2021_CZK_CHF",
    CZ2021_CZK_THB = "CZ2021_CZK_THB",
    CZ2021_CZK_TRY = "CZ2021_CZK_TRY",
    CZ2021_CZK_USD = "CZ2021_CZK_USD",
    CZ2021_CZK_GBP = "CZ2021_CZK_GBP",
    CZ2022_CZK_AUD = "CZ2022_CZK_AUD",
    CZ2022_CZK_BRL = "CZ2022_CZK_BRL",
    CZ2022_CZK_BGN = "CZ2022_CZK_BGN",
    CZ2022_CZK_CNY = "CZ2022_CZK_CNY",
    CZ2022_CZK_DKK = "CZ2022_CZK_DKK",
    CZ2022_CZK_EUR = "CZ2022_CZK_EUR",
    CZ2022_CZK_PHP = "CZ2022_CZK_PHP",
    CZ2022_CZK_HKD = "CZ2022_CZK_HKD",
    CZ2022_CZK_HRK = "CZ2022_CZK_HRK",
    CZ2022_CZK_INR = "CZ2022_CZK_INR",
    CZ2022_CZK_IDR = "CZ2022_CZK_IDR",
    CZ2022_CZK_ISK = "CZ2022_CZK_ISK",
    CZ2022_CZK_ILS = "CZ2022_CZK_ILS",
    CZ2022_CZK_JPY = "CZ2022_CZK_JPY",
    CZ2022_CZK_ZAR = "CZ2022_CZK_ZAR",
    CZ2022_CZK_CAD = "CZ2022_CZK_CAD",
    CZ2022_CZK_KRW = "CZ2022_CZK_KRW",
    CZ2022_CZK_HUF = "CZ2022_CZK_HUF",
    CZ2022_CZK_MYR = "CZ2022_CZK_MYR",
    CZ2022_CZK_MXN = "CZ2022_CZK_MXN",
    CZ2022_CZK_XDR = "CZ2022_CZK_XDR",
    CZ2022_CZK_NOK = "CZ2022_CZK_NOK",
    CZ2022_CZK_NZD = "CZ2022_CZK_NZD",
    CZ2022_CZK_PLN = "CZ2022_CZK_PLN",
    CZ2022_CZK_RON = "CZ2022_CZK_RON",
    CZ2022_CZK_SGD = "CZ2022_CZK_SGD",
    CZ2022_CZK_SEK = "CZ2022_CZK_SEK",
    CZ2022_CZK_CHF = "CZ2022_CZK_CHF",
    CZ2022_CZK_THB = "CZ2022_CZK_THB",
    CZ2022_CZK_TRY = "CZ2022_CZK_TRY",
    CZ2022_CZK_USD = "CZ2022_CZK_USD",
    CZ2022_CZK_GBP = "CZ2022_CZK_GBP",
    CZ2023_CZK_AUD = "CZ2023_CZK_AUD",
    CZ2023_CZK_BRL = "CZ2023_CZK_BRL",
    CZ2023_CZK_BGN = "CZ2023_CZK_BGN",
    CZ2023_CZK_CNY = "CZ2023_CZK_CNY",
    CZ2023_CZK_DKK = "CZ2023_CZK_DKK",
    CZ2023_CZK_EUR = "CZ2023_CZK_EUR",
    CZ2023_CZK_PHP = "CZ2023_CZK_PHP",
    CZ2023_CZK_HKD = "CZ2023_CZK_HKD",
    CZ2023_CZK_INR = "CZ2023_CZK_INR",
    CZ2023_CZK_IDR = "CZ2023_CZK_IDR",
    CZ2023_CZK_ISK = "CZ2023_CZK_ISK",
    CZ2023_CZK_ILS = "CZ2023_CZK_ILS",
    CZ2023_CZK_JPY = "CZ2023_CZK_JPY",
    CZ2023_CZK_ZAR = "CZ2023_CZK_ZAR",
    CZ2023_CZK_CAD = "CZ2023_CZK_CAD",
    CZ2023_CZK_KRW = "CZ2023_CZK_KRW",
    CZ2023_CZK_HUF = "CZ2023_CZK_HUF",
    CZ2023_CZK_MYR = "CZ2023_CZK_MYR",
    CZ2023_CZK_MXN = "CZ2023_CZK_MXN",
    CZ2023_CZK_XDR = "CZ2023_CZK_XDR",
    CZ2023_CZK_NOK = "CZ2023_CZK_NOK",
    CZ2023_CZK_NZD = "CZ2023_CZK_NZD",
    CZ2023_CZK_PLN = "CZ2023_CZK_PLN",
    CZ2023_CZK_RON = "CZ2023_CZK_RON",
    CZ2023_CZK_SGD = "CZ2023_CZK_SGD",
    CZ2023_CZK_SEK = "CZ2023_CZK_SEK",
    CZ2023_CZK_CHF = "CZ2023_CZK_CHF",
    CZ2023_CZK_THB = "CZ2023_CZK_THB",
    CZ2023_CZK_TRY = "CZ2023_CZK_TRY",
    CZ2023_CZK_USD = "CZ2023_CZK_USD",
    CZ2023_CZK_GBP = "CZ2023_CZK_GBP",
    CZ2024_CZK_AUD = "CZ2024_CZK_AUD",
    CZ2024_CZK_BRL = "CZ2024_CZK_BRL",
    CZ2024_CZK_BGN = "CZ2024_CZK_BGN",
    CZ2024_CZK_CNY = "CZ2024_CZK_CNY",
    CZ2024_CZK_DKK = "CZ2024_CZK_DKK",
    CZ2024_CZK_EUR = "CZ2024_CZK_EUR",
    CZ2024_CZK_PHP = "CZ2024_CZK_PHP",
    CZ2024_CZK_HKD = "CZ2024_CZK_HKD",
    CZ2024_CZK_INR = "CZ2024_CZK_INR",
    CZ2024_CZK_IDR = "CZ2024_CZK_IDR",
    CZ2024_CZK_ISK = "CZ2024_CZK_ISK",
    CZ2024_CZK_ILS = "CZ2024_CZK_ILS",
    CZ2024_CZK_JPY = "CZ2024_CZK_JPY",
    CZ2024_CZK_ZAR = "CZ2024_CZK_ZAR",
    CZ2024_CZK_CAD = "CZ2024_CZK_CAD",
    CZ2024_CZK_KRW = "CZ2024_CZK_KRW",
    CZ2024_CZK_HUF = "CZ2024_CZK_HUF",
    CZ2024_CZK_MYR = "CZ2024_CZK_MYR",
    CZ2024_CZK_MXN = "CZ2024_CZK_MXN",
    CZ2024_CZK_XDR = "CZ2024_CZK_XDR",
    CZ2024_CZK_NOK = "CZ2024_CZK_NOK",
    CZ2024_CZK_NZD = "CZ2024_CZK_NZD",
    CZ2024_CZK_PLN = "CZ2024_CZK_PLN",
    CZ2024_CZK_RON = "CZ2024_CZK_RON",
    CZ2024_CZK_SGD = "CZ2024_CZK_SGD",
    CZ2024_CZK_SEK = "CZ2024_CZK_SEK",
    CZ2024_CZK_CHF = "CZ2024_CZK_CHF",
    CZ2024_CZK_THB = "CZ2024_CZK_THB",
    CZ2024_CZK_TRY = "CZ2024_CZK_TRY",
    CZ2024_CZK_USD = "CZ2024_CZK_USD",
    CZ2024_CZK_GBP = "CZ2024_CZK_GBP",
    CZ2025_CZK_AUD = "CZ2025_CZK_AUD",
    CZ2025_CZK_BRL = "CZ2025_CZK_BRL",
    CZ2025_CZK_BGN = "CZ2025_CZK_BGN",
    CZ2025_CZK_CNY = "CZ2025_CZK_CNY",
    CZ2025_CZK_DKK = "CZ2025_CZK_DKK",
    CZ2025_CZK_EUR = "CZ2025_CZK_EUR",
    CZ2025_CZK_PHP = "CZ2025_CZK_PHP",
    CZ2025_CZK_HKD = "CZ2025_CZK_HKD",
    CZ2025_CZK_INR = "CZ2025_CZK_INR",
    CZ2025_CZK_IDR = "CZ2025_CZK_IDR",
    CZ2025_CZK_ISK = "CZ2025_CZK_ISK",
    CZ2025_CZK_ILS = "CZ2025_CZK_ILS",
    CZ2025_CZK_JPY = "CZ2025_CZK_JPY",
    CZ2025_CZK_ZAR = "CZ2025_CZK_ZAR",
    CZ2025_CZK_CAD = "CZ2025_CZK_CAD",
    CZ2025_CZK_KRW = "CZ2025_CZK_KRW",
    CZ2025_CZK_HUF = "CZ2025_CZK_HUF",
    CZ2025_CZK_MYR = "CZ2025_CZK_MYR",
    CZ2025_CZK_MXN = "CZ2025_CZK_MXN",
    CZ2025_CZK_XDR = "CZ2025_CZK_XDR",
    CZ2025_CZK_NOK = "CZ2025_CZK_NOK",
    CZ2025_CZK_NZD = "CZ2025_CZK_NZD",
    CZ2025_CZK_PLN = "CZ2025_CZK_PLN",
    CZ2025_CZK_RON = "CZ2025_CZK_RON",
    CZ2025_CZK_SGD = "CZ2025_CZK_SGD",
    CZ2025_CZK_SEK = "CZ2025_CZK_SEK",
    CZ2025_CZK_CHF = "CZ2025_CZK_CHF",
    CZ2025_CZK_THB = "CZ2025_CZK_THB",
    CZ2025_CZK_TRY = "CZ2025_CZK_TRY",
    CZ2025_CZK_USD = "CZ2025_CZK_USD",
    CZ2025_CZK_GBP = "CZ2025_CZK_GBP",
}

export enum LockTypeCode {
    User = "User",
}

export enum MandatoryAccountCode {
    CzAccBizAp = "CzAccBizAp",
    CzAccBizAr = "CzAccBizAr",
    CzAccBizBank = "CzAccBizBank",
    CzAccBizCash = "CzAccBizCash",
    CzAccBizBusinessOtherAr = "CzAccBizBusinessOtherAr",
    CzAccBizBusinessOtherAp = "CzAccBizBusinessOtherAp",
    CzAccBizVat = "CzAccBizVat",
    CzAccBizIncomeTax = "CzAccBizIncomeTax",
    CzAccBizOtherDirTax = "CzAccBizOtherDirTax",
    CzAccBizOtherTaxes = "CzAccBizOtherTaxes",
    CzAccBizConAccount = "CzAccBizConAccount",
    CzAccBizOtherAr = "CzAccBizOtherAr",
    CzAccBizOtherAp = "CzAccBizOtherAp",
    CzAccBizRecAdj = "CzAccBizRecAdj",
    CzAccBizIntClrng = "CzAccBizIntClrng",
    CzAccBizProfLossApr = "CzAccBizProfLossApr",
    CzAccBizAddAdj = "CzAccBizAddAdj",
    CzAccBizTan = "CzAccBizTan",
    CzAccBizIntan = "CzAccBizIntan",
    CzAccBizAssDep = "CzAccBizAssDep",
    CzAccBizDefExp = "CzAccBizDefExp",
    CzAccBizDefRev = "CzAccBizDefRev",
    CzAccBizAccExp = "CzAccBizAccExp",
    CzAccBizAccRev = "CzAccBizAccRev",
    CzAccBizEstAccRev = "CzAccBizEstAccRev",
    CzAccBizEstAccExp = "CzAccBizEstAccExp",
    CzAccBizWOff = "CzAccBizWOff",
    CzAccBizWOffT = "CzAccBizWOffT",
    CzAccBizWOffN = "CzAccBizWOffN",
    CzAccBizInit = "CzAccBizInit",
    CzAccBizOpen = "CzAccBizOpen",
    CzAccBizClose = "CzAccBizClose",
    CzAccBizProfitLoss = "CzAccBizProfitLoss",
    CzAccBizAdvPayGiven = "CzAccBizAdvPayGiven",
    CzAccBizAdvPayRecvd = "CzAccBizAdvPayRecvd",
    CzAccBizExchLoss = "CzAccBizExchLoss",
    CzAccBizExchGain = "CzAccBizExchGain",
    CzAccBizIncTaxExp = "CzAccBizIncTaxExp",
    CzAccBizInvMaterial = "CzAccBizInvMaterial",
    CzAccBizInvGoods = "CzAccBizInvGoods",
    CzAccBizInvMatProc = "CzAccBizInvMatProc",
    CzAccBizInvGoodsProc = "CzAccBizInvGoodsProc",
    CzAccBizResearch = "CzAccBizResearch",
    CzAccBizSoftware = "CzAccBizSoftware",
    CzAccBizBuildings = "CzAccBizBuildings",
    CzAccBizMovables = "CzAccBizMovables",
    CzAccBizHoldings = "CzAccBizHoldings",
    CzAccBizResearchAD = "CzAccBizResearchAD",
    CzAccBizSoftwareAD = "CzAccBizSoftwareAD",
    CzAccBizBuildingsAD = "CzAccBizBuildingsAD",
    CzAccBizHoldingsAD = "CzAccBizHoldingsAD",
    CzAccBizCashTransfer = "CzAccBizCashTransfer",
    CzAccBizPersConsumption = "CzAccBizPersConsumption",
    CzAccBizInterestExp = "CzAccBizInterestExp",
    CzAccBizInterestRev = "CzAccBizInterestRev",
    CzAccBizPayrollPayable = "CzAccBizPayrollPayable",
    CzAccBizRecFromEmployee = "CzAccBizRecFromEmployee",
    CzAccBizPayToEmployee = "CzAccBizPayToEmployee",
    CzAccBizPrSocSecHealthPayable = "CzAccBizPrSocSecHealthPayable",
    CzAccBizPrPayablePartner = "CzAccBizPrPayablePartner",
    CzAccBizPrSalaryExpenseEmployee = "CzAccBizPrSalaryExpenseEmployee",
    CzAccBizPrSalaryExpenseAscSalary = "CzAccBizPrSalaryExpenseAscSalary",
    CzAccBizPrSalaryExpenseAscComp = "CzAccBizPrSalaryExpenseAscComp",
    CzAccBizPrSocSecInsurance = "CzAccBizPrSocSecInsurance",
    CzAccBizPrSocSecExpense = "CzAccBizPrSocSecExpense",
    CzAccBizPrOtherOperatingExpenses = "CzAccBizPrOtherOperatingExpenses",
    CzAccBizPrSocExpense = "CzAccBizPrSocExpense",
    CzAccBizBankLoanShortTerm = "CzAccBizBankLoanShortTerm",
    CzAccBizBankLoanLongTerm = "CzAccBizBankLoanLongTerm",
    CzAccBizOtherLoanLongTerm = "CzAccBizOtherLoanLongTerm",
    CzAccBizStampsAndVouchers = "CzAccBizStampsAndVouchers",
    CzAccBizSalesProducts = "CzAccBizSalesProducts",
    CzAccBizSalesServices = "CzAccBizSalesServices",
    CzAccBizSalesGoods = "CzAccBizSalesGoods",
    CzNpoAccResearch = "CzNpoAccResearch",
    CzNpoAccSoftware = "CzNpoAccSoftware",
    CzNpoAccLowIntanFixedAssets = "CzNpoAccLowIntanFixedAssets",
    CzNpoAccOtherIntanFixedAssets = "CzNpoAccOtherIntanFixedAssets",
    CzNpoAccBuildings = "CzNpoAccBuildings",
    CzNpoAccMovables = "CzNpoAccMovables",
    CzNpoAccPermVegetation = "CzNpoAccPermVegetation",
    CzNpoAccBasicAnimals = "CzNpoAccBasicAnimals",
    CzNpoAccLowTanFixedAssets = "CzNpoAccLowTanFixedAssets",
    CzNpoAccOtherTanFixedAssets = "CzNpoAccOtherTanFixedAssets",
    CzNpoAccHoldings = "CzNpoAccHoldings",
    CzNpoAccArtObjects = "CzNpoAccArtObjects",
    CzNpoAccIntan = "CzNpoAccIntan",
    CzNpoAccTan = "CzNpoAccTan",
    CzNpoAccAdvanceIntanAssets = "CzNpoAccAdvanceIntanAssets",
    CzNpoAccAdvanceTanAssets = "CzNpoAccAdvanceTanAssets",
    CzNpoAccOtherLongLoans = "CzNpoAccOtherLongLoans",
    CzNpoAccOtherLongFinAssets = "CzNpoAccOtherLongFinAssets",
    CzNpoAccResearchAD = "CzNpoAccResearchAD",
    CzNpoAccSoftwareAD = "CzNpoAccSoftwareAD",
    CzNpoAccOtherIntanLongAssetsAD = "CzNpoAccOtherIntanLongAssetsAD",
    CzNpoAccBuildingsAD = "CzNpoAccBuildingsAD",
    CzNpoAccHoldingsAD = "CzNpoAccHoldingsAD",
    CzNpoAccPermVegetationAD = "CzNpoAccPermVegetationAD",
    CzNpoAccBasicAnimalsAD = "CzNpoAccBasicAnimalsAD",
    CzNpoAccLowTanFixedAssetsAD = "CzNpoAccLowTanFixedAssetsAD",
    CzNpoAccOtherTanFixedAssetsAD = "CzNpoAccOtherTanFixedAssetsAD",
    CzNpoAccInvMatProc = "CzNpoAccInvMatProc",
    CzNpoAccInvMaterial = "CzNpoAccInvMaterial",
    CzNpoAccInvGoodsProc = "CzNpoAccInvGoodsProc",
    CzNpoAccInvGoods = "CzNpoAccInvGoods",
    CzNpoAccCash = "CzNpoAccCash",
    CzNpoAccStampsAndVouchers = "CzNpoAccStampsAndVouchers",
    CzNpoAccBank = "CzNpoAccBank",
    CzNpoAccBankLoanShortTerm = "CzNpoAccBankLoanShortTerm",
    CzNpoAccCashTransfer = "CzNpoAccCashTransfer",
    CzNpoAccAr = "CzNpoAccAr",
    CzNpoAccAdvPayGiven = "CzNpoAccAdvPayGiven",
    CzNpoAccBusinessOtherAr = "CzNpoAccBusinessOtherAr",
    CzNpoAccAp = "CzNpoAccAp",
    CzNpoAccAdvPayRecvd = "CzNpoAccAdvPayRecvd",
    CzNpoAccBusinessOtherAp = "CzNpoAccBusinessOtherAp",
    CzNpoAccPayrollPayable = "CzNpoAccPayrollPayable",
    CzNpoAccPayToEmployee = "CzNpoAccPayToEmployee",
    CzNpoAccRecFromEmployee = "CzNpoAccRecFromEmployee",
    CzNpoAccPrSocSecHealthPayable = "CzNpoAccPrSocSecHealthPayable",
    CzNpoAccIncomeTax = "CzNpoAccIncomeTax",
    CzNpoAccOtherDirTax = "CzNpoAccOtherDirTax",
    CzNpoAccVat = "CzNpoAccVat",
    CzNpoAccOtherTaxes = "CzNpoAccOtherTaxes",
    CzNpoAccSubsidiesState = "CzNpoAccSubsidiesState",
    CzNpoAccSubsidiesLocal = "CzNpoAccSubsidiesLocal",
    CzNpoAccConAccount = "CzNpoAccConAccount",
    CzNpoAccRecFromMembers = "CzNpoAccRecFromMembers",
    CzNpoAccPrPayablePartner = "CzNpoAccPrPayablePartner",
    CzNpoAccOtherAr = "CzNpoAccOtherAr",
    CzNpoAccOtherAp = "CzNpoAccOtherAp",
    CzNpoAccDefExp = "CzNpoAccDefExp",
    CzNpoAccAccExp = "CzNpoAccAccExp",
    CzNpoAccDefRev = "CzNpoAccDefRev",
    CzNpoAccAccRev = "CzNpoAccAccRev",
    CzNpoAccEstAccRev = "CzNpoAccEstAccRev",
    CzNpoAccEstAccExp = "CzNpoAccEstAccExp",
    CzNpoAccRecAdj = "CzNpoAccRecAdj",
    CzNpoAccIntClrng = "CzNpoAccIntClrng",
    CzNpoAccAssociationClrng = "CzNpoAccAssociationClrng",
    CzNpoAccConsumpMaterial = "CzNpoAccConsumpMaterial",
    CzNpoAccConsumpEnergy = "CzNpoAccConsumpEnergy",
    CzNpoAccConsumpNonStockSupp = "CzNpoAccConsumpNonStockSupp",
    CzNpoAccGoodsSold = "CzNpoAccGoodsSold",
    CzNpoAccRepairsMaint = "CzNpoAccRepairsMaint",
    CzNpoAccTravelExpense = "CzNpoAccTravelExpense",
    CzNpoAccRepreCosts = "CzNpoAccRepreCosts",
    CzNpoAccOtherServices = "CzNpoAccOtherServices",
    CzNpoAccPrSalaryExpenseEmployee = "CzNpoAccPrSalaryExpenseEmployee",
    CzNpoAccPrSalaryExpenseAscSalary = "CzNpoAccPrSalaryExpenseAscSalary",
    CzNpoAccPrSalaryExpenseAscComp = "CzNpoAccPrSalaryExpenseAscComp",
    CzNpoAccPrSocSecInsurance = "CzNpoAccPrSocSecInsurance",
    CzNpoAccPrSocOtherInsurance = "CzNpoAccPrSocOtherInsurance",
    CzNpoAccPrSocSecExpense = "CzNpoAccPrSocSecExpense",
    CzNpoAccPrSocExpense = "CzNpoAccPrSocExpense",
    CzNpoAccTaxRoad = "CzNpoAccTaxRoad",
    CzNpoAccTaxProperty = "CzNpoAccTaxProperty",
    CzNpoAccTaxOther = "CzNpoAccTaxOther",
    CzNpoAccPenalLatePayInterest = "CzNpoAccPenalLatePayInterest",
    CzNpoAccPenalFeesOther = "CzNpoAccPenalFeesOther",
    CzNpoAccUnrecovableWriteOff = "CzNpoAccUnrecovableWriteOff",
    CzNpoAccInterestExp = "CzNpoAccInterestExp",
    CzNpoAccExchLoss = "CzNpoAccExchLoss",
    CzNpoAccDonations = "CzNpoAccDonations",
    CzNpoAccInventShortDamages = "CzNpoAccInventShortDamages",
    CzNpoAccOtherExpenses = "CzNpoAccOtherExpenses",
    CzNpoAccAssDep = "CzNpoAccAssDep",
    CzNpoAccDispFixedAssetsNetValue = "CzNpoAccDispFixedAssetsNetValue",
    CzNpoAccSecInvestSold = "CzNpoAccSecInvestSold",
    CzNpoAccMaterialSold = "CzNpoAccMaterialSold",
    CzNpoAccLegalProvisions = "CzNpoAccLegalProvisions",
    CzNpoAccAddAdj = "CzNpoAccAddAdj",
    CzNpoAccLegalAdjustments = "CzNpoAccLegalAdjustments",
    CzNpoAccContribOrgUnits = "CzNpoAccContribOrgUnits",
    CzNpoAccContrib = "CzNpoAccContrib",
    CzNpoAccIncTaxExp = "CzNpoAccIncTaxExp",
    CzNpoAccIncTaxAdditionalExp = "CzNpoAccIncTaxAdditionalExp",
    CzNpoAccSalesProducts = "CzNpoAccSalesProducts",
    CzNpoAccSalesServices = "CzNpoAccSalesServices",
    CzNpoAccSalesGoods = "CzNpoAccSalesGoods",
    CzNpoAccPenalLatePayInterestInc = "CzNpoAccPenalLatePayInterestInc",
    CzNpoAccPenalFeesOtherInc = "CzNpoAccPenalFeesOtherInc",
    CzNpoAccWriteOffRecCollections = "CzNpoAccWriteOffRecCollections",
    CzNpoAccInterestRev = "CzNpoAccInterestRev",
    CzNpoAccExchGain = "CzNpoAccExchGain",
    CzNpoAccFundSettle = "CzNpoAccFundSettle",
    CzNpoAccOtherRev = "CzNpoAccOtherRev",
    CzNpoAccFixIntanAssetsSales = "CzNpoAccFixIntanAssetsSales",
    CzNpoAccMaterialSoldInc = "CzNpoAccMaterialSoldInc",
    CzNpoAccShortFinAssetsRev = "CzNpoAccShortFinAssetsRev",
    CzNpoAccLongFinAssetsRev = "CzNpoAccLongFinAssetsRev",
    CzNpoAccContribOrgUnitsRec = "CzNpoAccContribOrgUnitsRec",
    CzNpoAccContribRec = "CzNpoAccContribRec",
    CzNpoAccMembershipFeesRec = "CzNpoAccMembershipFeesRec",
    CzNpoAccSubsidiesOperational = "CzNpoAccSubsidiesOperational",
    CzNpoAccEquity = "CzNpoAccEquity",
    CzNpoAccFunds = "CzNpoAccFunds",
    CzNpoAccRevalFinAssetsDiff = "CzNpoAccRevalFinAssetsDiff",
    CzNpoAccProfLossApr = "CzNpoAccProfLossApr",
    CzNpoAccEarnLossPrevYears = "CzNpoAccEarnLossPrevYears",
    CzNpoAccStatutoryProvisions = "CzNpoAccStatutoryProvisions",
    CzNpoAccBankLoanLongTerm = "CzNpoAccBankLoanLongTerm",
    CzNpoAccLeaseLiab = "CzNpoAccLeaseLiab",
    CzNpoAccLongRecAdvances = "CzNpoAccLongRecAdvances",
    CzNpoAccOtherLoanLongTerm = "CzNpoAccOtherLoanLongTerm",
    CzNpoAccOpen = "CzNpoAccOpen",
    CzNpoAccClose = "CzNpoAccClose",
    CzNpoAccProfitLoss = "CzNpoAccProfitLoss",
}

export enum MandatoryChartOfAccountsCode {
    MandatoryChartOfAccountsForBusinesses = "CzAccBiz",
    MandatoryChartOfAccountsForNonprofitOrganizations = "CzNpoAcc",
}

export enum MinorAssetStatusCode {
    Active = "ACTIVE",
    WithoutAssets = "EMPTY",
}

export enum ModuleCode {
    ExtendedStorage = "Storage",
    Rossum = "Rossum",
    Payroll = "Payroll",
    Grants = "Grants",
}

export enum MonthOfYearCode {
    April = "APR",
    August = "AUG",
    December = "DEC",
    February = "FEB",
    January = "JAN",
    July = "JUL",
    June = "JUN",
    March = "MAR",
    May = "MAY",
    November = "NOV",
    October = "OCT",
    September = "SEP",
}

export enum NotificationPriorityCode {
    High = "High",
    Standard = "Standard",
}

export enum NotificationTypeCode {
    DataboxMessage = "DataboxMessage",
    InboxDocument = "InboxDocument",
    InboxDocumentApprovalCanceled = "InboxDocumentApprovalCanceled",
    InboxDocumentApprovalResumed = "InboxDocumentApprovalResumed",
    SurveySatisfaction = "SurveySatisfaction",
    SystemUpdate = "SystemUpdate",
    SystemMessage = "SystemMessage",
    DocumentForApproval = "DocumentForApproval",
    NewChat = "NewChat",
    NewChatMessage = "NewChatMessage",
    BankStatementImportWarning = "BankStatementImportWarning",
    BankStatementImportError = "BankStatementImportError",
    BankTransactionsMatchMultipleError = "BankTransactionsMatchMultipleError",
    ISIntegrationCredentialsExpired = "ISIntegrationCredentialsExpired",
    VatPayerRegistrationRequired = "VatPayerRegistrationRequired",
    VatPayerRegistrationRequiredImmediately = "VatPayerRegistrationRequiredImmediately",
    PrIllnessLeaveEvent14DaysPassed = "PrIllnessLeaveEvent14DaysPassed",
    GrantSettlementDeadlineIsComingUp = "GrantSettlementDeadlineIsComingUp",
    PayrollPeriodCloseError = "PayrollPeriodCloseError",
}

export enum NotificationTypeGroupCode {
    DataBox = "Databox",
    Inbox = "Inbox",
    CustomerPortal = "CustomerPortal",
    Bank = "Bank",
    Integration = "ISIntegration",
    System = "System",
    Chats = "Chats",
    SocialEvents = "PrSocialEvent",
    Grant = "Grant",
    Payroll = "Payroll",
}

export enum NumberRangeTypeCode {
    BankStatement = "BankStatement",
    MinorAsset = "MinorAsset",
    Asset = "Asset",
    CorrectiveInvoiceIssued = "CorrectiveInvoiceIssued",
    CorrectiveInvoiceReceived = "CorrectiveInvoiceReceived",
    InternalDocument = "InternalDocument",
    InvoiceIssued = "InvoiceIssued",
    InvoiceReceived = "InvoiceReceived",
    OtherLiability = "OtherLiability",
    OtherReceivable = "OtherReceivable",
    ProformaInvoiceIssued = "ProformaInvoiceIssued",
    ProformaInvoiceReceived = "ProformaInvoiceReceived",
    CashReceiptIssued = "CashReceiptIssued",
    CashReceiptReceived = "CashReceiptReceived",
    Employment = "PrEmployment",
    EmploymentTemplate = "PrEmploymentTemplate",
    SalaryAdvance = "PrSalaryAdvance",
    Employee = "PrEmployee",
    Deduction = "PrDeduction",
    TaxpayerDeclaration = "PrTaxpayerDeclaration",
    LoanStatement = "LoanStatement",
    PayrollSubmission = "PrSubmission",
    SocialEvent = "PrSocialEvent",
    AnnualTaxSettlementRequest = "PrAnnualTaxSettlementRequest",
    AnnualTaxSettlement = "PrAnnualTaxSettlement",
    Grant = "Grant",
}

export enum NumberRangeWildcardCode {
    DocumentsFiscalYear4Digits_UpTo2CharactersSuffix = "%FFFF%",
    DocumentsFiscalYear2Digits_UpTo2CharactersSuffix = "%FF%",
    DocumentsFiscalYear1Digit_UpTo2CharactersSuffix = "%F%",
    DocumentsFiscalPeriod3Digits = "%PPP%",
    CalendarYear4Digits = "%YYYY%",
    CalendarYear2Digits = "%YY%",
    CalendarYear1Digit = "%Y%",
    CalendarMonth2Digit = "%MM%",
}

export enum PayableReceivableTypeCode {
    Payable = "AP",
    Receivable = "AR",
    InternalDocument = "NO",
}

export enum PayerReliabilityStatusCode {
    Reliable = "Reliable",
    Unreliable = "Unreliable",
    Unknown = "Unknown",
}

export enum PaymentDocumentItemTypeCode {
    ExchangeGain = "ExchangeGain",
    ExchangeLoss = "ExchangeLoss",
    Other = "Other",
    Payment = "Payment",
}

export enum PaymentItemCode {
    InitPaymentCZK = "InitPaymentCZK",
    InitPaymentEUR = "InitPaymentEUR",
}

export enum PaymentMethodCode {
    WireTransfer = "Wire",
    Cash = "Cash",
    Card = "Card",
    PaymentService = "Srvc",
    Netting = "Nett",
    CashOnDelivery = "Deli",
}

export enum PaymentOrderFormatCode {
    CzechPayment = "Czech",
    NonSEPAPayment = "NonSepa",
    SepaPayment = "Sepa",
}

export enum PaymentOrderOutputCode {
    BankAPIDefault = "BankApi",
    BankFile = "BankFile",
    CustomerPortal = "CustomerPortal",
    MicrosoftExcel = "Excel",
}

export enum PaymentStatusCode {
    WaitsForProcessing = "WP",
    NeedsApproval = "NA",
    PartiallyProcessed = "PP",
    Processed = "PR",
}

export enum ActiveEmploymentPolicyToolCode {
    PublicWorks = "PublicWorks",
    ReservedSociallyUsefulJob = "ReservedSociallyUsefulJob",
    SharedJob = "SharedJob",
    OtherWageContributions = "OtherWageContributions",
}

export enum CollectiveAgreementTypeCode {
    None = "None",
    CompanyCollectiveAgreement = "Company",
    HigherlevelCollectiveAgreementBasedOnEmployerAssociationMembership = "HigherMembership",
    HigherlevelCollectiveAgreementBasedOnExtendedBindingEffectUnderSection7 = "HigherExtension",
    CollectiveArrangement = "Agreement",
    HigherlevelCollectiveArrangement = "HigherAgreement",
}

export enum CsszEmploymentTypeCode {
    FirstEmployment = "CSSZ_1",
    SecondConcurrentEmployment = "CSSZ_2",
    ThirdConcurrentEmployment = "CSSZ_3",
    FourthConcurrentEmployment = "CSSZ_4",
    FifthConcurrentEmployment = "CSSZ_5",
    SixthConcurrentEmployment = "CSSZ_6",
    SeventhConcurrentEmployment = "CSSZ_7",
    EighthConcurrentEmployment = "CSSZ_8",
    NinthAndNextConcurrentEmployment = "CSSZ_9",
    WorkAgreementDPC = "CSSZ_A",
    SecondConcurrentWorkAgreementDPC = "CSSZ_B",
    ThirdConcurrentWorkAgreementDPC = "CSSZ_C",
    FourthConcurrentWorkAgreementDPC = "CSSZ_D",
    FifthConcurrentWorkAgreementDPC = "CSSZ_E",
    SixthConcurrentWorkAgreementDPC = "CSSZ_F",
    SeventhConcurrentWorkAgreementDPC = "CSSZ_G",
    EighthConcurrentWorkAgreementDPC = "CSSZ_H",
    NinthConcurrentWorkAgreementDPC = "CSSZ_I",
    TenthAndNextConcurrentWorkAgreementDPC = "CSSZ_J",
    MemberOfAssociation = "CSSZ_O",
    Procurator = "CSSZ_P",
    MemberOfBoard = "CSSZ_Q",
    InsuranceAssessor = "CSSZ_R",
    Partner_Executive_LimitedPartner_DirectorOfALlc_AndPersonInChargeOfBusinessManagement = "CSSZ_S",
    WorkAgreementDPP = "CSSZ_T",
    SecondConcurrentWorkAgreementDPP = "CSSZ_U",
    ThirdConcurrentWorkAgreementDPP = "CSSZ_V",
    FourthConcurrentWorkAgreementDPP = "CSSZ_W",
    FifthConcurrentWorkAgreementDPP = "CSSZ_X",
    SixthConcurrentWorkAgreementDPP = "CSSZ_Y",
    SeventhConcurrentWorkAgreementDPP = "CSSZ_Z",
    EighthConcurrentWorkAgreementDPP = "CSSZ_ZA",
    NinthConcurrentWorkAgreementDPP = "CSSZ_ZB",
    TenthAndNextConcurrentWorkAgreementDPP = "CSSZ_ZC",
}

export enum DetailedEmploymentSpecificationCode {
    Imprisonment = "Imprisonment",
    None = "None",
    Specific = "Specific",
}

export enum EmploymentEarlyTerminationReasonCode {
    NoticeOrAgreementForReasonsListedInSection52aeOfTheLabourCode = "Section52AToE",
    ImmediateTerminationUnderSection56OfTheLabourCode = "Section56",
    OtherReason = "Other",
}

export enum EmploymentRelationshipTerminationReasonCode {
    ForeignerStateless = "ForeignerStateless",
    EmployerAgreement = "EmployerAgreement",
    EmployeeNotice = "EmployeeNotice",
    Organizational = "Organizational",
    HealthReasons = "HealthReasons",
    UnsuitableForWork = "UnsuitableForWork",
    GrossBreach = "GrossBreach",
    RepeatedMinorBreach = "RepeatedMinorBreach",
    SickRegimeBreach = "SickRegimeBreach",
    ConvictionImmediate = "ConvictionImmediate",
    EmployerBreach = "EmployerBreach",
    FixedTerm = "FixedTerm",
    ProbationEmployer = "ProbationEmployer",
    ProbationEmployee = "ProbationEmployee",
    Other = "Other",
}

export enum LaborOfficeEmploymentTypeCode {
    Employment = "Employment",
    ServiceAct234 = "ServiceAct234",
}

export enum MpsvFreeAccessToLaborMarketTypeCode {
    AcquiredEducation = "AcquiredEducation",
    ArtisticActivity = "ArtisticActivity",
    Clergy = "Clergy",
    ContinuousEducation = "ContinuousEducation",
    DiplomaticFamilyMember = "DiplomaticFamilyMember",
    EuCitizen = "EuCitizen",
    EuFamilyMember = "EuFamilyMember",
    EuResident = "EuResident",
    FutureProfessionPreparation = "FutureProfessionPreparation",
    GrantedAsylum = "GrantedAsylum",
    InternationalTreaty = "InternationalTreaty",
    LongTermResidenceFamily = "LongTermResidenceFamily",
    LongTermResidenceProtection = "LongTermResidenceProtection",
    PermanentResidentNonUa = "PermanentResidentNonUa",
    PermanentResidentUa = "PermanentResidentUa",
    ShortTermWork = "ShortTermWork",
    SkillEnhancement = "SkillEnhancement",
    TransferredEmployee = "TransferredEmployee",
    UkCitizen = "UkCitizen",
    WhitelistCountryCitizen = "WhitelistCountryCitizen",
    WorkInInterestOfCountry = "WorkInInterestOfCountry",
}

export enum MpsvTaxIdentifierTypeCode {
    TaxNumber = "D",
    Other = "J",
    PersonalIdentificationNumber = "R",
    SocialSecurityNumber = "S",
}

export enum NoUnemploymentSupportTypeCode {
    PensionOrNoInsurance = "PensionOrNoInsurance",
    SelectedEmployments = "SelectedEmployments",
}

export enum OwnershipFormTypeCode {
    FullyPubliclyOwned = "FullyPublic",
    FullyPrivatelyOrCooperativelyOwned = "FullyPrivateOrCooperative",
    SharedOwnershipWithMajorityPublicShare = "SharedMajorityPublic",
    MajorityOwnershipWithMajorityPrivateOrCooperativeShare = "MajorityPrivateOrCooperative",
}

export enum PrAbsenceCategoryOriginCode {
    Custom = "Custom",
    Legislative = "Legislative",
    System = "System",
}

export enum PrAbsenceCategorySubtypeCode {
    ExcludedEvent = "ExcludedEvent",
    Manual = "Manual",
    SocialEvent = "SocialEvent",
}

export enum PrAbsenceCategoryTypeCode {
    Custom = "Custom",
    SickDay = "CzSickDay",
    Dovolená = "CzVacation",
    NáhradníVolnoZaPřesčas = "CzCompensatoryTimeForOvertime",
    NáhradníVolnoZaSvátek = "CzCompensatoryTimeForHoliday",
    NeplacenéVolno = "CzUnpaidTimeOff",
    PracovníVolno = "CzPaidTimeLeave",
    NeomluvenáAbsence = "CzUnexcusedAbsence",
    PřekážkaNaStraněZaměstnavatele = "CzEmployerImpediment",
    PracovníVolnoČinnostVedoucíchTáborů = "CzPaidTimeOffSummerCamp",
    DPN = "CzIllness",
    OtcovskáDovolená = "CzPaternityLeave",
    MateřskáDovolená = "CzMaternityLeave",
    Ošetřovné = "CzFamilyMemberCare",
    DlouhodobéOšetřovné = "CzLongFamilyMemberCare",
    RodičovskáDovolená = "CzParentalLeave",
    Vazba = "CzCustody",
    VýkonTrestu = "CzImprisonment",
}

export enum PrAbsenceCompensationCode {
    Paid = "Paid",
    Special = "Special",
    Unpaid = "Unpaid",
}

export enum PrAccountingCategoryCode {
    AssociateCompensation = "AssociateCompensation",
    AssociateSalary = "AssociateSalary",
    Employee = "Employee",
}

export enum PrAccountingGroupSelectionCode {
    All = "ALL",
    PerEmployee = "EMP",
}

export enum PrAccountingItemGroupCode {
    HealthInsurance = "HealthIns",
    LegalInsurace = "Legal",
    SalaryAccounting = "Salary",
    SocialSecurity = "SocSec",
    PensionInsurance = "PensionIns",
    LifeInsurance = "LifeIns",
    DIP = "Dip",
    Deduction = "Deduction",
}

export enum PrAccountingItemTypeCode {
    StatutoryInsuranceForCompany = "StatutoryInsuranceCompany",
    MealVoucherUnderLimit = "BenefitMealVoucherU",
    MealVoucherOverLimit = "BenefitMealVoucherO",
    MealVoucherIssued = "BenefitMealVoucherEmIs",
    MealVoucherEmployee = "BenefitMealVoucherEmPs",
    LumpSumMealBenefitUnderLimit = "BenefitLumpSumMealU",
    LumpSumMealBenefitOverLimit = "BenefitLumpSumMealO",
    RemoteWorkBenefitUnderLimit = "BenefitRemoteWorkU",
    RemoteWorkBenefitOverLimit = "BenefitRemoteWorkO",
    OtherBenefitsTaxdeductible = "BenefitOtherDeducible",
    OtherBenefitsNotTaxdeductible = "BenefitOtherNotDeducible",
    PayablesToEmployees = "PayablesToEmployees",
    ReceivablesFromEmployees = "ReceivablesFromEmployees",
    PaidAdvancedSalary = "PaidAdvancedSalary",
    GrossSalary = "GrossSalary",
    TemporaryIncapacityCompensation = "Illness",
    OtherSalaryCosts = "OtherSalary",
    AdvanceTax = "AdvanceTax",
    WithholdingTax = "WithholdingTax",
    HealthInsuranceEmployer = "HealthInsuranceEmployer",
    HealthInsuranceEmployee = "HealthInsuranceEmployee",
    SocialSecurityEmployer = "SocialSecurityEmployer",
    SocialSecurityEmployee = "SocialSecurityEmployee",
    RetirementSavingsEmployer = "RetirementSavingsEmployer",
    Deduction = "Deduction",
}

export enum PrAnnualTaxItemTypeCode {
    CurrentEmployerIncome = "CzCurrentEmplIncome",
    CurrentEmployerPaidTax = "CzCurrentEmplPaidTax",
    CurrentEmployerReceivedTaxBonus = "CzCurrentEmplReceivedTaxBonus",
    OtherEmployersIncome = "CzOtherEmplIncome",
    OtherEmployersPaidTax = "CzOtherEmplPaidTax",
    OtherEmployersReceivedTaxBonus = "CzOtherEmplReceivedTaxBonus",
    SavingForRetirement = "CzSavingForRetirement",
    PensionInsurance = "CzPensionInsurance",
    LifeInsurance = "CzLifeInsurance",
    DIP = "CzDip",
    LongtermCareInsurance = "CzLongTermCareInsurance",
    SupplementaryPensionSavingsNew = "CzSupplementaryPensionSavingsNew",
    SupplementaryPensionSavingsOld = "CzSupplementaryPensionSavingsOld",
    ValueOfGifts = "CzValueOfGifts",
    InterestOnLoans = "CzInterestOnLoans",
    OtherNotMentionedAbove = "CzOtherNotMentionedAbove",
    NontaxableTotal = "CzNonTaxableTotal",
    TaxpayerDiscount = "CzDiscountTaxpayer",
    SpouseDiscount = "CzDiscountPartner",
    DisabilityI_AndII_Degree = "CzDiscountBasicDisability",
    DisabilityIII_Degree = "CzDiscountExtendedDisability",
    ZTP_PDiscount = "CzDiscountZtpP",
    DistrainmentDiscount = "CzForeclosureEndDiscount",
    DiscountTotal = "CzDiscountTotal",
    _1stChildAdvantage = "CzChildAdvantage1",
    NumberOfMonths1stChild = "CzChildMonths1",
    NumberOfMonthsOfZTP_P1stChild = "CzChildZtpP1",
    _2ndChildAdvantage = "CzAdvantageChild2",
    NumberOfMonths2ndChild = "CzChildMonths2",
    NumberOfMonthsOfZTP_P2ndChild = "CzChildZtpP2",
    _3rdChildAdvantage = "CzAdvantageChild3",
    NumberOfMonths3rdChild = "CzChildMonths3",
    NumberOfMonthsOfZTP_P3rdChild = "CzChildZtpP3",
    AdvantageTotal = "CzAdvantageTotal",
    CalculatedTaxBeforeDiscountsAndAdvantage = "CzCalculatedTaxBeforeDicsAndAdv",
    CalculatedTaxIncludingDiscountsAndAdvantagesWithoutBonus = "CzCalculatedTaxWithoutBonus",
    Overpayment_Underpayment = "CzCalculatedAndPaidDifference",
    Overpayment_UnderpaymentDoesNotApplyForTaxAdvantage = "CzCalculatedAndPaidDiffNoAdv",
    Overpayment_UnderpaymentAppliesForTaxAdvantage = "CzCalculatedAndPaidDiffWithAdv",
    TaxableIncomeTotal = "CzTaxableIncomeTotal",
    LoweredTaxableIncome = "CzLoweredTaxableIncome",
    PaidTax = "CzPaidTax",
    CalculatedTaxBeforeAdvantage = "CzCalculatedTaxBeforeAdv",
    AdvantageAsDiscount = "CzAdvantageAsDiscount",
    AdvantageAsBonus = "CzAdvantageAsBonus",
    ReceivedBonuses = "CzReceivedBonuses",
    DifferenceWithoutBonus = "CzWithoutBonusDifference",
    DifferenceWithoutBonusFinal = "CzWithoutBonusDiffFinal",
    BonusDifference = "CzBonusDifference",
}

export enum PrAnnualTaxSettlementRequestFormSectionDetailTypeCode {
    OtherPeopleForMortgage = "CzMortgageInterestOtherPeople2025",
    MortgageInterestLocations = "CzMortgageInterestLocations2025",
    PartnerTaxCredit = "CzPartnerTaxCredit2025",
    PartnerTaxCreditZTP = "CzPartnerTaxCreditZTP2025",
    ChildDeduction = "CzChildDeduction2025",
    ZTP = "CzZtp2025",
}

export enum PrAnnualTaxSettlementRequestFormSectionTypeCode {
    DIP = "CzDip2025",
    ForeclosureEndBonus = "CzForeclosureEnd2025",
    Gifts = "CzGifts2025",
    MortgageInterest = "CzMortgageInterest2025",
    LifeInsurance = "CzLifeInsurance2025",
    OtherEmployees = "CzOtherEmployments2025",
    PartnerTaxCredit = "CzPartnerTaxCredit2025",
    PensionInsurance = "CzPensionInsurance2025",
    LongtermCareInsurance = "CzLongTermCareInsurance2025",
    SupplementaryPensionSavingsNew = "CzSupplementaryPensionSavingsNew2025",
    SupplementaryPensionSavingsOld = "CzSupplementaryPensionSavingsOld2025",
}

export enum PrAnnualTaxSettlementRequestResultTypeCode {
    NotRequested = "NotRequested",
    Requested = "Requested",
    WaitingForDecision = "WaitingForDecision",
}

export enum PrAnnualTaxSettlementRequestStatusTypeCode {
    FormIsBeingFilled = "FormIsBeingFilled",
    IsVerified = "IsVerified",
    NotRequested = "NotRequested",
    ToBeVerified = "ToBeVerified",
    WaitingForDecision = "WaitingForDecision",
}

export enum PrAnnualTaxSettlementStatusCode {
    ToCheck = "ToCheck",
    Checked = "Checked",
    IncludedInPayslip = "IncludedInPayslip",
    PaidOut = "PaidOut",
}

export enum PrAttendanceStatusCode {
    Locked = "Locked",
    Processed = "Processed",
    ToProcess = "ToProcess",
}

export enum PrAttendanceStatusDisplayCode {
    Locked = "Locked",
    NoAttendance = "NoAttendance",
    Processed = "Processed",
    ToProcess = "ToProcess",
}

export enum PrBenefitTaxFreeLimitCode {
    Czech2023 = "Cz2023",
    Czech2024 = "Cz2024",
    Czech2025 = "Cz2025",
    Czech2026 = "Cz2026",
}

export enum PrBenefitTypeCode {
    LumpSumMealBenefit = "CzLumpSumMeal",
    MealVouchers = "CzMealVoucher",
    RemoteWorkBenefit = "CzRemoteWork",
    OtherBenefit = "CzOther",
}

export enum PrCaregivingTypeCode {
    CaringForASickPerson = "Care",
    TheFacilityAttendedByAChildUnder10YearsOldWasClosed = "ClosedSchool",
    QuarantineOfAChildUnder10YearsOld = "Quarantine",
    ThePersonWhoOtherwiseCaresForTheChildHasFallenIll = "SickCareGiver",
}

export enum PrChildDeductionOrderCode {
    _1stChild = "Cz1",
    _2ndChild = "Cz2",
    _3rdChild = "Cz3",
    NotApplied = "CzN",
}

export enum PrCollectionItemChangeTypeCode {
    Added = "Added",
    Deleted = "Deleted",
    Updated = "Updated",
}

export enum PrCzechReductionLimitCode {
    _20221st = "Cz2022_1",
    _20222nd = "Cz2022_2",
    _20223rd = "Cz2022_3",
    _2022Limit = "Cz2022_4",
    _20231st = "Cz2023_1",
    _20232nd = "Cz2023_2",
    _20233rd = "Cz2023_3",
    _2023Limit = "Cz2023_4",
    _20241st = "Cz2024_1",
    _20242nd = "Cz2024_2",
    _20243rd = "Cz2024_3",
    _2024Limit = "Cz2024_4",
    _20251st = "Cz2025_1",
    _20252nd = "Cz2025_2",
    _20253rd = "Cz2025_3",
    _2025Limit = "Cz2025_4",
    _20261st = "Cz2026_1",
    _20262nd = "Cz2026_2",
    _20263rd = "Cz2026_3",
    _2026Limit = "Cz2026_4",
}

export enum PrDisabilityDiscountAmountCode {
    BasicDisabilityDiscountFor2024 = "Cz2024Basic2024",
    ExtendedDisabilityDiscountFor2024 = "Cz2024Extended2024",
    DiscountForZTP_PHolderFor2024 = "Cz2024ZtpP2024",
}

export enum PrDisabilityTypeCode {
    I_Disability = "I",
    II_Disability = "II",
    III_Disability = "III",
    III_DisabilityAbilityToWorkOnlyUnderExceptionalConditions = "IIISpecial",
    GrantedOnlyStatusOfPWD = "OZZ",
}

export enum PrDistrainmentDepositClosingCode {
    KeepOnAccount = "Keep",
    TransferToDistrainer = "Transfer",
}

export enum PrEducationCode {
    WithoutEducation = "A",
    IncompleteEducation = "B",
    PrimaryEducation = "C",
    LowerSecondaryEducation = "D",
    LowerSecondaryVocationalEducation = "E",
    SecondaryVocationalEducationWithAnApprenticeshipCertificate = "H",
    SecondOrSecondaryVocationalEducationWithoutGraduationAndApprenticeshipCertificate = "J",
    CompleteSecondaryGeneralEducation = "K",
    CompleteSecondaryVocationalEducationWithTrainedAndGraduation = "L",
    CompleteSecondaryVocationalEducationWithGraduationWithoutApprenticeship = "M",
    HigherVocationalEducation = "N",
    HigherVocationalEducationAtTheConservatory = "P",
    UniversityBachelorEducation = "R",
    HigherEducation = "T",
    DoctoralEducation = "V",
    Irrelevant = "Z",
}

export enum PrEldpItemTypeCode {
    CSSZ_1 = "CSSZ_1",
    CSSZ_1D = "CSSZ_1D",
    CSSZ_1P = "CSSZ_1P",
    CSSZ_1V = "CSSZ_1V",
    CSSZ_2 = "CSSZ_2",
    CSSZ_2D = "CSSZ_2D",
    CSSZ_2P = "CSSZ_2P",
    CSSZ_2V = "CSSZ_2V",
    CSSZ_3 = "CSSZ_3",
    CSSZ_3D = "CSSZ_3D",
    CSSZ_3P = "CSSZ_3P",
    CSSZ_3V = "CSSZ_3V",
    CSSZ_4 = "CSSZ_4",
    CSSZ_4D = "CSSZ_4D",
    CSSZ_4P = "CSSZ_4P",
    CSSZ_4V = "CSSZ_4V",
    CSSZ_5 = "CSSZ_5",
    CSSZ_5D = "CSSZ_5D",
    CSSZ_5P = "CSSZ_5P",
    CSSZ_5V = "CSSZ_5V",
    CSSZ_6 = "CSSZ_6",
    CSSZ_6D = "CSSZ_6D",
    CSSZ_6P = "CSSZ_6P",
    CSSZ_6V = "CSSZ_6V",
    CSSZ_7 = "CSSZ_7",
    CSSZ_7D = "CSSZ_7D",
    CSSZ_7P = "CSSZ_7P",
    CSSZ_7V = "CSSZ_7V",
    CSSZ_8 = "CSSZ_8",
    CSSZ_8D = "CSSZ_8D",
    CSSZ_8P = "CSSZ_8P",
    CSSZ_8V = "CSSZ_8V",
    CSSZ_9 = "CSSZ_9",
    CSSZ_9D = "CSSZ_9D",
    CSSZ_9P = "CSSZ_9P",
    CSSZ_9V = "CSSZ_9V",
    CSSZ_A = "CSSZ_A",
    CSSZ_AD = "CSSZ_AD",
    CSSZ_AP = "CSSZ_AP",
    CSSZ_AV = "CSSZ_AV",
    CSSZ_B = "CSSZ_B",
    CSSZ_BD = "CSSZ_BD",
    CSSZ_BP = "CSSZ_BP",
    CSSZ_BV = "CSSZ_BV",
    CSSZ_C = "CSSZ_C",
    CSSZ_CD = "CSSZ_CD",
    CSSZ_CP = "CSSZ_CP",
    CSSZ_CV = "CSSZ_CV",
    CSSZ_D = "CSSZ_D",
    CSSZ_DD = "CSSZ_DD",
    CSSZ_DP = "CSSZ_DP",
    CSSZ_DV = "CSSZ_DV",
    CSSZ_E = "CSSZ_E",
    CSSZ_ED = "CSSZ_ED",
    CSSZ_EP = "CSSZ_EP",
    CSSZ_EV = "CSSZ_EV",
    CSSZ_F = "CSSZ_F",
    CSSZ_FD = "CSSZ_FD",
    CSSZ_FP = "CSSZ_FP",
    CSSZ_FV = "CSSZ_FV",
    CSSZ_G = "CSSZ_G",
    CSSZ_GD = "CSSZ_GD",
    CSSZ_GP = "CSSZ_GP",
    CSSZ_GV = "CSSZ_GV",
    CSSZ_H = "CSSZ_H",
    CSSZ_HD = "CSSZ_HD",
    CSSZ_HP = "CSSZ_HP",
    CSSZ_HV = "CSSZ_HV",
    CSSZ_I = "CSSZ_I",
    CSSZ_ID = "CSSZ_ID",
    CSSZ_IP = "CSSZ_IP",
    CSSZ_IV = "CSSZ_IV",
    CSSZ_J = "CSSZ_J",
    CSSZ_JD = "CSSZ_JD",
    CSSZ_JP = "CSSZ_JP",
    CSSZ_JV = "CSSZ_JV",
    CSSZ_O = "CSSZ_O",
    CSSZ_OD = "CSSZ_OD",
    CSSZ_OP = "CSSZ_OP",
    CSSZ_OV = "CSSZ_OV",
    CSSZ_P = "CSSZ_P",
    CSSZ_PD = "CSSZ_PD",
    CSSZ_PP = "CSSZ_PP",
    CSSZ_PV = "CSSZ_PV",
    CSSZ_Q = "CSSZ_Q",
    CSSZ_QD = "CSSZ_QD",
    CSSZ_QP = "CSSZ_QP",
    CSSZ_QV = "CSSZ_QV",
    CSSZ_R = "CSSZ_R",
    CSSZ_RD = "CSSZ_RD",
    CSSZ_RP = "CSSZ_RP",
    CSSZ_RV = "CSSZ_RV",
    CSSZ_S = "CSSZ_S",
    CSSZ_SD = "CSSZ_SD",
    CSSZ_SP = "CSSZ_SP",
    CSSZ_SV = "CSSZ_SV",
    CSSZ_T = "CSSZ_T",
    CSSZ_TD = "CSSZ_TD",
    CSSZ_TV = "CSSZ_TV",
    CSSZ_U = "CSSZ_U",
    CSSZ_UD = "CSSZ_UD",
    CSSZ_UV = "CSSZ_UV",
    CSSZ_V = "CSSZ_V",
    CSSZ_VD = "CSSZ_VD",
    CSSZ_VV = "CSSZ_VV",
    CSSZ_W = "CSSZ_W",
    CSSZ_WD = "CSSZ_WD",
    CSSZ_WV = "CSSZ_WV",
    CSSZ_X = "CSSZ_X",
    CSSZ_XD = "CSSZ_XD",
    CSSZ_XV = "CSSZ_XV",
    CSSZ_Y = "CSSZ_Y",
    CSSZ_YD = "CSSZ_YD",
    CSSZ_YV = "CSSZ_YV",
    CSSZ_Z = "CSSZ_Z",
    CSSZ_ZD = "CSSZ_ZD",
    CSSZ_ZV = "CSSZ_ZV",
    CSSZ_ZA = "CSSZ_ZA",
    CSSZ_ZAD = "CSSZ_ZAD",
    CSSZ_ZAV = "CSSZ_ZAV",
    CSSZ_ZB = "CSSZ_ZB",
    CSSZ_ZBD = "CSSZ_ZBD",
    CSSZ_ZBV = "CSSZ_ZBV",
    CSSZ_ZC = "CSSZ_ZC",
    CSSZ_ZCD = "CSSZ_ZCD",
    CSSZ_ZCV = "CSSZ_ZCV",
}

export enum PrEldpTypeCode {
    CurrentEmployment = "01",
    EmploymentTerminated = "02",
    EmploymentTerminatedByDeath = "03",
    CorrectionCurrentEmployment = "51",
    CorrectionEmploymentTerminated = "52",
    CorrectionEmploymentTerminatedByDeath = "53",
    ReconstructionCurrentEmployment = "91",
    ReconstructionEmploymentTerminated = "92",
    ReconstructionEmploymentTerminatedByDeath = "93",
}

export enum PrEmployeeCarTaxabilityCode {
    Cz_2025_025 = "Cz_2025_025",
    Cz_2025_05 = "Cz_2025_05",
    Cz_2025_1 = "Cz_2025_1",
}

export enum PrEmployeeDependentPersonRelationCode {
    Child = "Child",
    Other = "Other",
}

export enum PrEmployeeStateCode {
    Current = "Current",
    Former = "Former",
    Future = "Future",
    None = "None",
}

export enum PrEmploymentCategoryCode {
    Associate = "Associate",
    Employee = "Employee",
}

export enum PrEmploymentTypeCode {
    WorkAgreementDPC = "CzDpc",
    WorkAgreementDPP = "CzDpp",
    Employment = "Employment",
    Compensation = "Compensation",
}

export enum PrEmploymentWorkplaceAddressSelectionCode {
    CompanyDefault = "Default",
    Own = "Own",
}

export enum PrExtraSalaryComputationTypeCode {
    AbsoluteAmountHour = "HourlyAbsolute",
    AverageHourlySalaryPercentage = "HourlyPercentage",
    AbsoluteAmountShift = "ShiftAbsolute",
}

export enum PrExtraSalaryLegislativeValueCode {
    Holiday100 = "CzHoliday100",
    Overtime25 = "CzOvertime25",
    Weekend10 = "CzWeekend10",
    Emergency10 = "CzEmergency10",
    Night10 = "CzNight10",
    HarshWorkEnvironment5 = "CzHarshWorkEnvironment5",
}

export enum PrExtraSalaryOriginCode {
    Custom = "Custom",
    Legislative = "Legislative",
}

export enum PrExtraSalaryTypeCode {
    Custom = "Custom",
    Holiday = "Holiday",
    Night = "Night",
    Overtime = "Overtime",
    Weekend = "Weekend",
    Emergency = "Emergency",
    HarshWorkingEnvironment = "HarshWorkEnvironment",
}

export enum PrForeignInsuranceCarrierSectorTypeCode {
    All = "All",
    OccupationalInjuriesAndOccupationalDiseases = "EmplInjuries",
    FamilyBenefits = "FamBenefits",
    Other = "Other",
    Pensions = "Pensions",
    RecoveryAndOffsets = "Recovery",
    Sickness = "Sickness",
    UnemploymentBenefits = "Unemployment",
}

export enum PrForeignInsuranceCarrierTypeCode {
    Current = "Current",
    Previous = "Past",
    None = "None",
}

export enum PrFormOfStudyTypeCode {
    Combined = "Combined",
    FullTime = "FullTime",
}

export enum PrHealthInsuranceCompanyBankAccountCode {
    CZ_CPZP = "CZ_CPZP",
    CZ_OZP = "CZ_OZP",
    CZ_RBP = "CZ_RBP",
    CZ_VZP_01 = "CZ_VZP_01",
    CZ_VZP_02 = "CZ_VZP_02",
    CZ_VZP_03 = "CZ_VZP_03",
    CZ_VZP_04 = "CZ_VZP_04",
    CZ_VZP_05 = "CZ_VZP_05",
    CZ_VZP_06 = "CZ_VZP_06",
    CZ_VZP_07 = "CZ_VZP_07",
    CZ_VZP_08 = "CZ_VZP_08",
    CZ_VZP_09 = "CZ_VZP_09",
    CZ_VZP_10 = "CZ_VZP_10",
    CZ_VZP_11 = "CZ_VZP_11",
    CZ_VZP_12 = "CZ_VZP_12",
    CZ_VZP_13 = "CZ_VZP_13",
    CZ_VZP_14 = "CZ_VZP_14",
    CZ_VOZP = "CZ_VOZP",
    CZ_ZPS = "CZ_ZPS",
    CZ_ZPMV = "CZ_ZPMV",
}

export enum PrHealthInsuranceCompanyCode {
    ČeskáPrůmyslováZdravotníPojišťovna = "CZ_CPZP",
    OborováZdravotníPojišťovna = "CZ_OZP",
    RevírníBratrskáPokladna = "CZ_RBP",
    VšeobecnáZdravotníPojišťovna = "CZ_VZP",
    VojenskáZdravotníPojišťovna = "CZ_VOZP",
    ZaměstnaneckáPojišťovnaŠKODA = "CZ_ZPS",
    ZdravotníPojišťovnaMinisterstvaVnitra = "CZ_ZPMV",
}

export enum PrHolidayPayoutTypeCode {
    PayOutAsCompensation = "PayOutAsCompensation",
    IncludeInSalary = "IncludeInSalary",
}

export enum PrHolidayShiftAssignmentCode {
    SplitByMidnight = "MidnightSplit",
    ByShiftEnd = "ByShiftEnd",
    ByShiftStart = "ByShiftStart",
}

export enum PrHozChangeCodeCode {
    EUCitizenCommencementWithInsuranceNumber = "A",
    NonEUForeignCitizenFirstRegistration = "C",
    PensionGranted = "D",
    EUCitizenFirstRegistration = "E",
    DependentChildStatusEnd = "F",
    DependentChildCommencement = "G",
    PensionRevoked = "H",
    JobSeekerCommencement = "I",
    JobSeekerRegistrationEnd = "J",
    PostEmploymentSickPayEnd = "K",
    CaregiverCategoryStart = "L",
    MaternityLeaveStart = "M",
    PostEmploymentSickPayStart = "N",
    EmploymentTermination = "O",
    EmploymentCommencement = "P",
    SingleDayEmployment = "Q",
    SupplementaryPensionEnd = "R",
    SupplementaryPensionStart = "S",
    CaregiverCategoryEnd = "T",
    MaternityLeaveEnd = "U",
    CivilServantPartnerDeregistration = "V",
    CivilServantPartnerRegistration = "W",
    InsuranceNumberCorrection = "X",
    RegistrationDateCorrection = "Y",
    DeregistrationDateCorrection = "Z",
}

export enum PrIdentifierCode {
    DateOfBirth = "DateOfBirth",
    PersonalIdentificationNumber = "PersonalIdentificationNumber",
}

export enum PrIdentityDocumentTypeCode {
    IDCard = "IdCard",
    Passport = "Passport",
    Other = "Other",
}

export enum PrIncomeTaxDiscountCode {
    CzechSince2022 = "Cz2022",
}

export enum PrInsolvencyDepositClosingCode {
    KeepOnAccount = "Keep",
    TransferToInsolvencyAdministrator = "Transfer",
}

export enum PrJmhzFormTypeCode {
    Regular = "Regular",
    Correction = "Correction",
    Cancellation = "Cancellation",
}

export enum PrLegislativeAverageSalaryCode {
    CzechRepublic2023 = "Cz_2023",
    CzechRepublic2024 = "Cz_2024",
    CzechRepublic2025 = "Cz_2025",
    CzechRepublic2026 = "Cz_2026",
}

export enum PrLegislativePayrollConstantCode {
    Czech2023 = "Cz2023",
    Czech2024 = "Cz2024",
    Czech2025 = "Cz2025",
    Czech2026 = "Cz2026",
}

export enum PrLegislativeYouthEventCompensationHourlyLimitCode {
    Czech2024 = "Cz2024",
    Czech2025 = "Cz2025",
    Czech2026 = "Cz2026",
}

export enum PrMaternityLeaveEntitlementCode {
    GivingBirth = "GivingBirth",
    Agreement = "Agreement",
    Illness = "Illness",
    AuthorityDecision = "AuthorityDecision",
    DeceasedMother = "DeceasedMother",
}

export enum PrMinimumHealthInsuranceBaseCode {
    NormalMinimumHealthInsuranceBaseFor2024 = "Cz2024Normal",
    ReducedMinimumHealthInsuranceBaseFor2024 = "Cz2024Reduced",
    NormalMinimumHealthInsuranceBaseFor2025 = "Cz2025Normal",
    ReducedMinimumHealthInsuranceBaseFor2025 = "Cz2025Reduced",
    NormalMinimumHealthInsuranceBaseFor2026 = "Cz2026Normal",
    ReducedMinimumHealthInsuranceBaseFor2026 = "Cz2026Reduced",
}

export enum PrMinimumHealthInsuranceTypeCode {
    Normal = "CzNormal",
    RealIncome = "CzRealIncome",
    Reduced = "CzReduced",
}

export enum PrMpsvFamilyRelationCode {
    OtherRelationship = "JIN",
    SpouseOfTheInsuredPerson = "MA",
    RelativeInDirectLine = "PL",
    RegisteredPartner = "RP",
    OtherIndividualsInTheSameHousehold = "SDO",
    SiblingOfInsuredPerson = "SO",
    ParentOfTheSpouseOrRegisteredPartner = "TCH",
}

export enum PrMpsvRelationCode {
    Spouse = "Spouse",
    Father_Mother = "Parent",
    Son_Daugther = "Child",
    Brother_Sister = "Sibling",
    SpouseOfBrother_sister = "SiblingsSpouse",
    PartnerOfBrother_sister = "SiblingsPartner",
    Grandparent = "GrandParent",
    Grandchild = "GrandChild",
    Fatherinlaw_Motherinlaw = "SpousesParent",
    Soninlaw_Daughterinlaw = "ChildsSpouse",
    Nephew_Niece = "Nephew",
    Uncle_Aunt = "Uncle",
    SpouseOfFather_mother = "ParentsSpouse",
    RegisteredPartnerOfSon_daughter = "ChildsRegisteredPartner",
    SpouseOfGrandparent = "GrandParentsSpouse",
    SpouseOfGrandchild = "GrandChildsSpouse",
    SpouseOfFatherinlaw_motherinlaw = "SpousesParentsSpouse",
    SpouseOfNephew_niece = "NephewsSpouse",
    SpouseOfUncle_aunt = "UnclesSpouse",
    PartnerOfFather_mother = "ParentsPartner",
    PartnerOfSon_daughter = "ChildsPartner",
    RegisteredPartnerOfGrandparent = "GrandParentsPartner",
    PartnerOfGrandchild = "GrandChildsPartner",
    PartnerOfFatherinlaw_motherinlaw = "SpousesParentsPartner",
    PartnerOfNephew_niece = "NephewsPartner",
    PartnerOfUncle_aunt = "UnclesPartner",
    PartnerOfCareReceiver = "CareReceiverPartner",
    OtherPersonSharingHousehold = "PersonSharingHousehold",
    OtherRelationship = "Other",
}

export enum PrOtherBenefitCategoryCode {
    Financial = "Financial",
    Nonfinancial = "NonFinancial",
}

export enum PrOtherBenefitTaxAndContributionsApplicabilityCode {
    FullyExempt = "FullyExempt",
    ExemptToLimitOfAvg_Salary = "HigherLimit",
    ExemptToLimitOf1_2Avg_Salary = "LowerLimit",
    NotExempt = "NotExempt",
}

export enum PrOtherBenefitTaxDeducibilityCode {
    Deducible = "Deducible",
    Nondeducible = "NonDeducible",
    NondeducibleUpToLimit = "PartlyDeducible",
}

export enum PrPaternityLeaveEntitlementCode {
    Father = "Father",
    Adoption = "Adoption",
    Deceased = "Deceased",
}

export enum PrPayrollPeriodStatusCode {
    Processed = "Processed",
    ProcessedAndClosed = "ProcessedAndClosed",
    ToProcess = "ToProcess",
}

export enum PrPayrollSubstitutePayDayCode {
    FollowingWorkingDay = "Following",
    PreviousWorkingDay = "Previous",
}

export enum PrPayslipEmploymentItemTypeCode {
    SalaryForHoursWorked = "CzSalaryWorked",
    PlannedWorkHours = "CzPlannedWorkHours",
    HoursWorked = "CzWorkedHours",
    RollingAverageOfWeeklyWorkedHours = "CzDpcRollingAvgWeeklyHours",
    HolidayCompensation = "CzHolidayCompensation",
    DaysWorked = "CzWorkedDays",
    SalaryPercentageBonus = "CzSalaryBonusPercentage",
    SalaryBonus = "CzSalaryBonusTimeBased",
    SeverancePay = "CzSalarySeverancePay",
    CompensationForLossOfMedicalFitnessSect_271ca = "CzSalaryMedicalLossCompensation",
    RetirementBenefit = "CzSalaryRetirementBenefit",
    TerminationSettlement = "CzSalaryTerminationSettlement",
    OtherSalaryFullyTaxed = "CzSalaryOtherFullyTaxed",
    OtherSalaryIncomeTaxOnly = "CzSalaryOtherIncTaxOnly",
    OtherSalaryIncomeTaxOnlyTotal = "CzSalaryIncTaxOnlyTotal",
    SalaryInKindFullyTaxed = "CzSalaryInKindFullyTaxed",
    SalaryInKindFullyTaxedTotal = "CzSalaryInKindFullyTaxedTotal",
    SalaryInKindIncomeTaxOnly = "CzSalaryInKindIncTaxOnly",
    SalaryInKindIncomeTaxOnlyTotal = "CzSalaryInKindIncTaxOnlyTotal",
    PaidAbsences = "CzAbsencePaidTotal",
    UnpaidAbsences = "CzAbsenceUnpaidTotal",
    Vacation = "CzVacation",
    IllnessPaid = "CzIllnessPaid",
    IllnessUnpaid = "CzIllnessUnpaid",
    PaidTimeOffSummerCamp = "CzPaidTimeOffSummerCamp",
    SickDay = "CzSickDay",
    LegislativeAbsencePaid = "CzLegislAbsencePaid",
    LegislativeAbsenceUnpaid = "CzLegislAbsenceUnpaid",
    CustomAbsencePaid = "CzCustomAbsencePaid",
    CustomAbsenceUnpaid = "CzCustomAbsenceUnpaid",
    AverageSalary = "CzAverageSalary",
    Overtime = "CzExtraSalaryOvertime",
    Night = "CzExtraSalaryNight",
    Weekend = "CzExtraSalaryWeekend",
    Emergency = "CzExtraSalaryEmergency",
    HarshWorkingEnvironment = "CzExtraSalaryHarshWorkEnvironment",
    Holiday = "CzExtraSalaryHoliday",
    ExtraSalaryHourly = "CzExtraSalaryCustHourAbs",
    ExtraSalaryHourlyPercentage = "CzExtraSalaryCustHourPerc",
    ExtraSalaryShift = "CzExtraSalaryCustShiftAbs",
    ExtraSalaryTotal = "CzExtraSalaryTotal",
    ExtraSalaryTotalWithoutEmergency = "CzExtraSalaryNoEmergencyTotal",
    GrossSalaryEmployment = "CzGrossSalaryTotal",
    MonthlyCompensation = "CzMonthlyCompensation",
    FinancialIncomeFullyTaxed = "CzFinancialIncomeFullyTaxed",
    CompanyCarForPrivateUse = "CzEmployeeCar",
    SocialAndHealthInsuranceIncomeBaseWithoutRetirementSaving = "CzInsuranceIncomeBaseNoRetirement",
    IncomeSubjectToSocialInsurance = "CzSocialInsuranceIncomeBase",
    IncomeSubjectToHealthInsurance = "CzHealthInsuranceIncomeBase",
    BasisForSocialInsuranceCalculation = "CzSocialInsuranceCalcBase",
    SocialInsurancePaidByEmployee = "CzSocialInsurancePaidByEmployee",
    SocialInsurancePaidByEmployer = "CzSocialInsurancePaidByEmployer",
    SocialInsuranceTotal = "CzSocialInsuranceTotal",
    BasisForHealthInsuranceCalculation = "CzHealthInsuranceCalcBase",
    BasisForAdvanceIncomeTaxCalculation = "CzAdvanceIncomeTaxCalcBase",
    BasisForWithholdingIncomeTaxCalculation = "CzWithholdingIncomeTaxCalcBase",
    MealVouchers = "CzBenefitMealVouchers",
    MealVouchersUnderLimit = "CzBenefitMealVouchersU",
    MealVouchersOverLimit = "CzBenefitMealVouchersO",
    MealVouchersEmployee = "CzBenefitMealVouchersE",
    LumpSumMealBenefit = "CzBenefitLumpSumMeal",
    LumpSumMealBenefitUnderLimit = "CzBenefitLumpSumMealU",
    LumpSumMealBenefitOverLimit = "CzBenefitLumpSumMealO",
    MealBenefitsUnderLimit = "CzBenefitMealU",
    MealBenefitsOverLimit = "CzBenefitMealO",
    RemoteWorkBenefit = "CzBenefitRemoteWork",
    RemoteWorkBenefitUnderLimit = "CzBenefitRemoteWorkU",
    RemoteWorkBenefitOverLimit = "CzBenefitRemoteWorkO",
    OtherBenefit = "CzBenefitOther",
    BenefitsFullyExempt = "CzBenefitFullyExempt",
    BenefitsExemptToLimitOf1_2Avg_Salary = "CzBenefitPartlyExemptL",
    BenefitsExemptToLimitOfAvg_Salary = "CzBenefitPartlyExemptH",
    BenefitsOverLimit = "CzBenefitOverLimit",
    BenefitsNotExempt = "CzBenefitNotExempt",
    OtherBenefitsTaxdeducible = "CzBenefitDeducible",
    OtherBenefitsNotTaxdeducible = "CzBenefitNotDeducible",
    FinancialBenefitsNotTaxed = "CzBenefitFinancialNotTaxed",
    FinancialBenefitsTaxed = "CzBenefitFinancialTaxed",
    NonfinancialBenefits = "CzBenefitNonFinancial",
    BenefitsTotal = "CzBenefitTotal",
    PensionRetirementSaving = "CzPensionInsurance",
    LifeRetirementSaving = "CzLifeInsurance",
    DIPBenefit = "CzDip",
    LongtermCareInsurance = "CzLongTermCareInsurance",
    SupplementaryPensionSavingsNew = "CzSupplementaryPensionSavingsNew",
    SupplementaryPensionSavingsOld = "CzSupplementaryPensionSavingsOld",
    SavingForRetirementTotal = "CzSavingForRetiremTotal",
    TaxfreeSavingForRetirementTotal = "CzSavingForRetiremNoTaxTotal",
    TaxableSavingForRetirementTotal = "CzSavingForRetiremTaxableTotal",
}

export enum PrPayslipEmploymentSubitemTypeCode {
    CzSalaryWorkedBase = "CzSalaryWorkedBase",
    CzVacationEntitlement = "CzVacationEntitlement",
    CzVacationPreviouslyUsed = "CzVacationPreviouslyUsed",
    CzSickDayEntitlement = "CzSickDayEntitlement",
    CzSickDayPreviouslyUsed = "CzSickDayPreviouslyUsed",
    CzBenefitMealVoAmount = "CzBenefitMealVoAmount",
    CzBenefitMealVoEmplr = "CzBenefitMealVoEmplr",
    CzBenefitMealVoDays = "CzBenefitMealVoDays",
    CzBenefitMealLSEmplr = "CzBenefitMealLSEmplr",
    CzBenefitMealLSDays = "CzBenefitMealLSDays",
    CzBenefitRemoteWorkA = "CzBenefitRemoteWorkA",
    CzBenefitRemoteWorkH = "CzBenefitRemoteWorkH",
    CzBenefitOtherCategory = "CzBenefitOtherCategory",
    CzBenefitOtherLimit = "CzBenefitOtherLimit",
    CzOvertimeValue = "CzOvertimeValue",
    CzNightValue = "CzNightValue",
    CzWeekendValue = "CzWeekendValue",
    CzHolidayValue = "CzHolidayValue",
    CzEmergencyValue = "CzEmergencyValue",
    CzHarshWorkEnvValue = "CzHarshWorkEnvValue",
    CzCustHourAbsValue = "CzCustHourAbsValue",
    CzCustHourPercValue = "CzCustHourPercValue",
    CzCustShiftAbsValue = "CzCustShiftAbsValue",
    CzSalaryWorkedValidFrom = "CzSalaryWorkedValidFrom",
    CzSalaryWorkedValidTo = "CzSalaryWorkedValidTo",
    CzRetiremGrossSalaryPerc = "CzRetiremGrossSalaryPerc",
    CzRetiremSocInsBasisPerc = "CzRetiremSocInsBasisPerc",
    CzSocialInsuranceEligibility = "CzSocialInsuranceEligibility",
    CzSocialInsEmployeePerc = "CzSocialInsEmployeePerc",
    CzSocialInsEmployeeRetireeDiscPerc = "CzSocialInsEmployeeRetireeDiscPerc",
    CzSocialInsEmployeeRetireeDiscAmount = "CzSocialInsEmployeeRetireeDiscAmount",
    CzSocialInsEmployerPerc = "CzSocialInsEmployerPerc",
    CzSocialInsEmployerDiscountPerc = "CzSocialInsEmployerDiscountPerc",
    CzSocialInsEmployerDiscountAmount = "CzSocialInsEmployerDiscountAmount",
    CzSocialInsEmployerDiscountCode = "CzSocialInsEmployerDiscountCode",
    CzPaidTimeOffSummerCampHourlyCompensation = "CzPaidTimeOffSummerCampHourlyCompensation",
}

export enum PrPayslipItemTypeCode {
    GrossSalary = "CzGrossSalary",
    BenefitsTotal = "CzBenefitsTotal",
    TaxdeductibleBenefitsTotal = "CzBenefitsNoTaxTotal",
    TaxableBenefitsTotal = "CzBenefitsTaxableTotal",
    TaxableIncomeTotal = "CzTaxableIncomeTotal",
    AdvanceIncomeTaxCalculationBasis = "CzAdvanceIncomeTaxCalcBasis",
    WithholdingIncomeTaxCalculationBasis = "CzIncomeTaxWithholdingCalcBasis",
    AdvanceIncomeTaxCalculationBasisRounded = "CzAdvanceIncomeTaxCalcBasisRound",
    AdvanceIncomeTaxBeforeAdvantages = "CzAdvanceIncomeTaxGross",
    IncomeTaxReduction = "CzIncomeTaxReduction",
    IncomeTaxAdvantages = "CzIncomeTaxAdvantage",
    IncomeTaxNet = "CzIncomeTaxNetAdvance",
    WithholdingTax = "CzIncomeTaxNetWithholding",
    IncomeTaxBonus = "CzIncomeTaxBonus",
    AnnualIncomeTaxSettlement = "CzAnnualIncomeTaxSettlement",
    BasisForHealthInsuranceCalculation = "CzHealthInsuranceCalcBase",
    HealthInsurancePaidByEmployee = "CzHealthInsuranceEmployee",
    HealthInsurancePaidByEmployer = "CzHealthInsuranceEmployer",
    HealthInsuranceMinimumSurchargePaidByEmployee = "CzHealthInsuranceSurchargeEmployee",
    HealthInsuranceMinimumSurchargePaidByEmployer = "CzHealthInsuranceSurchargeEmployer",
    HealthInsuranceTotal = "CzHealthInsuranceTotal",
    BasisForSocialInsuranceCalculation = "CzSocialInsuranceCalcBase",
    SocialInsurancePaidByEmployee = "CzSocialInsuranceEmployee",
    SocialInsurancePaidByEmployer = "CzSocialInsuranceEmployer",
    SocialInsuranceTotal = "CzSocialInsuranceTotal",
    NetSalary = "CzNetSalary",
    NetIncome = "CzNetIncome",
    FinancialBenefitsTotal = "CzBenefitFinancialTotal",
    EmergencyTotal = "CzExtraSalaryEmergencyTotal",
    FinancialComponentsSubjectOnlyToIncomeTax = "CzFinancialTaxOnlyTotal",
    NonfinancialIncomeTotal = "CzNonFinancialIncomeTotal",
    DeductionCalculationBasis = "CzDeductionCalcBasis",
    CustomDeduction = "CzCustomDeduction",
    CourtOrderedDeduction = "CzCourtOrderedDeduction",
    OwedRegularChildSupport = "CzUnpaidRegularChildSupport",
    UndeductedTotal = "CzUnpaidRegularChildSupportTotal",
    InsolvencyAdministratorReward = "CzInsolvencyRewardDeduction",
    OwnDeduction = "CzOwnDeduction",
    DeductionTotal = "CzDeductionTotal",
    Liabilities = "CzLiabilities",
    LiabilitiesTotal = "CzLiabilitiesTotal",
    Receivables = "CzReceivables",
    ReceivablesTotal = "CzReceivablesTotal",
    SalaryAdvance = "CzSalaryAdvanceSubtr",
    SalaryAdvanceTotal = "CzSalaryAdvanceTotal",
    MealVoucherEmployeeDeduction = "CzMealVoucherDeduction",
    RemoteWorkBenefit = "CzRemoteWorkTotal",
    LumpSumMealBenefit = "CzLumpSumMealTotal",
    Illness = "CzIllnessTotal",
    AmountToPayEmployee = "CzAmountToPayEmployee",
}

export enum PrPayslipSubitemTypeCode {
    HealthInsuranceEmployeePercentage = "CzHealthInsEmployeePerc",
    HealthInsuranceEmployerPercentage = "CzHealthInsEmployerPerc",
    IncomeTaxDiscountCode = "CzIncomeTaxReductionCode",
    IllnessOfEmployment = "CzIllnessEmployment",
}

export enum PrPropertyAcquisitionCode {
    From20210101 = "From2021",
    Until20201231 = "Until2020",
}

export enum PrRegularSalaryTypeCode {
    Hourly = "Hourly",
    Monthly = "Monthly",
}

export enum PrRelevantIncomeCode {
    RelevantIncomeSince2018 = "CZ_2018",
    RelevantIncomeSince2019 = "CZ_2019",
    RelevantIncomeSince2021 = "CZ_2021",
    RelevantIncomeSince2023 = "CZ_2023",
    RelevantIncomeSince2025 = "CZ_2025",
    RelevantIncomeSince2026 = "CZ_2026",
}

export enum PrRetirementSavingsComputationTypeCode {
    FixedAmount = "FixedAmount",
    MandatoryContribution = "MandatoryContribution",
    PercentageOfBasicSalary = "BasicSalaryPercentage",
    PercentageOfGrossSalary = "GrossSalaryPercentage",
    PercentageOfSocialInsuranceBasis = "SocialInsuranceBasisPercentage",
}

export enum PrRetirementSavingsTypeCode {
    LongtermInvestmentProduct = "Dip",
    LifeInsurance = "LifeInsurance",
    LongtermCareInsurance = "LongTermCareInsurance",
    PensionInsurance = "PensionInsurance",
    SupplementaryPensionSavingsNew = "SupplementaryPensionSavingsNew",
    SupplementaryPensionSavingsOld = "SupplementaryPensionSavingsOld",
}

export enum PrSalaryComponentTypeCode {
    Regular = "Regular",
    TimeBasedBonus = "TimeBasedBonus",
    PercentageBonus = "PercentageBonus",
    Fixed = "Fixed",
    SeverancePay = "SeverancePay",
    MedicalLossCompensation = "MedicalLossCompensation",
    RetirementBenefit = "RetirementBenefit",
    TerminationSettlement = "TerminationSettlement",
}

export enum PrSexCode {
    Female = "Female",
    Male = "Male",
}

export enum PrSocialEventMonthDetailTypeCode {
    OnlyInSelectedDays = "Selection",
    WholeTimeOfAbsence = "Whole",
}

export enum PrSocialEventRequiredActionCode {
    SubmitHZUPN = "SubmitHzupn",
    SubmitNEMPRI = "SubmitNempri",
}

export enum PrSocialEventStatusCode {
    Cancelled = "Cancelled",
    Completed = "Completed",
    Ongoing = "Ongoing",
}

export enum PrSocialEventTypeCode {
    CaregivingAllowance = "Care",
    LongtermCaregivingAllowance = "LongCare",
    MaternityLeave = "Maternity",
    PaternityLeave = "Paternity",
    IllnessLeave = "Illness",
    ParentalLeave = "Parental",
    Custody = "Custody",
    Imprisonment = "Imprison",
}

export enum PrSocialInsuranceDiscountIneligibilityReasonCode {
    DiscountReasonIsNotSetOnEmployee = "DiscountReasonMissing",
    HourlyWageIsTooHigh = "HourlyWageTooHigh",
    MonthlyWageIsTooHigh = "MonthlyWageTooHigh",
    NoHoursWorked = "NoWorkedHours",
    TooManyHoursWorkedInMonthExceeded138 = "TooManyHoursWorked",
    WeeklyWorkingHoursAreTooLowLessThan8Hours = "WorkloadTooLow",
    WeeklyWorkingHoursAreTooHighMoreThan30Hours = "WorkloadTooHigh",
    EmployeeIsNotUnder21ForTheEntireMonth = "Under21AgeNotMet",
    EmployeeIsNotAtLeast55ForTheEntireMonth = "Over55AgeNotMet",
}

export enum PrSocialInsuranceDiscountTypeCode {
    CareForDependentUnder10 = "CareForDependentUnder10",
    CareForAChildUnder10 = "ChildCareUnder10",
    HealthDisability = "HealthDisability",
    AgeOver55Years = "Over55Years",
    RetrainingInLast12Months = "RetrainingLast12Months",
    Student = "Student",
    AgeUnder21Years = "Under21Years",
}

export enum PrSocialInsuranceRateCode {
    CzechFrom1_1_2023 = "Cz2023_1",
    CzechFrom1_2_2023 = "Cz2023_2",
    CzechFrom1_1_2024 = "Cz2024_1",
    CzechFrom1_1_2025 = "Cz2025_1",
}

export enum PrSplitShiftAssignmentTypeCode {
    NextMonth = "NextMonth",
    ThisMonth = "ThisMonth",
}

export enum PrSubmissionStatusCode {
    Error = "Error",
    NotSubmitted = "NotSubmitted",
    Processing = "Processing",
    Rejected = "Rejected",
    Submitted = "Submitted",
}

export enum PrSubmissionSubtypeCode {
    NempriLongTermCaregiving = "NempriLongTermCaregiving",
    NempriIllnessLeave = "NempriIllnessLeave",
    NempriPaternityLeave = "NempriPaternityLeave",
    NempriCaregiving = "NempriCaregiving",
    NempriMaternityLeave = "NempriMaternityLeave",
    OzuspojRegistration = "OzuspojRegistration",
    OzuspojTermination = "OzuspojTermination",
    OzuspojCancellation = "OzuspojCancellation",
    RegZecStart = "RegZecStart",
    RegZecTermination = "RegZecTermination",
    RegZecChange = "RegZecChange",
    RegZecCorrection = "RegZecCorrection",
    RegZecCzechOriginStart = "RegZecCzechOriginStart",
    RegZecCzechOriginEnd = "RegZecCzechOriginEnd",
    RegZecCancellation = "RegZecCancellation",
    JmhzRegular = "JmhzRegular",
    JmhzCorrection = "JmhzCorrection",
    JmhzCancellation = "JmhzCancellation",
    PppzRegular = "PppzRegular",
    PppzCorrective = "PppzCorrective",
}

export enum PrSubmissionTypeCode {
    PensionInsuranceRecord = "Eldp",
    MonthlyReport = "Jmhz",
    EmployersNotificationOfAnEmployeesBenefitApplication = "Nempri",
    EmployerDiscountOnSocialInsurance = "Ozuspoj",
    EmployersMassHealthInsuranceNotification = "Hoz",
    ReportingByTheEmployerUponTerminationOfIncapacityForWork = "Hzupn",
    EmployeeRegistration = "RegZec",
    EmployersHealthInsurancePaymentOverview = "Pppz",
}

export enum PrSubmissionValidationStatusCode {
    NotValidated = "NotValidated",
    Valid = "Valid",
    Invalid = "Invalid",
    InProgress = "InProgress",
    Failed = "Failed",
}

export enum PrTaxDiscountTypeCode {
    TaxPayerDiscount = "CzPayer2024",
    BasicDisabilityDiscount = "CzDisBasic2024",
    ExtendedDisabilityDiscount = "CzDisExtended2024",
    DiscountForZTP_PHolder = "CzDisZtpP2024",
}

export enum PrTaxpayerDeclarationStatusCode {
    Draft = "Draft",
    WaitingForSignature = "WaitingForSignature",
    Signed = "Signed",
    Ended = "Ended",
    N_A = "None",
}

export enum PrTimeBasedBonusTypeCode {
    Halfyearly = "HalfYearly",
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    Annual = "Yearly",
}

export enum PrUnseizableAmountCode {
    From1_1_2022 = "Cz2022_1",
    From1_4_2022 = "Cz2022_4",
    From1_7_2022 = "Cz2022_7",
    From1_10_2022 = "Cz2022_10",
    From1_1_2023 = "Cz2023_1",
    From1_1_2024 = "Cz2024_1",
    From1_1_2025 = "Cz2025_1",
    From1_1_2026 = "Cz2026_1",
}

export enum PrVacationEntitlementCode {
    CzechSince2023 = "Cz2023",
}

export enum PrVacationEntitlementInclusionCode {
    Full = "Full",
    None = "None",
    Partial = "Partial",
}

export enum PrWorkPermitTypeCode {
    WorkPermit = "WorkPermit",
    EmployeeCard = "EmployeeCard",
    CardForAnIntracompanyEmployeeTransfer = "TransferCard",
    BlueCard = "BlueCard",
}

export enum PrWorkingPatternTypeCode {
    Uneven = "Uneven",
    Rotation = "Rotation",
    Weekly = "Weekly",
}

export enum PrYearOperationSectionTypeCode {
    AnnualTaxStatement = "AnnualTaxStatement",
    PayrollSheetsProcessing = "PayrollSheetsProcessing",
    TaxpayerDeclaration = "TaxpayerDeclaration",
}

export enum RiskCategoryCode {
    WorkClassifiedInCategory4 = "Category4Work",
    EmergencyMedicalRescuerWork = "EmergencyMedicalRescuerWork",
    CompanyFireRescueUnitMemberWork = "CompanyFireRescueUnitMemberWork",
}

export enum ServiceRelationshipTerminationReasonCode {
    FixedTerm = "FixedTerm",
    Section72ACToE = "Section72ACToE",
    RequestOrAgreement = "RequestOrAgreement",
    Section74 = "Section74",
    Other = "Other",
    Section72B = "Section72B",
}

export enum ShiftPatternCode {
    NA = "NA",
    Single = "Single",
    Two = "Two",
    Multi = "Multi",
}

export enum SpecificLegalFactTypeCode {
    DeathOfTheDecedentSection239b4OfTheTaxCode = "DecedentDeath",
    DissolutionOfALegalEntityWithoutLiquidationSection240aOfTheTaxCode = "LegalEntityNoLiquidation",
    EntryOfALegalEntityIntoLiquidationSection240c2OfTheTaxCode = "LegalEntityLiquidation",
    PreparationOfProposalForUseOfLiquidationBalanceSection240c3OfTheTaxCode = "LiquidationBalanceProposal",
    CessationOfObligationToRemitTaxCollectedByWithholdingBeforeEndOfCalendarYearSection234OfTheTaxCode = "WithholdingTaxEnd",
    EndOfEstateProceedingsSection239b5OfTheTaxCode = "EstateProceedingEnd",
    SubmissionOfRegularReportOnMonetizationOfLiquidationEstateAssetsOrPartThereofToCourtSection239cOfTheTaxCode = "LiquidationMonetizationReport",
    EffectOfInsolvencyDecisionSection2441OfTheTaxCode = "InsolvencyDecisionEffect",
    SubmissionOfFinalReportSection2443And4OfTheTaxCode = "FinalReportSubmission",
    TransferOfPartOfPrivatizedAssetsOfAStateEnterpriseSection240dOfTheTaxCode = "StateEnterpriseAssetTransfer",
    EndOfTrustFundAdministrationSection240e2OfTheTaxCodeEffectiveFrom1July2025 = "TrustAdministrationEnd",
    TerminationOfTrustFundSection240e3OfTheTaxCodeEffectiveFrom1July2025 = "TrustFundTermination",
}

export enum WorkplaceTypeCode {
    OnPrem = "OnPrem",
    Customer = "Customer",
    Residence = "Residence",
    Else = "Else",
}

export enum PeriodDayCode {
    FirstDay = "First",
    LastDay = "Last",
}

export enum PostedStatusCode {
    Posted = "P",
    NotPosted = "N",
    N_A = "_",
}

export enum PostingRuleDocumentTypeCode {
    ReceivedDocuments = "AP",
    IssuedDocuments = "AR",
    InvoiceReceived = "InvoiceReceived",
    InvoiceIssued = "InvoiceIssued",
    ProformaInvoiceReceived = "ProformaInvoiceReceived",
    ProformaInvoiceIssued = "ProformaInvoiceIssued",
    OtherLiability = "OtherLiability",
    OtherReceivable = "OtherReceivable",
    CorrectiveInvoiceReceived = "CorrectiveInvoiceReceived",
    CorrectiveInvoiceIssued = "CorrectiveInvoiceIssued",
}

export enum PostingRuleOperatorCode {
    Equal = "EQ",
    NotEqual = "NE",
    GreaterThan = "GT",
    GreaterThanOrEqual = "GE",
    LessThan = "LT",
    LessThanOrEqual = "LE",
    Between = "BETWEEN",
    Contains = "CONTAINS",
}

export enum PrCSSZPaymentMethodCode {
    CashPayment = "Cash",
    PaymentToAddress = "Delivery",
    PaymentToAccountAbroad = "WireTransferAbroad",
    PaymentToAccountInTheCzechRepublic = "WireTransferCZ",
}

export enum PrChildSupportDeductionTypeCode {
    Owed = "Owed",
    Regular = "Regular",
    Substitute = "Substitute",
    Assigned = "Assigned",
}

export enum PrDeductionCalculationTypeCode {
    Fixed = "Fixed",
    PercentageFromGrossSalary = "PercentageGross",
    PercentageFromNetSalary = "PercentageNet",
}

export enum PrDeductionEntityTypeCode {
    Group = "Group",
    Individual = "Individual",
}

export enum PrDeductionStatusCode {
    Deposited = "Deposited",
    Finished = "Finished",
    Ongoing = "Ongoing",
    Planned = "Planned",
    Suspended = "Suspended",
}

export enum PrDeductionTypeCode {
    ChildSupport = "ChildSupport",
    Custom = "Custom",
    Distrainment = "Distrainment",
    DistrainmentDeposit = "DistrainmentDeposit",
    Insolvency = "Insolvency",
    InsolvencyDeposit = "InsolvencyDeposit",
    InsolvencyAdministratorReward = "InsolvencyReward",
}

export enum PrDistrainmentDeductionTypeCode {
    Standard = "Standard",
    Priority = "Priority",
}

export enum PrEntityValueSourceCode {
    Default = "D",
    Entity = "E",
}

export enum PrFixedBonusDeductionImpactCode {
    Included = "Included",
    NotIncluded = "NotIncluded",
}

export enum PrFixedBonusPayOutImpactCode {
    InKind = "InKind",
    ToPayOut = "ToPayOut",
}

export enum PrFixedBonusTaxImpactCode {
    Full = "Full",
    IncomeTaxOnly = "IncomeTaxOnly",
}

export enum PrPensionTypeCode {
    ForeignOfAnOldageNature = "ForeignOldAge",
    ForeignOfTheNatureOfAFullDisability = "ForeignFullDisability",
    ForeignOfTheNatureOfPartialDisability = "ForeignPartialDisability",
    DisabilityDueToDisabilityOfTheFirstOrSecondDegree = "FirstOrSecondDegree",
    DisabilityDueToDisabilityOfTheThirdDegree = "ThirdDegree",
    DoesNotReceive = "DoesNotReceive",
    OldAge = "OldAge",
}

export enum PrPeriodDocumentTypeCode {
    SalaryExpenses = "SalaryExpenses",
    SalaryToPayToEmployee = "SalaryToPayEmployee",
    SocialSecurity = "SocialSecurity",
    HealthInsurance = "HealthInsurance",
    AdvancedTax = "AdvancedTax",
    WithholdingTax = "WithholdingTax",
    RetirementSaving = "RetirementSaving",
    Deduction = "Deduction",
    StatutoryInsurance = "StatutoryInsurance",
}

export enum PrSalaryComponentAverageInclusionCode {
    Exclude = "Exclude",
    Include = "Include",
}

export enum PrSubsequentMaternityLeaveStatusCode {
    NotStarting = "NotStarting",
    Starting = "Starting",
}

export enum PrTaxpayerDeclarationTypeCode {
    Regular = "Regular",
    Yearly = "Yearly",
}

export enum PrValueTypeCode {
    Amount = "Amount",
    AmountPerHour = "AmountPerHour",
    Days = "Days",
    Months = "Months",
    Minutes = "Minutes",
    Hours = "Hours",
    Count = "Count",
    Percentage = "Percentage",
    Code = "CodeString",
    Date = "Date",
}

export enum PrWorkIntervalTypeCode {
    CompensationForHoliday = "HolidayNotWorked",
    MealBreak = "MealBreak",
    Work = "Work",
}

export enum PrWorkingPatternIntervalTypeCode {
    MealBreak = "MealBreak",
    Work = "Work",
}

export enum ProductCode {
    EvalaDemo = "Demo",
    EvalaForAccountants = "Acc",
    EvalaForCompanies = "Comp",
}

export enum PurchaseStatusCode {
    NotPurchased = "NotPurchased",
    Purchased = "Purchased",
}

export enum ReceivableAdjustmentGroupCode {
    SmallReceivableAdjustment = "CzSmall",
    LargeReceivableAdjustment = "CzLarge",
    InsolvencyReceivableAdjustment = "CzInsolvency",
    CancelReceivableAdjustment = "CzCancel",
    WriteOffReceivableAdjustment = "CzWriteOff",
}

export enum ReceivableAdjustmentTypeCode {
    ReceivableAdjustmentPer8cZORUnder30Thousand = "CZ_8c",
    ReceivableAdjustmentPer8aZOR50 = "CZ_8a_50",
    ReceivableAdjustmentPer8aZOR100 = "CZ_8a_100",
    ReceivableAdjustmentPer8ZORInsolvency = "CZ_8_Insolvency",
    ReceivableAdjustmentCancellationPer8ZOR = "CZ_8_Cancel",
    TaxWriteOff = "CZ_WriteOff_Tax",
    NontaxWriteOff = "CZ_WriteOff_NonTax",
}

export enum RecurrentPaymentStateCode {
    Paid = "Paid",
    Created = "Created",
    Failed = "Failed",
    OverTheCardLimit = "OverLimit",
}

export enum RecurringTaskIntervalCode {
    ToDate = "DATE",
    First = "FIRST",
    Fourth = "FOURTH",
    Last = "LAST",
    Second = "SECOND",
    Third = "THIRD",
}

export enum RecurringTaskPeriodCode {
    Daily = "D",
    Monthly = "M",
    Weekly = "W",
    Yearly = "Y",
}

export enum RecurringTaskStateCode {
    Active = "A",
    Blocked = "B",
    Paused = "P",
}

export enum RecurringTaskTypeCode {
    InvoiceIssued = "InvoiceIssued",
    InvoiceReceived = "InvoiceReceived",
    ProformaInvoiceIssued = "ProformaInvoiceIssued",
}

export enum ReportSectionTypeCode {
    BS_A = "BS_A",
    BS_L = "BS_L",
    BS_S = "BS_S",
    IS_N_I = "IS_N_I",
    IS_N_E = "IS_N_E",
    IS_N_S = "IS_N_S",
    IS_F_I = "IS_F_I",
    IS_F_E = "IS_F_E",
    IS_F_S = "IS_F_S",
}

export enum ReportTypeCode {
    BalanceSheet = "BS",
    IncomeStatementNatureOfExpense = "IS_N",
    IncomeStatementFunctionOfExpense = "IS_F",
}

export enum RequiredAccountTypeCode {
    ReceivableAdjustment = "ReceivableAdjustment",
    VatAccount = "VatAccount",
    VatOSSAccount = "VatOssAccount",
}

export enum RossumJobStatusCode {
    Done = "Done",
    Running = "Running",
    Canceled = "Canceled",
    Expired = "Expired",
}

export enum SelectionCode {
    None = "None",
    Default = "Default",
    Own = "Own",
    Copy = "Copy",
    Split = "Split",
}

export enum SignatoryPersonCode {
    _4aGeneralAttorneyIndividualAndLegalPerson = "4a",
    _4bIndividual_TaxAdvisorOrAttorney = "4b",
    _4cLegalEntityProvidingTaxConsultancy = "4c",
}

export enum SubscriptionContactTypeCode {
    Billing = "Billing",
    Technical = "Technical",
}

export enum SubscriptionStatusCode {
    Active = "Active",
    Cancelled = "Cancelled",
    Expired = "Expired",
    AwaitsRenewal = "AwaitsRenewal",
    AwaitsConfirmation = "AwaitsConfirm",
}

export enum SubscriptionTypeCode {
    Free = "Free",
    Standard = "Standard",
    EDU = "Edu",
}

export enum TaxApplicabilityCode {
    TaxApplicable = "Applicable",
    NotTaxApplicable = "NotApplicable",
}

export enum TaxCalendarTaxTypeCode {
    Biofuel = "Biofuel",
    CRS = "Crs",
    DAC6 = "Dac6",
    Ecotax = "Ecotax",
    ExciseTax = "Excise",
    ForeignAccountTaxComplianceAct = "Fatca",
    GamblingTax = "Gambling",
    IncomeTax = "Income",
    LandValueTax = "LandValue",
    ValueaddedTax = "ValueAdded",
    VehicleExciseDuty = "Vehicle",
    WindfallTax = "Windfall",
    DAC7 = "Dac7",
    ExcludedFromNotificationDuty = "ExclNote",
    TopupTax = "TopUp",
}

export enum TaxDepreciationCategoryCode {
    C1_CZ_93 = "C1_CZ_93",
    C1_CZ_05 = "C1_CZ_05",
    C1a_CZ = "C1a_CZ",
    C2_CZ_93 = "C2_CZ_93",
    C2_CZ_99 = "C2_CZ_99",
    C2_CZ_05 = "C2_CZ_05",
    C3_CZ_93 = "C3_CZ_93",
    C3_CZ_99 = "C3_CZ_99",
    C3_CZ_05 = "C3_CZ_05",
    C4_CZ_93 = "C4_CZ_93",
    C4_CZ_99 = "C4_CZ_99",
    C5_CZ_93 = "C5_CZ_93",
    C5_CZ_95 = "C5_CZ_95",
    C5_CZ_99 = "C5_CZ_99",
    C6_CZ_04 = "C6_CZ_04",
    C1cv_CZ_20 = "C1cv_CZ_20",
    C2cv_CZ_20 = "C2cv_CZ_20",
    C30_CZ_20 = "C30_CZ_20",
    C2cv_CZ_24 = "C2cv_CZ_24",
    C30b_CZ_20 = "C30b_CZ_20",
}

export enum TaxPriceLimitCode {
    C2_CZ_05_M1_24 = "C2_CZ_05_M1_24",
    C2cv_CZ_24_M1_24 = "C2cv_CZ_24_M1_24",
}

export enum TaxStatementSubmitterCode {
    Accountant = "Accountant",
    Customer = "Customer",
    TaxAdvisor = "TaxAdvisor",
}

export enum TimeFormatCode {
    Hh_mm = "HoursMinutes24Clock",
    H_mm = "HoursMinutes24ClockNoLeadingZero",
    Hh_mm_ss = "HoursMinutesSeconds24Clock",
    Hh_mm_ssAM_PM = "HoursMinutesSecondsDesignator12Clock",
    Hh_mmAM_PM = "HoursMinutesDesignator12Clock",
}

export enum TimeZoneCode {
    UTC_1CentralEuropeanTime_Amsterdam = "Europe/Amsterdam",
    UTC_1CentralEuropeanTime_Andorra = "Europe/Andorra",
    UTC_2EasternEuropeanTime_Athens = "Europe/Athens",
    UTC_0GreenwichMeanTime_Belfast = "Europe/Belfast",
    UTC_1CentralEuropeanTime_Belgrade = "Europe/Belgrade",
    UTC_1CentralEuropeanTime_Berlin = "Europe/Berlin",
    UTC_1CentralEuropeanTime_Bratislava = "Europe/Bratislava",
    UTC_1CentralEuropeanTime_Brussels = "Europe/Brussels",
    UTC_2EasternEuropeanTime_Bucharest = "Europe/Bucharest",
    UTC_1CentralEuropeanTime_Budapest = "Europe/Budapest",
    UTC_1CentralEuropeanTime_Busingen = "Europe/Busingen",
    UTC_2EasternEuropeanTime_Chisinau = "Europe/Chisinau",
    UTC_1CentralEuropeanTime_Copenhagen = "Europe/Copenhagen",
    UTC_0GreenwichMeanTime_Dublin = "Europe/Dublin",
    UTC_1CentralEuropeanTime_Gibraltar = "Europe/Gibraltar",
    UTC_0GreenwichMeanTime_Guernsey = "Europe/Guernsey",
    UTC_2EasternEuropeanTime_Helsinki = "Europe/Helsinki",
    UTC_0GreenwichMeanTime_IsleOfMan = "Europe/Isle_of_Man",
    UTC_3Turkey_Istanbul = "Europe/Istanbul",
    UTC_0GreenwichMeanTime_Jersey = "Europe/Jersey",
    UTC_3MoscowStandardTime_Kaliningrad = "Europe/Kaliningrad",
    UTC_2EasternEuropeanTime_Kiev = "Europe/Kiev",
    UTC_0WesternEuropeanTime_Lisbon = "Europe/Lisbon",
    UTC_1CentralEuropeanTime_Ljubljana = "Europe/Ljubljana",
    UTC_0GreenwichMeanTime_London = "Europe/London",
    UTC_1CentralEuropeanTime_Luxembourg = "Europe/Luxembourg",
    UTC_1CentralEuropeanTime_Madrid = "Europe/Madrid",
    UTC_1CentralEuropeanTime_Malta = "Europe/Malta",
    UTC_2EasternEuropeanTime_Mariehamn = "Europe/Mariehamn",
    UTC_3BelarusStandardTime_Minsk = "Europe/Minsk",
    UTC_1CentralEuropeanTime_Monaco = "Europe/Monaco",
    UTC_3MoscowStandardTime_Moscow = "Europe/Moscow",
    UTC_2EasternEuropeanTime_Nicosia = "Europe/Nicosia",
    UTC_1CentralEuropeanTime_Oslo = "Europe/Oslo",
    UTC_1CentralEuropeanTime_Paris = "Europe/Paris",
    UTC_1CentralEuropeanTime_Podgorica = "Europe/Podgorica",
    UTC_1CentralEuropeanTime_Prague = "Europe/Prague",
    UTC_2EasternEuropeanTime_Riga = "Europe/Riga",
    UTC_1CentralEuropeanTime_Rome = "Europe/Rome",
    UTC_4Samara = "Europe/Samara",
    UTC_1CentralEuropeanTime_SanMarino = "Europe/San_Marino",
    UTC_1CentralEuropeanTime_Sarajevo = "Europe/Sarajevo",
    UTC_3MoscowStandardTime_Simferopol = "Europe/Simferopol",
    UTC_1CentralEuropeanTime_Skopje = "Europe/Skopje",
    UTC_2EasternEuropeanTime_Sofia = "Europe/Sofia",
    UTC_1CentralEuropeanTime_Stockholm = "Europe/Stockholm",
    UTC_2EasternEuropeanTime_Tallinn = "Europe/Tallinn",
    UTC_1CentralEuropeanTime_Tirane = "Europe/Tirane",
    UTC_2EasternEuropeanTime_Uzhgorod = "Europe/Uzhgorod",
    UTC_1CentralEuropeanTime_Vaduz = "Europe/Vaduz",
    UTC_1CentralEuropeanTime_Vatican = "Europe/Vatican",
    UTC_1CentralEuropeanTime_Vienna = "Europe/Vienna",
    UTC_2EasternEuropeanTime_Vilnius = "Europe/Vilnius",
    UTC_4Volgograd = "Europe/Volgograd",
    UTC_1CentralEuropeanTime_Warsaw = "Europe/Warsaw",
    UTC_1CentralEuropeanTime_Zagreb = "Europe/Zagreb",
    UTC_2EasternEuropeanTime_Zaporozhye = "Europe/Zaporozhye",
    UTC_1CentralEuropeanTime_Zurich = "Europe/Zurich",
}

export enum TypeOfBusinessCode {
    LegalPerson = "LP",
    NaturalPerson = "NP",
}

export enum UnitOfMeasureCode {
    Set = "SET",
    Centimeter = "CM",
    Gram = "GRAM",
    Kilogram = "KILO",
    Piece = "PIECE",
    Liter = "LITER",
    Meter = "METER",
    Pallet = "PAL",
    Tonne = "TONNE",
    Hour = "HOUR",
    Minute = "MINUTE",
    Day = "DAY",
    None = "NONE",
    Kilometer = "KM",
}

export enum UserStatusCode {
    Invited = "INV",
    Active = "ACT",
    Inactive = "IAC",
    Deleted = "DEL",
    WaitingForAcceptanceOfNewRole = "RAP",
}

export enum VariantAccessTypeCode {
    SystemVariant = "System",
    GlobalVariant = "Global",
    UserVariant = "User",
}

export enum VariantTypeCode {
    FormVariant = "Form",
    TableVariant = "Table",
}

export enum VatCode {
    CzStd2012 = "CzStd2012",
    CzRdc2012 = "CzRdc2012",
    CzStd2013 = "CzStd2013",
    Cz1Rdc2013 = "Cz1Rdc2013",
    Cz2Rdc2015 = "Cz2Rdc2015",
    CzRdc2024 = "CzRdc2024",
    SkStd2004 = "SkStd2004",
    Sk1Rdc2007 = "Sk1Rdc2007",
    Sk2Rdc2010 = "Sk2Rdc2010",
    SkStd2011 = "SkStd2011",
    SkRdc2011 = "SkRdc2011",
    SkStd2025 = "SkStd2025",
    Sk1Rdc2025 = "Sk1Rdc2025",
    Sk2Rdc2025 = "Sk2Rdc2025",
    AtStd2024 = "AtStd2024",
    At1Rdc2024 = "At1Rdc2024",
    At2Rdc2024 = "At2Rdc2024",
    BeStd2024 = "BeStd2024",
    Be1Rdc2024 = "Be1Rdc2024",
    Be2Rdc2024 = "Be2Rdc2024",
    BgStd2024 = "BgStd2024",
    BgRdc2024 = "BgRdc2024",
    CyStd2024 = "CyStd2024",
    Cy1Rdc2024 = "Cy1Rdc2024",
    Cy2Rdc2024 = "Cy2Rdc2024",
    DeStd2024 = "DeStd2024",
    DeRdc2024 = "DeRdc2024",
    DkStd2024 = "DkStd2024",
    EeStd2024 = "EeStd2024",
    EeStd2025 = "EeStd2025",
    EeRdc2024 = "EeRdc2024",
    GrStd2024 = "GrStd2024",
    Gr1Rdc2024 = "Gr1Rdc2024",
    Gr2Rdc2024 = "Gr2Rdc2024",
    EsStd2024 = "EsStd2024",
    EsRdc2024 = "EsRdc2024",
    FiStd2024 = "FiStd2024",
    Fi1Rdc2024 = "Fi1Rdc2024",
    Fi2Rdc2024 = "Fi2Rdc2024",
    FrStd2024 = "FrStd2024",
    Fr1Rdc2024 = "Fr1Rdc2024",
    Fr2Rdc2024 = "Fr2Rdc2024",
    HrStd2024 = "HrStd2024",
    Hr1Rdc2024 = "Hr1Rdc2024",
    Hr2Rdc2024 = "Hr2Rdc2024",
    HuStd2024 = "HuStd2024",
    Hu1Rdc2024 = "Hu1Rdc2024",
    Hu2Rdc2024 = "Hu2Rdc2024",
    IeStd2024 = "IeStd2024",
    Ie1Rdc2024 = "Ie1Rdc2024",
    Ie2Rdc2024 = "Ie2Rdc2024",
    ItStd2024 = "ItStd2024",
    It1Rdc2024 = "It1Rdc2024",
    It2Rdc2024 = "It2Rdc2024",
    LtStd2024 = "LtStd2024",
    Lt1Rdc2024 = "Lt1Rdc2024",
    Lt2Rdc2024 = "Lt2Rdc2024",
    LuStd2024 = "LuStd2024",
    LuRdc2024 = "LuRdc2024",
    LvStd2024 = "LvStd2024",
    Lv1Rdc2024 = "Lv1Rdc2024",
    Lv2Rdc2024 = "Lv2Rdc2024",
    MtStd2024 = "MtStd2024",
    Mt1Rdc2024 = "Mt1Rdc2024",
    Mt2Rdc2024 = "Mt2Rdc2024",
    NlStd2024 = "NlStd2024",
    NlRdc2024 = "NlRdc2024",
    PlStd2024 = "PlStd2024",
    Pl1Rdc2024 = "Pl1Rdc2024",
    Pl2Rdc2024 = "Pl2Rdc2024",
    PtStd2024 = "PtStd2024",
    Pt1Rdc2024 = "Pt1Rdc2024",
    Pt2Rdc2024 = "Pt2Rdc2024",
    RoStd2024 = "RoStd2024",
    Ro1Rdc2024 = "Ro1Rdc2024",
    Ro2Rdc2024 = "Ro2Rdc2024",
    RoStd2025 = "RoStd2025",
    RoRdc2025 = "RoRdc2025",
    SeStd2024 = "SeStd2024",
    Se1Rdc2024 = "Se1Rdc2024",
    Se2Rdc2024 = "Se2Rdc2024",
    SiStd2024 = "SiStd2024",
    Si1Rdc2024 = "Si1Rdc2024",
    Si2Rdc2024 = "Si2Rdc2024",
}

export enum VatCanceledStatusCode {
    Canceled = "Canceled",
    Reapplied = "Reapplied",
}

export enum VatControlStatementCode {
    KontrolníHlášeníDPHPlatnéOd1_1_2016 = "CZ_2016",
}

export enum VatControlStatementSectionCode {
    A_1 = "CZ_2016_A1",
    A_2 = "CZ_2016_A2",
    A_3 = "CZ_2016_A3",
    A_4 = "CZ_2016_A4",
    A_4_A_5 = "CZ_2016_A4_A5",
    A_5 = "CZ_2016_A5",
    B_1 = "CZ_2016_B1",
    B_2 = "CZ_2016_B2",
    B_2_B_3 = "CZ_2016_B2_B3",
    B_3 = "CZ_2016_B3",
    CZ_2016_N = "CZ_2016_N",
}

export enum VatDeductionTypeCode {
    Proportional = "Proportional",
    Reduced = "Reduced",
    ReducedAndProportional = "ReducedAndProportional",
}

export enum VatOssCode {
    ElektronickáSlužba = "Services",
    ZbožíNaDálku = "Goods",
}

export enum VatPayerRegistrationActionCode {
    NotRequired = "NotRequired",
    Required = "Required",
    RequiredImmediately = "RequiredImmediately",
}

export enum VatPayerRegistrationLimitCode {
    Required = "Required2025",
    RequiredImmediately = "RequiredImmediately2025",
}

export enum VatRateTypeCode {
    Standard = "Std",
    FirstReduced = "1Rdc",
    SecondReduced = "2Rdc",
}

export enum VatReverseChargeCode {
    Ano = "Yes",
    Ne = "No",
    Zlato = "1",
    Zlato_ZprostředkováníDodáníInvestičníhoZlata = "1a",
    DodáníNemovitéVěci = "3",
    DodáníNemovitéVěciVNucenémProdeji = "3a",
    StavebníAMontážníPráce = "4",
    StavebníAMontážníPráce_PoskytnutíPracovníků = "4a",
    ZbožíUvedenéVPřílozeČ_5 = "5",
    DodáníZbožíPoskytnutéhoPůvodněJakoZáruka = "6",
    DodáníZbožíPoPostoupeníVýhradyVlastnictví = "7",
    PovolenkyNaEmiseSkleníkovýchPlynů = "11",
    ObilovinyATechnickéPlodiny = "12",
    Kovy = "13",
    MobilníTelefony = "14",
    IntegrovanéObvody = "15",
    PřenosnáZařízeníProAutomatizovanéZpracováníDat = "16",
    VideoherníKonzole = "17",
    DodáníCertifikátůElektřiny = "18",
    DodáníElektřinySoustavamiNeboSítěmiObchodníkovi = "19",
    DodáníPlynuSoustavamiNeboSítěmiObchodníkovi = "20",
    PoskytnutíVymezenýchSlužebElektronickýchKomunikací = "21",
}

export enum VatStatementCode {
    PřiznáníKDaniZPřidanéHodnotyPlatnéOd1_1_2011 = "CZ_2011",
}

export enum VatStatementFrequencyCode {
    Monthly = "Monthly",
    Quarterly = "Quarterly",
}

export enum VatStatementSectionCode {
    CZ_2011_3_4 = "CZ_2011_3_4",
    CZ_2011_5_6 = "CZ_2011_5_6",
    CZ_2011_12_13 = "CZ_2011_12_13",
    CZ_2011_9 = "CZ_2011_9",
    CZ_2011_7_8 = "CZ_2011_7_8",
    CZ_2011_10_11 = "CZ_2011_10_11",
    CZ_2011_40_41 = "CZ_2011_40_41",
    CZ_2011_34 = "CZ_2011_34",
    CZ_2011_42 = "CZ_2011_42",
    CZ_2011_61 = "CZ_2011_61",
    CZ_2011_30 = "CZ_2011_30",
    CZ_2011_47 = "CZ_2011_47",
    CZ_2011_32 = "CZ_2011_32",
    CZ_2011_1_2 = "CZ_2011_1_2",
    CZ_2011_20 = "CZ_2011_20",
    CZ_2011_22 = "CZ_2011_22",
    CZ_2011_23 = "CZ_2011_23",
    CZ_2011_24 = "CZ_2011_24",
    CZ_2011_26 = "CZ_2011_26",
    CZ_2011_50 = "CZ_2011_50",
    CZ_2011_61D = "CZ_2011_61D",
    CZ_2011_31 = "CZ_2011_31",
    CZ_2011_21 = "CZ_2011_21",
    CZ_2011_25 = "CZ_2011_25",
    CZ_2011_3_4_IP = "CZ_2011_3_4_IP",
    CZ_2011_5_6_IP = "CZ_2011_5_6_IP",
    CZ_2011_12_13_IP = "CZ_2011_12_13_IP",
}

export enum VatStatementSectionCategoryCode {
    DocumentReceivedInReverseChargeMode = "DocRcvdRCh",
    DocumentReceivedInAutomatedVATInclusionMode = "DocRcvdAvim",
    DocumentReceivedInAutomatedVATInclusionModeIdentifiedPerson = "DocRcvdAvimIp",
    DocumentReceived = "DocRcvd",
    DocumentIssued = "DocIssd",
    InternalVATStatementSection = "Internal",
}

export enum VatStatementStatusCode {
    Filed = "F",
    FiledAndModified = "M",
    PartiallyFiled = "P",
    NotFiled = "N",
    N_A = "_",
    Undefined = "U",
    Cancelled = "C",
    Reapplied = "R",
}

export enum VatStatusCode {
    VATRegistered = "VatRegistered",
    NotVATRegistered = "NotVatRegistered",
    IdentifiedPerson = "IdentifiedPerson",
}

export enum VatViesCode {
    Kód0 = "0",
    Kód1 = "1",
    Kód2 = "2",
    Kód3 = "3",
    N = "N",
}

export enum WebSocketMessageTypeCode {
    Notification = "Notification",
    SessionInvalidated = "SessionInvalidated",
    CompanyUpdated = "CompanyUpdated",
    PayrollPeriodUpdated = "PrPeriodUpdated",
    SessionTerminated = "SessionTerminated",
    BackgroundJob = "BackgroundJob",
    ActionProgress = "ActionProgress",
    Login = "Login",
    System = "System",
}

export enum WriteOffTypeCode {
    No = "None",
    Nottax = "NotTax",
    Tax = "Tax",
}

export enum YesNoCode {
    No = "N",
    Yes = "Y",
}

